<template>
  <div class="c-content-static-data-security">
    <h1 v-if="isPage">Datenschutzerklärung (Stand Juli 2026)</h1>
    <h2 v-else class="grandline">Datenschutzerklärung (Stand Juli 2026)</h2>
    <div
      style="
        background-color: rgba(255, 255, 255, 0);
        background-repeat: no-repeat;
        background-position-x: center;
        background-position-y: center;
        background-size: auto;
      "
    >
      <div>
        <p>
          Nachfolgende Datenschutzerklärung informiert Sie über die Grundsätze, nach denen
          die expert e-Commerce GmbH mit Ihren Daten umgeht. Diese Datenschutzerklärung
          betrifft dabei die Erhebung, Verarbeitung und Nutzung von personenbezogenen
          Daten. Hierunter sind alle Informationen zu verstehen, die sich auf eine
          identifizierte oder identifizierbare natürliche Person beziehen.
        </p>
        <p>
          Verantwortlich für die Datenverarbeitung ist die expert e-Commerce GmbH
          ("expert"),<br />erreichbar unter:
        </p>
        <p>
          Bayernstr. 4<br />D- 30855 Langenhagen<br />Telefon: 0511 / 7808-0<br />E-Mail-Adresse:
          <a href="mailto:mail@expert.de">mail@expert.de</a>
        </p>
        <p>Den Datenschutzbeauftragten von expert erreichen Sie unter:</p>
        <p>
          expert Datenschutzbeauftragter<br />Bayernstr. 4<br />D- 30855 Langenhagen<br />E-Mail-Adresse:
          <a href="mailto:datenschutz@expert.de">datenschutz@expert.de</a>
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"><strong>1. Grundsätze</strong></span>
        </p>
        <p>
          expert verarbeitet personenbezogene Daten, um die Bedürfnisse ihrer Kund:innen
          besser zu verstehen und so ihr Angebot verbessern zu können. Personenbezogene
          Daten werden daneben nur im konkreten Zusammenhang mit Ihrer Kundenbeziehung zur
          expert e-Commerce GmbH sowie zu Ihrem expert Händler im gesetzlich zulässigen
          Maße oder aufgrund Ihrer vorherigen ausdrücklichen Einwilligung verwendet.
        </p>
        <p>&nbsp;</p>
      </div>
      <div>
        <div>
          <p>
            <span class="text-base"
              ><strong
                ><a id="Nutzungsbedingungen"></a>2. Angaben im Rahmen der Nutzung der
                Webseite</strong
              ></span
            >
          </p>
        </div>
      </div>
      <div>
        <p>
          Grundsätzlich ist es möglich, die expert Webseite ohne Angabe personenbezogener
          Daten zu nutzen. Beim Zugriff auf eine Seite unseres Angebots und bei jedem
          Abruf einer Datei werden dabei Zugriffsdaten über diesen Vorgang in einer
          Protokolldatei gespeichert. Die entsprechende Protokolldatei enthält: die Seite,
          von der aus die Datei angefordert wurde, den Namen der Datei, das Datum und die
          Uhrzeit der Anforderung, die übertragenen Datenmengen, den Zugriffsstatus (Datei
          übertragen, Datei nicht gefunden, etc.), eine Beschreibung des Typs des
          verwendeten Betriebssystems und Webbrowsers. Die gespeicher-ten Daten lassen
          keinen Rückschluss auf Ihre Identität zu und werden ausschließlich zu
          statistischen Zwecken ausgewertet.<br />
          &nbsp;<br />
          Wenn Sie Produkte oder Dienstleistungen bestellen oder Informationen abrufen,
          werden Sie zur Angabe personenbezogener Daten aufgefordert. Dies kann Ihren
          Namen, Ihre Adresse, Ihre Telefonnummer, Ihre E-Mail-Adresse und/oder Ihre
          Zahlungsdaten einschließen. Die von Ihnen eingegebenen Daten werden dazu
          verwendet, um Ihnen die angeforderte Leistung zur Verfügung stellen zu können.
          Zahlungsdaten werden ausschließlich dafür genutzt, um die Zahlung abzuwickeln
          sowie Betrugsfällen vorzubeugen. Sofern Sie im Webshop der expert e-Commerce
          GmbH (im Rahmen eines Bestellvorgangs) Ihre Rechnungsadresse eingeben, erfolgt
          automatisch eine Zuordnung zu dem zuständigen Fachmarkt der expert SE. Ihr
          Vertragspartner wird ausschließlich die expert e-Commerce GmbH, so dass diese
          verant-wortlich für die Datenverarbeitung ist. Grundlage dieser Speicherung und
          Verwendung Ihrer personenbezogenen Daten, die Sie uns zu solchen Zwecken
          übermitteln, ist Art. 6 Abs. 1 S. 1 lit. b) DSGVO, soweit Sie diese
          personenbezogenen Daten zwecks Anbahnung eines Vertrages eingeben. Andernfalls
          erfolgt diese Speicherung und Verwendung aufgrund von Art. 6 Abs. 1 S. 1 lit. f)
          DSGVO, wobei unser berechtigtes Interesse die Bearbeitung Ihres Anliegens
          ist.<br />
          &nbsp;<br />expert verwendet eine sichere Servertechnologie für den Online-Kauf.
          Die sichere Server-technologie verschlüsselt Ihre Zahlungsdaten bevor sie über
          das Internet übermittelt werden. Ein Bezug von Produkten und Services über
          expert Webseite ist nur möglich, wenn Sie einen Browser verwenden, der eine
          sichere Servertechnologie unterstützt.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"><strong>3. Cookies</strong></span>
        </p>
        <p>
          Während der Benutzung unserer Webseite werden auf Ihrem Computer sogenannte
          "Cookies", kleine Textdateien, gespeichert. Derartige Cookies registrieren
          Informationen über die Navigation Ihres Computers auf unserer Webseite
          (angewählte Seiten, Tag, Uhrzeit und Dauer der Benutzung, etc.). Ein Cookie wird
          beim ersten Besuch einer Webseite über einen Browser heruntergeladen. Wenn Sie
          diese Webseite das nächste Mal mit demselben Gerät besuchen, prüft der Browser,
          ob ein entsprechender Cookie vorhanden ist (d.h. den Webseiten-Namen enthält).
          Er sendet die in dem Cookie gespeicherten Daten zurück zur Webseite.<br />Einige
          Cookies sind wichtig für die verschiedenen Funktionalitäten der Webseite
          einschließ-lich der Festlegung des von Ihnen bevorzugten Fachmarktes für spätere
          Besuche unserer Webseite und werden von uns automatisch aktiviert, wenn
          Nutzer:innen diese besuchen. Unsere Webseite verwendet auch Cookies, um die
          Nutzung zu erleichtern und Ihnen an Ihren Informationsbedarf angepasste Inhalte
          zu vermitteln. Sie können über keine der von uns gesammelten Informationen
          persönlich identifiziert werden. Der Einsatz der von uns gesetzten Cookies ist
          erforderlich, um das Online-Angebot von expert überhaupt bereitstellen und
          darüber hinaus auch fortlaufend optimieren zu können. Die Datenverarbeitung in
          diesem Zusammenhang basiert somit auf Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Unser
          berechtigtes Interesse besteht darin, den Besucher:innen unserer Webseite ein
          funktionierendes Online-Angebot zur Verfügung zu stellen und den Besuch sowie
          die Nutzung der Webseite so angenehm und effizient wie möglich zu machen.
          Rechtsgrundlage für den Einsatz von technisch notwendigen Cookies oder ähnlichen
          Technologien auf Ihrem Endgerät ist § 25 Abs. 2 Nr. 2 TDDDG.
        </p>
        <p>
          <span style="font-size: 11pt"
            >Auf unserer Webseite werden auch Cookies von den auf unserer Webseite
            verfügbaren Zahlungsdiensten gesetzt, um die von Ihnen gewählte Zahlungsart
            auszuführen, wobei die Rechtsgrundlage für diese Datenverarbeitung Art. 6 Abs.
            1 S. 1 lit. b) DSGVO ist. Die Zahlungsdienstleister setzen zudem Cookies,
            damit der Bezahlungsvorgang Ihres Online-Kaufs bei uns verifiziert und
            technisch geschützt ist und ein Missbrauch oder unbefugtes Eingreifen durch
            Dritte verhindert wird. Rechtsgrundlage der damit zusammenhängenden
            Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Unser berechtigtes
            Interesse ist es, Ihnen sichere und im Rahmen des technisch Möglichen
            geschützte Funktionen unseres Online-Angebots bereitzustellen; das berechtigte
            Interesse unserer Zahlungsdienstleister ist es, eine möglichst sichere
            Zahlungsabwicklung zu gewährleisten. Rechtsgrundlage für den Einsatz von
            solchen technisch notwendigen Cookies oder ähnlichen Technologien auf Ihrem
            Endgerät ist ebenfalls § 25 Abs. 2 Nr. 2 TDDDG.</span
          >
        </p>
        <p>
          Sie haben die Möglichkeit, die Annahme von "Cookies" selbst zu steuern und ggf.
          zu verhindern, indem Sie Ihren Browser konfigurieren, wie auf den Webseiten der
          Browser-Hersteller angegeben:<br />
          Mozilla Firefox: <br />
          <a
            href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen"
            target="_blank"
            rel="noopener noreferrer"
            >https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen</a
          ><br />
          Internet Explorer: <br />
          <a
            href="http://windows.microsoft.com/de-de/windows-vista/block-or-allow-cookies"
            target="_blank"
            rel="noopener noreferrer"
            >http://windows.microsoft.com/de-de/windows-vista/block-or-allow-cookies</a
          ><br />
          Chrome: <br />
          <a
            href="https://support.google.com/chrome/answer/95647?hl=de"
            target="_blank"
            rel="noopener noreferrer"
            >https://support.google.com/chrome/answer/95647?hl=de</a
          ><br />
          Safari: <br />
          <a
            href="http://support.apple.com/kb/PH5042"
            target="_blank"
            rel="noopener noreferrer"
            >http://support.apple.com/kb/PH5042</a
          ><br />
          Opera: <br />
          <a
            href="http://help.opera.com/Linux/9.00/de/cookies.html"
            target="_blank"
            rel="noopener noreferrer"
            >http://help.opera.com/Linux/9.00/de/cookies.html</a
          >
        </p>
        <p>&nbsp;</p>
      </div>
      <div>
        <div style="padding-bottom: 20px">
          <p>
            Alternativ haben Sie die Möglichkeit, die Annahme von "Cookies" innerhalb
            unserer Webseite selbst zu steuern und ggf. zu verhindern.
          </p>
        </div>
      </div>
      <div
        class="pt-2.5 pb-5"
      >
        <div>
          <div>
            <div
              class="pt-5 pr-2.5"
            >
              <p><strong>Notwendig</strong></p>
              <p>
                Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem
                sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche
                der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht
                richtig funktionieren.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>Statistische Auswertung<br /></strong>
              </p>
              <p>
                Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher
                mit Webseiten interagieren, indem Informationen anonym gesammelt und
                gemeldet werden. Zur bedarfsgerechten Gestaltung sowie zur Optimierung
                dieser Webseite werden durch Analysetools anonymisierte Nutzungsdaten
                erfasst und aggregiert gespeichert.
              </p>
              <p>&nbsp;</p>
              <p><strong>Marketing</strong></p>
              <p>
                Marketing-Cookies werden verwendet, um Besuchern auf Webseiten zu folgen.
                Die Absicht ist, Anzeigen zu zeigen, die relevant und ansprechend für den
                einzelnen Benutzer sind. Durch das Tracking werden Kontakte, die Nutzer
                mit Werbeeinblendungen auf anderen Websites haben (Sichtkontakte und
                Klicks auf Werbebanner), in Bezug gesetzt zu nachfolgenden Interaktionen
                auf unserer Webseite. Die erhobenen Daten werden statistisch ausgewertet,
                um die Leistung der Mediakampagnen optimieren zu können.
              </p>
              <p>
                Diese Daten werden auch dazu benutzt, um Nutzer nach dem Besuch unserer
                Webseiten mit gezielter Werbung entsprechend ihres Nutzungsverhaltens
                wieder anzusprechen. Diese Werbeeinblendungen erfolgen außerhalb unserer
                Webseiten.
              </p>
              <p>&nbsp;</p>
              <p><strong>Produktbewertung</strong></p>
              <p>
                Produktbewertung-Cookies ermöglichen einer Webseite sich an Informationen
                zu erinnern, die die Art beeinflussen, wie sich eine Webseite verhält oder
                aussieht, wie z. B. Ihre bevorzugte Sprache oder die Region in der Sie
                sich befinden.
              </p>
            </div>
          </div>
        </div>
        <div>
          <div
            class="pt-5 pr-2.5 pl-2.5"
          >
            <p><strong>Notwendig</strong></p>
            <p>
              Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie
              Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der
              Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig
              funktionieren.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Statistische Auswertung<br /></strong>
            </p>
            <p>
              Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit
              Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet
              werden. Zur bedarfsgerechten Gestaltung sowie zur Optimierung dieser
              Webseite werden durch Analysetools anonymisierte Nutzungsdaten erfasst und
              aggregiert gespeichert.
            </p>
            <p>&nbsp;</p>
            <p><strong>Marketing</strong></p>
            <p>
              Marketing-Cookies werden verwendet, um Besuchern auf Webseiten zu folgen.
              Die Absicht ist, Anzeigen zu zeigen, die relevant und ansprechend für den
              einzelnen Benutzer sind. Durch das Tracking werden Kontakte, die Nutzer mit
              Werbeeinblendungen auf anderen Websites haben (Sichtkontakte und Klicks auf
              Werbebanner), in Bezug gesetzt zu nachfolgenden Interaktionen auf unserer
              Webseite. Die erhobenen Daten werden statistisch ausgewertet, um die
              Leistung der Mediakampagnen optimieren zu können.
            </p>
            <p>
              Diese Daten werden auch dazu benutzt, um Nutzer nach dem Besuch unserer
              Webseiten mit gezielter Werbung entsprechend ihres Nutzungsverhaltens wieder
              anzusprechen. Diese Werbeeinblendungen erfolgen außerhalb unserer Webseiten.
            </p>
            <p>&nbsp;</p>
            <p><strong>Produktbewertung</strong></p>
            <p>
              Produktbewertung-Cookies ermöglichen einer Webseite sich an Informationen zu
              erinnern, die die Art beeinflussen, wie sich eine Webseite verhält oder
              aussieht, wie z. B. Ihre bevorzugte Sprache oder die Region in der Sie sich
              befinden.
            </p>
          </div>
        </div>
      </div>
      <div
        class="pb-5"
      >
        <p>
          <span class="text-base"
            ><strong>4. Speicherdauer und Löschung<br /></strong
          ></span>
        </p>
        <p>
          Wir speichern Ihre personenbezogenen Daten so lange, wie es zur Erfüllung des
          vorgesehenen Zwecks (z.B. Vertragserfüllung, Beantwortung Ihrer Anfragen)
          notwendig ist oder gesetzliche Aufbewahrungsfristen eine Speicherung
          erforderlich machen. Solange gesetzliche Aufbewahrungspflichten, wie z.B.
          steuer- und handelsrechtliche Vorschriften, einer Löschung Ihrer
          personenbezogenen Daten entgegenstehen, schränken wir die Verarbeitung Ihrer
          Daten ein; anschließend werden Ihre Daten nach den gesetzlichen Vorschriften
          gelöscht.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>5. Weitergabe von Nutzerdaten<br /></strong
          ></span>
        </p>
        <p>
          expert wird Ihre personenbezogenen Daten nicht an Dritte veräußern, vermieten
          oder anderweitig weitergeben. Wir übertragen Ihre Daten an Dritte, wenn Sie
          darin gemäß Art. 6 Abs. 1 S. 1 lit. a) DSGVO eingewilligt haben, oder in den
          folgenden Fällen:
        </p>
        <ul>
          <li>
            Auftragnehmer: expert beauftragt in bestimmten Fällen andere Unternehmen und
            Personen, um ihre Verpflichtungen gegenüber ihren Kunden in ihrem Namen zu
            erfüllen. Hierfür kann es erforderlich sein, Ihre Daten an diese Dritten
            weiterzugeben, um Ihnen Produkte oder Dienstleistungen zur Verfügung zu
            stellen. Beispiele hierfür sind der Kundendienst, die Verarbeitung von
            Zahlungsdaten, die Erfüllung von Bestellungen und die Unterstützung beim
            Marketing. In diesen Fällen erfolgt eine Übermittlung der Daten an solche
            Dienstleister und Auftragnehmer (wie bspw. Zahlungsdienstanbieter,
            Werbeanbieter, technische Service-Provider) zu Zwecken der Vertragserfüllung
            gemäß Art. 6 Abs. 1 S. 1 lit. b) DSGVO. Selbstverständlich stellt expert vor
            einer Weitergabe von personenbezogenen Daten die Gewährleistung der
            Datensicherheit durch den jeweiligen Dienstleister sicher. expert wird daher
            nur solche Unternehmen beauftragen, die aufgrund ihrer Qualifikation sowie
            ihrer technischen und organisatorischen Möglichkeiten eine sichere und
            ordnungsgemäße Datenverarbeitung gewährleisten können.<br />&nbsp;
          </li>
        </ul>
        <ul>
          <li>
            expert Fachmärkte innerhalb der Fachhandelskooperation: Eine Weitergabe von
            Daten an expert Fachmärkte innerhalb der Fachhandelskooperation kann zu
            Zwecken der Vertragsabwicklung erfolgen, beispielsweise zur Erfüllung oder
            Rückabwicklung von Warenlieferungen, oder soweit Sie eingewilligt haben.
            Rechtsgrundlage für die hiermit verbundene Datenübermittlung und weitere
            Verarbeitung ist wiederum Art. 6 Abs. 1 S. 1 lit. b) DSGVO (Vertragserfüllung)
            bzw. Art. 6 Abs. 1 S. 1 lit. a) DSGVO (Einwilligung).<br />&nbsp;
          </li>
        </ul>
        <ul>
          <li>
            Datenverarbeitung aufgrund gesetzlicher Bestimmungen / Schutz vor Missbrauch /
            Rechte Dritter: expert ist berechtigt, Ihre personenbezogenen Daten zu
            verarbeiten, soweit dies zur Erfüllung gesetzlicher Verpflichtungen
            erforderlich ist. Hierfür kann die expert e-Commerce GmbH diese Daten
            insbesondere an Behörden, Strafverfolgungsbehörden und Gerichte übermitteln.
            In diesem Fall ist die Weitergabe Ihrer Daten durch Art. 6 Abs. 1 S. 1 lit. c)
            DSGVO zur Erfüllung einer rechtlichen Verpflichtung erforderlich, der wir
            unterliegen. expert ist weiterhin berechtigt, personenbezogene Daten zu
            verarbeiten, wenn und soweit dies erforderlich ist, um eine missbräuchliche
            Nutzung dieser Webseite aufzudecken oder zu verhindern oder um Ansprüche von
            expert, seiner Mitarbeiter oder seiner Nutzer durchzusetzen, wobei die
            Datenverarbeitung in diesen Fällen zur Wahrung dieser genannten berechtigten
            Interessen von expert gemäß Art. 6 Abs. 1 S. 1 lit. f) DSGVO erforderlich
            ist.<br />&nbsp;
          </li>
        </ul>
        <p>
          Ihre personenbezogenen Daten werden nicht in Länder außerhalb der EU
          übermittelt, sofern dies nicht in dieser Datenschutzerklärung ausdrücklich
          angegeben ist.
        </p>
        <p>
          Die Erfassung und Nutzung Ihrer Telefonnummer geschieht ausschließlich zum Zweck
          der Kontaktaufnahme durch den von Ihnen gewählten Markt im Rahmen des
          Produktreservierungsprozesses, um mit Ihnen zwecks Rückfragen und Auskünften im
          Zusammenhang mit Ihrer Bestellung oder Reservierung in Kontakt treten zu können.
          Eine darüber hinaus gehende Weitergabe Ihrer Telefonnummer oder die werbliche
          Nutzung findet nicht statt. Die Erhebung, Speicherung und Verwendung Ihrer
          Telefonnummer erfolgt damit ausschließlich zu Zwecken der Vertragserfüllung bzw.
          zur Anbahnung eines Vertragsverhältnisses mit Ihnen gemäß Art. 6 Abs. 1 S. 1
          lit. b) DSGVO.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >5.1&nbsp;Bewertungen auf Trusted Shops, idealo und Bazaarvoice</strong
            ></span
          >
        </p>
        <p>
          Mit Absendung Ihrer Bestellung in unserem Online-Shop, in deren Rahmen Sie durch
          Häkchen-Setzen Ihr Einverständnis mit dieser Datenschutzerklärung bestätigen,
          erteilen Sie uns zugleich Ihre ausdrückliche Einwilligung gemäß Art. 6 Abs. 1 S.
          1 lit. a) DSGVO, Ihnen per E-Mail einen Link auf eines der o.g.
          Bewertungsportale (Trusted Shops und/oder idealo) zuzusenden, unter welchem Sie
          den jeweiligen Kaufvorgang bewerten können.
        </p>
        <p>
          Zugleich erklären Sie Ihre Einwilligung, dass wir Ihre E-Mail-Adresse an die
          Bazaarvoice Inc., 10901 Stonelake Blvd., Austin, Texas 78759, USA, übermitteln,
          damit diese Sie per E-Mail um die Abgabe einer Bewertung bitten und Ihnen den
          passenden Link übermitteln sowie Ihnen ggf. eine Bewertungserinnerung per E-Mail
          zusenden kann.
        </p>
        <p>
          Diese Einwilligungen können jederzeit durch eine Nachricht an unsere oben
          angegebenen Kontaktdaten frei widerrufen werden. Darüber hinaus können Sie Ihre
          Einwilligung gegenüber Bazaarvoice zur Nutzung Ihrer E-Mail-Adresse für die
          Zusendung einer Bewertungs-E-Mail und ggf. Bewertungserinnerung jederzeit direkt
          gegenüber Bazaarvoice widerrufen, indem Sie auf den in jeder E-Mail vorhandenen
          Abmeldelink klicken.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>5.2&nbsp;Bewertungserinnerung durch Trusted Shops</strong></span
          >
        </p>
        <p>
          Sofern Sie nach Abschluss Ihrer Bestellung in dem auf unserer Webseite
          integrierten Trustbade auf den Link "Kauf bis 100 EUR absichern und bewerten"
          klicken, verlassen Sie unsere Webseite und gelangen zur Webseite der Trusted
          Shops GmbH, Subbelrather Str. 15c, 50823 Köln (<a
            href="http://www.trustedshops.de/"
            target="_blank"
            rel="noopener noreferrer"
            >www.trustedshops.de</a
          >). In diesem Fall erklären Sie mit dem Klick auf den Link Ihre Einwilligung
          gemäß Art. 6 Abs. 1 S. 1 lit. a) DSGVO dazu, dass Trusted Shops Ihnen eine
          Bewertungserinnerung per E-Mail zusendet. Diese Einwilligung können Sie
          jederzeit durch eine Nachricht an die oben angegebenen Kontaktdaten von Trusted
          Shops widerrufen. Diesbezüglich gelten die Datenschutzrichtlinien von Trusted
          Shops, die hier abrufbar sind:
          <a
            href="https://www.trustedshops.de/impressum/"
            target="_blank"
            rel="noopener noreferrer"
            >https://www.trustedshops.de/impressum/</a
          >
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >5.3 Auswertungen von Produktbewertungen durch Bazaarvoice</strong
            ></span
          >
        </p>
        <p>
          Wir nutzen die Dienstleistungen der Bazaarvoice Inc., 10901 Stonelake Blvd.,
          Austin, Texas 78759, USA (<a
            href="https://www.bazaarvoice.com/"
            target="_blank"
            rel="noopener noreferrer"
            >www.bazaarvoice.com</a
          >), um Produktbewertungen und Kundenfragen auf unseren Webseiten zu ermöglichen
          und mit diesem Kundenfeedback Anpassungen unseres Angebots zu entwickeln und
          Ihnen ein noch besseres Produkt- und Leistungsportfolio anzubieten. Hierbei
          möchten wir in erster Linie erfahren, wie Besucher unserer Webseiten abgegebene
          Bewertungen und Kundenfragen nutzen, welche Services von expert nach Kontakt mit
          einem der vorgenannten Inhalte genutzt werden und welche Unterseiten auf der
          Webseite aufgerufen werden und ob Sie sich für einen Newsletter anmelden. Hierzu
          werden sowohl sog. Pixel, d.h. kleine Bildelemente, genutzt, die auf unseren
          Webseiten eingebunden sind, als auch Cookies. Außerdem werden Informationen zu
          dem von Ihnen genutzten Browser erhoben. Eine Zuordnung zu Ihnen erfolgt nur
          über einen zufällig generierten Zahlenwert. Eine Zusammenführung mit unmittelbar
          personenbezogenen Daten, wie Ihrem Namen oder Ihrer E-Mail-Adressen erfolgt hier
          nicht.
        </p>
        <p>
          Weiterhin werden bei der Abgabe von Bewertungen und deren Aufruf systembedingt
          Cookies gesetzt, um diese Services anzubieten. Diese Cookies speichern keinerlei
          personenbezogene Daten. Die Speicherdauer der gesetzten Cookies beträgt maximal
          ein Jahr.
        </p>
        <p>
          Bazaarvoice setzt bei Nutzung des Bazaarvoice-Netzwerkes und der sonstigen
          Services von Bazaarvoice weiterhin eigenständig und eigenverantwortlich Cookies.
          Eine Übersicht über die von Bazaarvoice genutzten Cookies finden Sie
          <a
            href="https://knowledge.bazaarvoice.com/wp-content/knowledge/en_US/cookies.html"
            target="_blank"
            rel="noopener noreferrer"
            >hier</a
          >.
        </p>
        <p>
          Rechtsgrundlage für unsere Nutzung der Auswertungsdienste von Bazaarvoice mit
          Sitz in den USA ist Ihre Einwilligung gemäß Art. 6 Abs. 1 S. 1 lit. a) DSGVO.
          Rechtsgrundlage für den Einsatz von Cookies oder ähnlichen Technologien auf
          Ihrem Endgerät ist Ihre Einwilligung gemäß § 25 Abs. 1 TDDDG. Sie können Ihre
          Einwilligung in die Verwendung Ihrer Daten jederzeit mit Wirkung für die Zukunft
          widerrufen. Dazu können Sie Ihre Einstellungen oben im Abschnitt Cookies
          entsprechend anpassen.
        </p>
        <p>
          Ihre Einwilligung in die Datenermittlung und -verarbeitung zu den vorgenannten
          Zwecken durch Bazaarvoice können Sie jederzeit mit Wirkung für die Zukunft
          widerrufen. Wenden Sie sich hierzu bitte an unseren Datenschutzbeauftragten.
        </p>
        <p>
          <span style="background-color: rgba(255, 255, 255, 0)"
            >Soweit Bazaarvoice zu unseren Zwecken Daten in die USA übermittelt, werden
            Bazaarvoice und wir sicherstellen, dass dies auf der Grundlage angemessener
            Schutzmaßnahmen nach Art. 44 ff. DSGVO erfolgt. Bazaarvoice ist unter dem
            EU-US Data Privacy Framework (DPF) zertifiziert und in die vom U.S. Department
            of Commerce geführte Liste (DPF List) eingetragen, sodass die
            Datenübermittlung auf Grundlage des Angemessenheitsbeschlusses der
            EU-Kommission erfolgt. Bei der Übermittlung von Daten an Server von
            Bazaarvoice in den USA ist daher ein durchgängig hohes Datenschutzniveau
            gewährleistet. Ein solcher Drittlandtransfer basiert somit auf Art. 45 Abs. 1
            S. 1 DSGVO. Weitere Informationen zur Verarbeitung Ihrer Daten durch
            Bazaarvoice entnehmen Sie bitte den Datenschutzhinweisen unter </span
          ><a
            style="background-color: rgba(255, 255, 255, 0)"
            href="http://www.bazaarvoice.com/de/legal/datenschutzrichtlinie/"
            target="_blank"
            rel="noopener noreferrer"
            >www.bazaarvoice.com/de/legal/datenschutzrichtlinie/</a
          ><span style="background-color: rgba(255, 255, 255, 0)">.</span>
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >5.4&nbsp;Zahlung auf Rechnung, Sofortüberweisung, Lastschrift und Ratenkauf
              mittels Klarna</strong
            ></span
          >
        </p>
        <p>
          Für Bestellungen in unserem Online-Shop stellen wir Ihnen nach Möglichkeit als
          Zahlungsoption die Zahlung auf Rechnung und mittels sog. Sofortüberweisung zur
          Auswahl.
        </p>
        <p>
          Die Zahlung auf Rechnung wird in unserem Online-Shop bereitgestellt von der
          Klarna Bank AB (publ), Sveavägen 46, 111 34 Stockholm, Schweden ("Klarna"). Wenn
          Sie sich für den Kauf auf Rechnung entscheiden, erhält Klarna von uns Ihren
          Namen, Ihre Kontaktdaten und Ihr Geburtsdatum, Angaben zu Ihrer Bestellung
          einschließlich des Rechnungsbetrages und Ihre IP-Adresse.
        </p>
        <p>
          Klarna verwendet diese Daten selbständig, um vor Bereitstellung der Zahlung auf
          Rechnung Ihre Identität und Bonität zu prüfen. Im Rahmen dieser Bonitätsprüfung
          kann Klarna auch Partner wie Kreditauskunfteien, mit denen Klarna
          zusammenarbeitet, zur Bewertung des Zahlungsausfallrisikos hinzuziehen und Ihre
          personenbezogenen Daten zur Durchführung der Bonitätsprüfung an diese Partner
          weiterleiten. Eine Übersicht der Partner, mit denen Klarna zu Zwecken der
          Bonitätsprüfung derzeit zusammenarbeitet,
          <a
            href="https://cdn.klarna.com/1.0/shared/content/legal/terms/de-DE/credit_rating_agencies"
            >ist verfügbar</a
          >. Unsere Übermittlung Ihrer personenbezogenen Daten an Klarna zur
          Bonitätsprüfung erfolgt auf der Grundlage von berechtigten Interessen (Art. 6
          Abs. 1 S. 1 lit. f) DSGVO). Berechtigtes Interesse von uns und Klarna ist die
          Vermeidung von Zahlungsausfällen und Verhinderung von Betrugsversuchen, um die
          Option der Zahlung auf Rechnung weiterhin einer möglichst großen Zahl unserer
          Kunden anbieten zu können.
        </p>
        <p>
          Klarna verarbeitet diese Daten im Anschluss selbständig und eigenverantwortlich
          zu Zwecken der Rechnungsabwicklung mit Ihnen, ohne weitere Beteiligung von
          expert. Die Übermittlung Ihrer personenbezogenen Daten in diesem Zusammenhang
          erfolgt daher ausschließlich zu Zwecken der Vertragserfüllung gemäß Art. 6 Abs.
          1 S. 1 lit. b) DSGVO.
        </p>
        <p>
          Die Zahlung per Sofortüberweisung erfolgt ebenfalls mittels der Dienste von
          Klarna. Für eine Sofortüberweisung müssen Sie sich in Ihren
          Online-Banking-Zugang einwählen und hierfür Ihre Anmeldedaten eingeben, die
          Klarna an Ihre Bank weiterleitet. Klarna erhebt zudem Ihren Namen, Ihre
          Kontonummer, den Überweisungsbetrag, den angegebenen Verwendungszweck sowie Ihre
          IP-Adresse. Diese Daten verarbeitet Klarna selbständig zur Veranlassung und
          Abwicklung Ihrer Zahlung. expert ist an diesem Verarbeitungsprozess nicht
          beteiligt, sondern wird nur nach Abschluss der Zahlungsabwicklung über die
          erfolgreiche Abwicklung informiert. Die Übermittlung Ihrer personenbezogenen
          Daten in diesem Zusammenhang erfolgt daher ausschließlich zur Erfüllung des
          Vertrages gemäß Art. 6 Abs. 1 S. 1 lit. b) DSGVO.
        </p>
        <p>
          Im Rahmen der Abwicklung Ihrer Zahlung kann Klarna die übermittelten Daten
          jeweils im Einzelfall auch zu weiteren Zwecken verarbeiten, wie zur Erfüllung
          gesetzlicher Vorschriften, insbesondere bankenaufsichtsrechtlicher Vorgaben und
          Vorschriften zur Geldwäscheprävention. Nähere Informationen dazu, wie Klarna die
          von uns übermittelten, Sie betreffenden personenbezogenen Daten verarbeitet,
          finden Sie in der Datenschutzerklärung von Klarna, die Sie
          <a
            href="http://cdn.klarna.com/1.0/shared/content/legal/terms/0/de_de/privacy"
            target="_blank"
            rel="noopener noreferrer"
            >hier</a
          >
          einsehen können.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>5.5&nbsp;Klarna Onsite Messaging</strong></span
          >
        </p>
        <p>
          Klarna verwendet Cookies, um das Gerät der Benutzer:innen zu erkennen, um
          personalisierte Werbung für Klarna-Produkte bereitzustellen, wenn Benutzer:innen
          das nächste Mal eine Händler-Webseite besuchen, die Klarna-Produkte anbietet,
          und zu Analysezwecken. expert ist an diesen Verarbeitungsprozessen nicht
          beteiligt.
        </p>
        <p>
          Dauerhafte Marketing- und Analyse-Cookies<br />Diese Cookies enthalten eine
          eindeutige Benutzer-ID, die es Klarna ermöglicht, das Gerät der Benutzer:innen
          wiederzuerkennen, wenn die Benutzer:innen das nächste Mal zu einem Händler
          zurückkehren, der die Dienste von Klarna nutzt. Dies sind dauerhafte Cookies,
          die auf dem Gerät für einen Zeitraum von bis zu 540 Tagen ab der letzten
          Interaktion mit Klarna gespeichert werden (oder so lange bis sie gelöscht
          werden) und es Klarna (i) ermöglichen, den Benutzer:innen personalisiertes
          Marketing für Klarna-Produkte anzuzeigen, einschließlich Kreditaktionen und (ii)
          um Analysen des Nutzerverhaltens durchzuführen.
        </p>
        <p>
          Durch die Verknüpfung der im Cookie auf dem Gerät gespeicherten eindeutigen
          Benutzer-ID mit den Informationen, die Klarna über die Benutzer:innen hat, kann
          Klarna die Benutzer:innen dieses Geräts wiedererkennen. Die Informationen, die
          Klarna durch die Cookies sammelt, werden nicht an Dritte weitergegeben.
        </p>
        <p>
          Über Klarna<br />Klarna Bank AB (publ) unterliegt der schwedischen
          Datenschutzgesetzgebung und ist der Datenverantwortliche für die Verarbeitung
          der personenbezogenen Daten wie oben beschrieben, einschließlich des Setzens von
          Cookies bei der Nutzung von Klarna. Klarna hat einen Datenschutzbeauftragten und
          ein Team bestehend aus Experten für personenbezogene Daten. Klarna hat auch ein
          Kundenservice-Team, das Fragen zu personenbezogenen Daten bearbeitet. Gerne
          können Sie Klarna unter
          <a href="mailto:datenschutz@klarna.de">datenschutz@klarna.de</a> kontaktieren.
          Bitte besuchen Sie
          <a
            class="external"
            href="http://www.klarna.com/"
            target="_blank"
            rel="noopener noreferrer"
            >www.klarna.com</a
          >&nbsp;für weitere Informationen über Klarna und wie Klarna personenbezogene
          Daten verarbeitet.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >5.6&nbsp;Warenversand mittels Transportdienstleistern, Abstimmung des
              Lieferzeitpunkts</strong
            ></span
          >
        </p>
        <p>
          Für den Versand Ihrer bestellten Ware an die von Ihnen bestimmte Lieferadresse
          arbeiten wir mit Transportdienstleistern zusammen (DPD Deutschland GmbH,
          Wailandtstraße 1, 63741 Aschaffenburg und GEL Express Logistik GmbH,
          Otto-Hahn-Straße 10, 40670 Meerbusch). Zur Abwicklung des Versandes erhält der
          jeweilige Transportdienstleister folgende Daten: Ihren Namen und die
          Lieferanschrift, Angaben zur Sendung (Maße, Gewicht und ggf. Gefahrgutangaben)
          sowie, zur Abstimmung des genauen Lieferzeitpunkts mit Ihnen bzw. zur Mitteilung
          des Lieferzeitpunkts und etwaiger Verzögerungen insbesondere bei sperrigen
          Sendungen, Ihre Telefonnummer und/oder Ihre E-Mail-Adresse, einschließlich Ihrer
          IP-Adresse. Die Bereitstellung dieser Daten erfolgt über einen Dienst, den der
          jeweilige Transportdienstleister zur Verfügung stellt (Schnittstelle). Die
          Transportdienstleister verarbeiten alle vorgenannten Daten im Zusammenhang mit
          dem Warenversand selbständig und eigenverantwortlich. Selbstverständlich stellen
          wir vor einer Weitergabe der Sie betreffenden personenbezogenen Daten sicher,
          dass der jeweilige Transportdienstleister angemessene technische und
          organisatorische Maßnahmen ergriffen hat, um die Sicherheit der Daten zu
          gewährleisten. Nähere Informationen zum Umgang der Transportdienstleister mit
          Ihren personenbezogenen Daten finden Sie in der Datenschutzerklärung des
          jeweiligen Transport-dienstleisters (Datenschutzerklärung der DPD Deutschland
          GmbH bzw. der GEL Express Logistik GmbH). Die Übermittlung der vorgenannten
          Daten an die Transportdienstleister erfolgt zum Zweck der Vertragserfüllung
          gemäß Art. 6 Abs. 1 S. 1 lit. b) DSGVO.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >5.7 Verlängerte Gerätegarantien, Vermittlung von
              Geräteversicherungen</strong
            ></span
          >
        </p>
        <p>
          In unserem Online-Shop bieten wir Ihnen die Option an, für ein bestelltes Gerät
          eine verlängerte Gerätegarantie zu erwerben. Um Ihnen diese Gerätegarantie
          anbieten zu können, arbeiten wir mit der Deutschen Garantie Gesellschaft mbH,
          Breite Straße 6, 30159 Hannover, ("DGG") zusammen. Sofern Sie sich für eine
          verlängerte Gerätegarantie entscheiden, kommt der Garantievertrag zwar mit
          expert zustande. Die DGG übernimmt anschließend aber eigenverantwortlich die
          Bearbeitung der Garantieleistungen und die Abwicklung von Schadensfällen,
          einschließlich der Prüfung und Bewertung eines gemeldeten Geräteschadens oder
          -verlustes im Hinblick auf die Einhaltung der vereinbarten Bedingungen für die
          verlängerte Gerätegarantie und der Auszahlung der Garantieleistung.
        </p>
        <p>
          Wenn Sie ein Gerät mit einer verlängerten Gerätegarantie bestellen, übermitteln
          wir nach Abschluss des Garantievertrages mit Ihnen folgende Informationen an die
          DGG zwecks Erfüllung der aus dem Garantievertrag folgenden Leistungen: Ihren
          Namen, Ihre Anschrift und Ihr Geburtsdatum, die Details zu Ihrem bestellten
          Gerät einschließlich des Kaufpreises und des Kaufdatums sowie die Details zu
          Ihrer ausgewählten Gerätegarantie und den Garantiebedingungen und Ihre Bankdaten
          zwecks Auszahlung der Garantieleistung. Bei Inanspruchnahme der
          Garantieleistungen leiten wir zudem die Informationen aus Ihrer Schadensmeldung
          über den konkreten Schaden, das betreffende Gerät und zu Ihrer Bestellung sowie
          die Rechnungsdaten an die DGG weiter; bei Verlust des Gerätes kommt eine Kopie
          der von Ihnen ggf. übermittelten Strafanzeige hinzu. Die Übermittlung dieser
          Daten an die DGG und die Verarbeitung aller der DGG vorliegenden, Sie
          betreffenden Daten durch die DGG erfolgt allein zur Bearbeitung und
          Bereitstellung der vereinbarten Garantieleistung entsprechend des Vertrages mit
          Ihnen. Rechtsgrundlage für die Datenverarbeitungen in diesem Rahmen ist folglich
          die Erfüllung des mit Ihnen abgeschlossenen Garantievertrages gemäß Art. 6 Abs.
          1 S. 1 lit. b) DSGVO. Die Übermittlung der Daten an die DGG ist dabei
          erforderlich, um die Abwicklung im Schadensfall zügig und effizient zu
          gestalten.
        </p>
        <p>
          Im Rahmen ihrer Garantieleistungen nutzt die DGG Leistungen der Wertgarantie SE,
          Breite Straße 8, 30159 Hannover, ("Wertgarantie") zur Absicherung verbleibender
          Risiken. Die Wertgarantie prüft und bewertet hierzu eigenständig das Risiko aus
          der verlängerten Garantie sowie das Vorliegen eines Garantiefalls. Zu diesem
          Zweck erhält und verarbeitet die Wertgarantie die vorgenannten Daten, also Ihren
          Namen, Ihre Anschrift und Ihr Geburtsdatum, sowie die Details zu Ihrem
          bestellten Gerät einschließlich des Kaufpreises und des Kaufdatums sowie die
          Details zu Ihrer ausgewählten Gerätegarantie und den Garantiebedingungen. Die
          Übermittlung und die mit der Risikoabsicherung durch die Wertgarantie
          zusammenhängenden Datenverarbeitungen erfolgen auf der Rechtsgrundlage
          berechtigter Interessen nach Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Sowohl unser
          berechtigtes Interesse als auch das Interesse der DGG ist die angemessene
          Absicherung solcher Risiken, die aufgrund etwaiger, mitunter nur schwer
          vorherzusehender Schadensfälle für Geräte einer besonderen Absicherung bedürfen.
          Über eine angemessene Absicherung wollen wir gewährleisten, dass möglichst viele
          Kunden von einer verlängerten Gerätegarantie profitieren können.
        </p>
        <p>
          Nähere Informationen zum Umgang der DGG und der Wertgarantie mit Ihren
          personenbezogenen Daten finden Sie in den Datenschutzinformationen der DGG und
          der Wertgarantie zum Geräteschutz hier, sowie in der allgemeinen
          Datenschutzerklärung der Wertgarantie
          <a href="https://www.wertgarantie.de/datenschutz">hier</a>.
        </p>
        <p>
          Wir bieten außerdem über unseren Online-Shop die Möglichkeit an, eine
          Geräteversicherung für Ihr bestelltes Gerät (sog. "Komplettschutz") bei der
          Wertgarantie abzuschließen. Diese Geräteversicherung wird allein und
          eigenverantwortlich von der Wertgarantie bereitgestellt. Wir vermitteln
          lediglich den Vertragsschluss zwischen Ihnen und der Wertgarantie. Wenn Sie sich
          für eine Geräteversicherung mit Komplettschutz entscheiden, übermitteln wir
          Ihren Namen, Ihre Kontaktdaten und die Details zur Geräteversicherung sowie zu
          dem von Ihnen bestellten Gerät an die Wertgarantie. Diese Übermittlung ist
          notwendig, damit die Wertgarantie den Abschluss des Vertrages über die
          Geräteversicherung, den Sie angefragt haben, prüfen und den Vertrag nach
          Abschluss erfüllen und abwickeln kann. Die Wertgarantie führt die anschließenden
          Datenverarbeitungen selbständig und ohne unser Zutun durch. Die Erhebung und
          Weiterleitung Ihrer Daten erfolgt daher zur Durchführung vorvertraglicher
          Maßnahmen, die auf Ihrer Anfrage beruhen, und zur Erfüllung des anschließend
          geschlossenen Vertrages entsprechend Art. 6 Abs. 1 S. 1 lit. b) DSGVO.
        </p>
        <p>
          Auch insoweit finden Sie nähere Informationen über den Umgang der Wertgarantie
          mit Ihren personenbezogenen Daten in der Datenschutzerklärung der Wertgarantie,
          die
          <a
            href="https://www.wertgarantie.de/Home/Service/Datenschutz.aspx"
            target="_blank"
            rel="noopener noreferrer"
            >hier</a
          >
          abrufbar ist.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>5.8 Dankeschön-Angebote nach Bestellungen</strong></span
          >
        </p>
        <p>
          Am Ende Ihrer Bestellung können wir Ihnen gesonderte Hinweise zu Angeboten und
          Vergünstigungen für Leistungen Dritter ("Dankeschön-Angebote" oder
          "Vorteilsangebote") anzeigen, die Sie separat ordern können. Für die
          Bereitstellung dieser Angebote arbeiten wir mit der userwerk GmbH, Ehinger Str.
          19, 89077 Ulm ("userwerk") zusammen.
        </p>
        <p>
          Die Hinweise verlinken zu einer separaten Seite bzw. einem separaten Fenster mit
          Details zu den Dankeschön-Angeboten und dem zugehörigen Bestellformular. Um ein
          für Sie passendes Vorteilsangebot (z.B. eine lokale Tageszeitung) vorschlagen zu
          können, leiten wir Ihre Postleitzahl an userwerk weiter. Sofern Sie keines der
          vorgeschlagenen Vorteilsangebote wahrnehmen möchten und das Browserfenster
          schließen, werden keine weiteren Daten übertragen. Dann wird Ihre Postleitzahl
          unmittelbar gelöscht und Sie sind für userwerk nicht identifizierbar. Die
          Weiterleitung Ihrer Postleitzahl an userwerk erfolgt zur Wahrung unseres
          berechtigten Interesses, Ihnen ein möglichst passendes Dankeschön-Angebot im
          Nachgang zu Ihrem Kauf im expert-Onlineshop unterbreiten zu können, und damit
          auf Basis von Art. 6 Abs. 1 S. 1 lit. f) DSGVO. userwerk darf Ihre Postleitzahl
          in diesem Zusammenhang nur weisungsgebunden in unserem Auftrag verarbeiten. Wir
          haben insoweit einen Vertrag über Auftragsverarbeitung gemäß Art. 28 DSGVO mit
          userwerk abgeschlossen.
        </p>
        <p>
          Wenn Sie eines der vorgeschlagenen Vorteilsangebote wahrnehmen möchten, geben
          Sie die Bestellung direkt über userwerk auf. userwerk erfasst Ihre Bestelldaten
          und übermittelt sie zur Ausführung Ihrer Order an den Dritten, dessen Leistungen
          Sie in Anspruch nehmen möchten. Um Ihnen hierbei einen einfachen Bestellvorgang
          zu ermöglichen, werden Ihre beim Einkauf in unserem Shopsystem hinterlegten,
          persönlichen Kontaktdaten automatisch in das Bestellformular eingegeben (z.B.
          Name, Adresse, E-Mail-Adresse). Diese Daten werden an userwerk jedoch erst
          weitergeleitet, wenn Sie das Bestellformular abschicken. Sollten Sie sich
          während des Bestellvorgangs anders entscheiden und den Bestellvorgang abbrechen
          (z.B. indem Sie das Browserfenster schließen), werden keine Daten an userwerk
          übermittelt. Im Übrigen sind wir an der Erhebung und Verarbeitung Ihrer Daten im
          Zusam-menhang mit den Dankeschön-Angeboten nicht beteiligt. Ein diesbezüglicher
          Vertrag kommt dann lediglich mit userwerk bzw. dem Dritten zustande, dessen
          Leistungen Sie in Anspruch nehmen möchten. Wir sind an dieser Vertragsbeziehung
          ausdrücklich nicht beteiligt.
        </p>
        <p>
          Sofern Sie ein Dankeschön-Angebot bestellen möchten und die Bestellung absenden,
          werden Ihre dafür erforderlichen personenbezogenen Daten zur Durchführung
          vorvertraglicher Maßnahmen, die auf Ihrer Anfrage eines Dankeschön-Angebots
          beruhen, und zur Erfüllung des anschließend geschlossenen Vertrages mit dem
          Dritten, dessen Leistungen Sie in Anspruch nehmen möchten, an userwerk
          übermittelt. Die Speicherung von Informationen auf Ihrem Endgerät bzw. der
          Zugriff auf Informationen, die bereits in Ihrem Endgerät gespeichert sind, sowie
          die anschließende Datenverarbeitung beruhen somit auf § 25 Abs. 2 Nr. 2 TDDDG
          bzw. Art. 6 Abs. 1 S. 1 lit. b) DSGVO. Details zur anschließenden
          Datenverarbeitung durch userwerk finden Sie in deren Datenschutzerklärung
          <a
            href="https://www.userwerk.com/datenschutzerklaerung/"
            target="_blank"
            rel="noopener noreferrer"
            >hier</a
          ><a href="https://www.userwerk.com/datenschutzerklaerung/">&nbsp;</a>.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>5.9 Shopping-Bonus von loopingo<br /></strong></span
          ><br />Für die Anzeige des Shopping-Bonus verwenden wir die Dienste der loopingo
          GmbH, Freibadstr. 30, 81543 München. Zur Vorbereitung des Shopping-Bonus wird
          von uns die E-Mail-Adresse an loopingo verschlüsselt und pseudonymisiert
          übermittelt (Rechtsgrundlage hierfür ist Art. 6 Abs.1 S. 1 b) und f) DSGVO).
          Unser berechtigtes Interesse liegt in der Bereitstellung des Shopping-Bonus und
          der Kundenbindung. Die IP-Adresse, die von loopingo ausschließlich zu Zwecken
          der Datensicherheit verwendet wird, wird im Regelfall nach sieben Tagen
          anonymisiert. Außerdem übermitteln wir zur Aufbereitung des Angebots
          verschlüsselt Bestellnummer und Bestellwert mit Währung an loopingo. Weitere
          Informatio-nen zur Verarbeitung Ihrer Daten durch die loopingo entnehmen Sie
          bitte deren Datenschut-zerklärung
          <a href="https://www.loopingo.com/datenschutz">hier</a>.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>6. Direktmarketing im Rahmen einer Kundenbeziehung<br /></strong
          ></span>
        </p>
        <p>
          Wir verwenden die von Ihnen mitgeteilten Daten zur Erfüllung und Abwicklung
          Ihrer Bestellung gemäß Art. 6 Abs. 1 S. 1 lit. b) DSGVO. Soweit Sie uns im
          Zusammenhang mit dem Verkauf einer Ware oder Dienstleistung Ihre E-Mail-Adresse
          mitgeteilt haben, informie-ren wir sie per elektronischer Post ferner über
          sonstige Angebote der expert e-Commerce GmbH, die denjenigen Produkten oder
          Leistungen ähnlich sind, die Sie bei uns bereits erworben bzw. in Anspruch
          genommen haben. Sollten Sie solche Informationen nicht wünschen, können Sie der
          Zusendung jederzeit schriftlich oder per E-Mail widersprechen. Dieser
          Widerspruch ist für Sie kostenfrei mit Ausnahme der üblichen
          Übertragungsentgelte.
        </p>
        <p>
          Ihnen wird in jeder von uns übersandten Information und in jedem Newsletter die
          Möglichkeit eingeräumt, den Erhalt weiterer Informationen abzulehnen und einen
          entsprechenden Widerspruch abzusenden. Die Verarbeitung Ihrer personenbezogenen
          Daten zum Versand der produktbezogenen Werbenewsletter erfolgt auf der Grundlage
          Art. 6 Abs. 1 S. 1 lit. f) DSGVO, wobei unser berechtigtes Interesse die Werbung
          für eigene ähnliche Produkte und Dienstleistungen im Rahmen einer laufenden
          Kundenbeziehung mit Ihnen ist. Ihre schutzwürdigen Interessen sind unter
          Berücksichtigung von § 7 Abs. 3 des Gesetzes gegen unlauteren Wettbewerb (UWG)
          hinreichend gewahrt.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >7. Gütesiegel Trusted Shops (Einbindung des "Trustbadge")<br /></strong
          ></span>
        </p>
        <p>
          Zur Anzeige unseres Trusted Shops Gütesiegels und der über uns gesammelten
          Bewertungen sowie zum Angebot der Trusted Shops Produkte für Käufer nach einer
          Bestellung ist auf unserer Webseite das Trusted Shops Trustbadge eingebunden.
          Das Trustbadge und die damit beworbenen Dienste sind ein Angebot der Trusted
          Shops SE, Subbelrather Str. 15C, 50823 Köln ("Trusted Shops"). Trusted Shops und
          expert sind gemeinsam Verantwortliche im Sinne des Art. 26 DSGVO. Weitere
          Informationen dazu finden Sie in der Vereinbarung zur gemeinsamen
          Verantwortlichkeit
          <a
            href="https://help.etrusted.com/hc/de/articles/23970819574290-FAQ-zum-Datenschutz-bei-Trusted-Shops"
            >hier</a
          >.
        </p>
        <p>
          Dies dient der Wahrung unserer im Rahmen einer Interessensabwägung überwiegenden
          berechtigten Interessen an einer optimalen Vermarktung unseres Angebots durch
          die Ermöglichung eines sicheren Einkaufs. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1
          lit. f) DSGVO.
        </p>
        <p>
          Bei dem Aufruf unserer Webseite speichert der Webserver automatisch ein
          sogenanntes Server-Logfile, das z.B. Ihre IP-Adresse, Datum und Uhrzeit des
          Abrufs, übertragene Datenmenge und den anfragenden Provider (Zugriffsdaten)
          enthält und den Abruf dokumentiert. Diese Zugriffsdaten werden nicht ausgewertet
          und spätestens sieben Tage nach Ende Ihres Seitenbesuchs automatisch
          überschrieben.
        </p>
        <p>
          Wenn Sie das Trustbadge anklicken, werden durch Trusted Shops Session-Cookies
          gesetzt, um den Login-Status zu speichern und das sogenannte Welcome-Layer
          anzuzeigen. Rechtsgrundlage für den Einsatz von Cookies oder ähnlichen
          Technologien auf Ihrem Endgerät ist § 25 Abs. 2 Nr. 2 TDDDG.
        </p>
        <p>
          Weitere personenbezogene Daten werden lediglich an Trusted Shops übertragen,
          soweit Sie hierzu eingewilligt haben, sich nach Abschluss einer Bestellung für
          die Nutzung von Trusted Shops Produkten entscheiden oder sich bereits für die
          Nutzung registriert haben. In diesem Fall gilt die zwischen Ihnen und Trusted
          Shops getroffene vertragliche Vereinbarung.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>8. Einbindung von Flixmedia<br /></strong
          ></span>
        </p>
        <p>
          Um immer aktuelle Produktinformationen auf unseren Seiten anbieten zu können,
          haben wir des Weiteren auf unserer Webseite die Dienste der Flixmedia Ltd., Unit
          1, The Technology Park, Colindeep Lane, London, NW9 6BX, United Kingdom
          ("Flixmedia") eingebunden.
        </p>
        <p>
          Für das schnelle Hochladen von Produktseiten, Übersichten und Produktinhalten
          verarbeitet Flixmedia Ihre IP-Adresse. Flixmedia arbeitet mit dem von Ihnen
          gewählten Händler zusammen, um Ihnen offizielle Herstellerinformationen über das
          von Ihnen in Betracht gezogene Produkt zu liefern, und ist kein Werbedienst.
          Flixmedia erhebt und verarbeitet Ihre IP-Adresse ausschließlich, um Video-,
          Bild- oder Textinformationen des Herstellers zur Verfügung zu stellen, speichert
          Ihre IP-Adresse jedoch nicht als Teil dieses Service für Ihren Händler und
          stellt Ihre IP-Adresse ausschließlich den unterstützenden Technologiepartnern
          für die Darstellung der Informationen zur Verfügung. Flixmedia verarbeitet oder
          speichert keine anderen personenbezogenen Daten von Ihnen und bezieht keine
          anderen Ihrer personenbezogenen Daten von Dritten. Weitere Informationen finden
          Sie in der Datenschut-zerklärung von Flixmedia
          <a href="https://www.flixmedia.com/privacy-notice">hier</a>. Falls Sie Fragen
          zur Verarbeitung Ihrer IP-Adresse durch Flixmedia haben, wenden Sie sich bitte
          an <a href="mailto:GDPR@flixmedia.eu">GDPR@flixmedia.eu</a>.
        </p>
        <p>
          Wir nutzen die Dienste von Flixmedia ausschließlich, um Ihnen mehr Informationen
          über die auf unserer Webseite angebotenen Produkte zur Verfügung stellen zu
          können und Ihnen damit Ihre Produktauswahl zu erleichtern. Rechtsgrundlage für
          die Nutzung der Flixmedia-Dienstleistungen und die hierüber erfolgende
          Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Unser berechtigtes
          Interesse ist die Optimierung unserer Webseite, um Ihnen den größtmöglichen
          Nutzerkomfort bieten zu können und Ihnen den Besuch unserer Webseite so angenehm
          und informativ wie möglich zu gestalten.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>9. Webanalyse durch DYMATRIX (ehem. econda)<br /></strong
          ></span>
        </p>
        <p>
          Zur bedarfsgerechten Gestaltung sowie zur Optimierung dieser Webseite werden
          durch die Lösungen der DYMATRIX GmbH, Lautenschlagerstraße 2, 70173 Stuttgart
          ("DYMATRIX"), mittels Cookies Nutzungsdaten erfasst und aggregiert gespeichert
          sowie aus diesen Daten Nutzungsprofile unter der Verwendung von Pseudonymen
          erstellt.
        </p>
        <p>
          Darüber hinaus verarbeitet DYMATRIX diese Nutzerprofile, um die Akzeptanz
          unserer Onlinewerbung auszuwerten und darauf basierende
          Verbesserungsmöglichkeiten für uns zu ermitteln, indem DYMATRIX durch den
          Einsatz von Cookies Ihr Nutzungsverhalten auf den von uns betriebenen Webseiten
          erhebt und verarbeitet. Diese Daten werden dazu benutzt, um Sie nach dem Besuch
          unserer Webseiten mit gezielter Werbung entsprechend Ihres Nutzungsverhaltens
          wieder anzusprechen und zu verhindern, dass Sie mit Werbung belästigt werden,
          die nicht für Sie relevant ist. Diese Werbeeinblendungen erfolgen außerhalb
          unserer Webseiten. Die von DYMATRIX zu diesem Zweck gesetzten Cookies bleiben
          höchstens 2 Jahre auf Ihrem Computer gespeichert, können aber auch vor Ablauf
          dieser Laufzeit von Ihnen gelöscht werden.
        </p>
        <p>
          Nutzungsdaten werden nicht mit Daten von natürlichen Personen zusammengeführt.
          Beispielsweise werden technische Informationen zur Browserausstattung erfasst,
          nicht aber personenbezogene Informationen wie Namen, Straßennamen, oder
          ähnliches, die einen Rückschluss auf eine konkrete Person ermöglichen. Aufgrund
          der sofortigen Anonymisierung der IP-Adresse werden keine personenbezogenen
          Daten erfasst, so dass eine Rückführbarkeit auf einzelne Personen technisch
          nicht möglich ist.
        </p>
        <p>
          Weitere Informationen zur Verarbeitung Ihrer personenbezogenen Daten finden Sie
          in der Datenschutzerklärung von DYMATRIX
          <a href="https://www.dymatrix.de/de/datenschutz">hier</a>.
        </p>
        <p>
          Wir nutzen die Analysedienste von DYMATRIX, um die Nutzung unserer Webseite zu
          analysieren und unsere Webseite kontinuierlich im Sinne der Nutzerfreundlichkeit
          weiter-entwickeln zu können. Außerdem nutzen wir die Dienste von DYMATRIX , um
          Ihnen nur relevante, das heißt Ihren mutmaßlichen Interessen entsprechende
          Werbung anzeigen zu können. Grundlage für die Nutzung der Dienste ist Ihre
          Einwilligung im Sinne von Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Rechtsgrundlage für
          den Einsatz von Cookies oder ähnlichen Technolo-gien auf Ihrem Endgerät ist § 25
          Abs. 1 TDDDG. Sie können Ihre Einwilligung in die Verwen-dung Ihrer Daten
          jederzeit mit Wirkung für die Zukunft widerrufen. Dazu können Sie Ihre
          Einstellungen oben im Abschnitt Cookies entsprechend anpassen.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>10. Conversion-Tracking mit Dynamic Tracking System<br /></strong
          ></span>
        </p>
        <p>
          Mit Ihrer Zustimmung wird auf unserer Webseite der Dienst Dynamic Tracking
          System eingesetzt, der von der Dynamic 1001 GmbH, Im Medienpark 8, 50670 Köln
          ("Dynamic 1001"), angeboten wird.
        </p>
        <p>
          Das Dynamic Tracking System ist ein sog. "Multi-Channel-Tracking-Tool", durch
          das wir ermitteln können, welchem Werbenetzwerk bzw. Werbepartner (auch als
          "Werbekanal" bezeichnet) ein erfolgreicher Verkaufsabschluss zuzurechnen ist.
          Diese Informationen werden benötigt, damit wir diesen Werbepartnern eine
          korrekte Provision auszahlen können. Die gewonnenen Informationen können durch
          Dynamic 1001 zudem statistisch ausgewertet und aufbereitet werden, sodass wir
          einen Überblick darüber erhalten, wie leistungsfähig unsere einzelnen
          Werbekanäle sind. Dies hilft uns dabei, unsere Marketingstrategie zu verbessern.
        </p>
        <p>
          Das Dynamic Tracking System verknüpft die Interaktion der Kund:innen auf unserer
          Webseite, etwa die Bestellung eines Produktes, mit den vorherigen Kontakten der
          Kund:innen (etwa Sichtkontakten oder Klicks) zu den von unseren Werbepartnern
          ausgespielten Werbemitteln. Dies wird auch als "Conversion-Tracking" bezeichnet.
          Hierbei können auch unterschiedliche Werbekanäle (etwa Affiliate-Links,
          Bannerwerbung, Werbung in Newslettern) erfasst werden. Die verschiedenen
          Kontakte, die der Kunde im Vorfeld einer Bestellung auf unserer Webseite zu den
          unterschiedlichen Werbemitteln und Werbekanälen hatte, können durch Dynamic 1001
          in einer Übersicht aufbereitet werden (sog. "Customer Journey").
        </p>
        <p>
          Interagieren die Kund:innen mit einem Werbemittel, etwa durch Klick auf den
          Affiliate-Link von einem unserer Werbepartner, setzt Dynamic 1001 einen Cookie
          auf dem Endgerät (im Browser) der Kund:innen. Der Cookie enthält einen
          individuellen Identifizierungswert ("Cookie-ID"). Besuchen die Kund:innen im
          Anschluss unsere Webseite, werden verschiedene Informationen zum verwendeten
          Browser erhoben und an Dynamic 1001 übermittelt. Hierzu gehören insbesondere die
          verwendete Browserversion, das Betriebssystem, die Browsereinstellungen
          (Sprache), die Referrer-URL, die verkürzte IP-Adresse des Endgeräts sowie die
          Cookie-ID. Die IP-Adresse wird nur verkürzt übermittelt und gespeichert, sodass
          ein Personenbezug auf Grundlage dieser verkürzten IP-Adresse nicht mehr
          hergestellt werden kann. Kommt es zu einer Bestellung auf unserer Webseite,
          werden außerdem Informationen zu dieser Bestellung, etwa die Bestellnummer, der
          Warenkorb und die Bestellwerte, an Dynamic 1001 übermittelt. Die Übermittlung
          dieser Daten erfolgt mithilfe eines sog. Pixels, der auf unserer Webseite
          eingebunden ist und einen Kontakt zu den Servern von Dynamic 1001 herstellt. Die
          übermittelten Informationen werden von Dynamic 1001 ausschließlich auf Servern
          in Deutschland gespeichert.
        </p>
        <p>
          Mithilfe der übermittelten Cookie-ID kann Dynamic 1001 den Verkaufsabschluss
          einem oder mehreren Werbepartnern zuordnen. Dynamic 1001 informiert hiernach das
          entsprechende Werbenetzwerk über den Verkaufsabschluss, die Bestellnummer und
          Bestellwerte. Auf dieser Grundlage kann die Höhe der Provision ermittelt werden.
          Zudem kann Dynamic 1001 die übermittelten Informationen statistisch auswerten
          und uns diese Auswertung in einem Bericht zur Verfügung stellen.
        </p>
        <p>
          Wir haben mit Dynamic 1001 einen Vertrag über Auftragsverarbeitung im
          Zusammenhang mit der Verwendung des Dynamic Tracking Systems geschlossen. Die
          vom Dynamic Tracking System erhobenen Informationen werden von Dynamic 1001 auf
          der Grundlage dieses Auftrags gemäß unseren Weisungen verarbeitet. Die
          Weiterleitung der erhobenen Informati-onen an Dynamic 1001 und die dortige
          Datenverarbeitung erfolgt somit in unserem Auftrag gemäß Art. 28 DSGVO.
        </p>
        <p>
          Sie können das Setzen von Cookies in den Einstellungen Ihres Browsers verhindern
          und bereits gesetzte Cookies löschen. Die von Dynamic 1001 eingesetzten Cookies
          haben eine Laufzeit von höchstens zwei Jahren nach dem Kontakt und werden
          anschließend automatisch gelöscht.
        </p>
        <p>
          Weitere Informationen zum Datenschutz bei Dynamic 1001 finden Sie unter:&nbsp;<a
            href="https://dynamic-tracking.com/Datenschutz.aspx"
            target="_blank"
            rel="noopener noreferrer"
            >https://dynamic-tracking.com/Datenschutz.aspx</a
          >.
        </p>
        <p>
          Die Nutzung des Dynamic Tracking Systems erfolgt nur mit Ihrer Einwilligung auf
          Grundlage von Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Rechtsgrundlage für den Einsatz
          von Cookies oder ähnlichen Technologien auf Ihrem Endgerät ist § 25 Abs. 1
          TDDDG. Ihre Einwilligungen können Sie bezüglich Ihres jeweils verwendeten
          Endgeräts jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie Ihre
          Einstellungen oben im Abschnitt Cookies anpassen.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>11.&nbsp;</strong><strong>TikTok Pixel</strong></span
          >
        </p>
        <p>
          Wir setzen auf unserer Webseite auch den TikTok Pixel ein. Dieser Dienst wird
          von der TikTok Information Technologies UK Limited, 4 Lindsey Street, Barbican,
          London, EC1A 9HP, Vereinigtes Königreich und TikTok Technology Limited, 10
          Earlsfort Terrace, Dublin, D02 T380, Irland("TikTok") angeboten. Über diesen
          Dienst wird Ihnen, wenn Sie unsere Webseite besuchen und damit Interesse an
          unseren Angeboten signalisiert haben, auf den Webseiten von TikTok oder dessen
          Partnern gezielt Werbung zu unseren Angeboten angezeigt. Hierfür wird beim
          Besuch unserer Webseite ein Cookie (sog. "TikTok Pixel") auf Ihrem Endgerät
          gesetzt. Pixel sind Cookie-Elemente, welche die Kommunikation zwischen Browser
          und Server ermöglichen. Mit diesem TikTok Pixel kann zugeordnet werden, dass Sie
          unsere Webseite bereits besucht haben. Darüber hinaus können wir das Verhalten
          der Besucher:innen auswerten, welche von einer TikTok-Werbung auf diese Webseite
          gelangt sind. Dies kann zur Verbesserung von TikTok-Werbeanzeigen genutzt werden
          und insbesondere verhindern, dass Sie mit unpassender Werbung belästigt werden,
          die für Sie nicht relevant ist. Zu diesen Zwecken werden Informationen über Ihre
          Aktivitäten auf unserer Webseite (sog. Event-Informationen), Ihre IP-Adresse,
          Datum und Uhrzeit des Events und Informationen zu Ihrem Endgerät an TikTok
          übermittelt. Das TikTok Pixel und die damit erhobenen Informationen werden an
          Server von TikTok, die sich auch in Ländern außerhalb der EU bzw. des EWR, wie
          z.B. in den USA oder Singapur, befinden können, übermittelt und dort
          gespeichert.
        </p>
        <p>
          Wenn Sie auf unsere Webseite zugreifen, während Sie in Ihrem TikTok-Konto
          angemeldet sind, verknüpft TikTok die über das TikTok Pixel gesammelten
          Informationen auch mit Ihrem TikTok-Konto. TikTok kann die gesammelten
          Informationen für geräteübergreifendes Tracking und Marketing verwenden.
          Insbesondere können auf Grundlage Ihrer Nutzung unserer Webseite auf einem
          Endgerät unsere Werbeanzeigen auch dann an Sie ausgespielt werden, wenn Sie auf
          einem anderen Endgerät im Internet browsen. Für uns sind Ihre Daten jedoch
          anonym, so dass wir Sie nicht persönlich identifizieren können.
        </p>
        <p>
          Weitere Informationen zur Verarbeitung Ihrer personenbezogenen Daten und zum
          Datenschutz durch TikTok finden Sie in der Datenschutzerklärung von TikTok
          unter:
          <a href="https://www.tiktok.com/legal/privacy-policy-eea?lang=de"
            >https://www.tiktok.com/legal/privacy-policy-eea?lang=de</a
          >
        </p>
        <p>
          Die vorstehend beschriebene Datenverarbeitung beruht auf Ihrer Einwilligung in
          die Speicherung von Cookies auf Ihrem Endgerät und dem Zugriff auf die Cookies,
          die bereits auf Ihrem Endgerät gespeichert sind, sowie in die anschließende
          Datenverarbeitung durch TikTok. Rechtsgrundlage für unsere Nutzung des TikTok
          Pixel ist daher bezüglich der Speicherung von und dem Zugriff auf den TikTok
          Pixel § 25 Abs. 1 TDDDG sowie bezüglich der weiteren Verarbeitung der Daten Art.
          6 Abs. 1 S. 1 lit. a) DSGVO. Für die Übermittlung von personenbezogenen Daten in
          Länder außerhalb der EU bzw. des EWR setzt TikTok Maßnahmen für ein angemessenes
          Schutzniveau im Sinne der Art. 44 ff. DSGVO um, auf deren Grundlage die
          Übermittlung erfolgt. So hat TikTok nach eigenen Angaben die
          Standardvertragsklauseln der EU-Kommission gemäß Art. 46 Abs. 2 lit. c) DSGVO
          abgeschlossen und technische Schutzmaßnahmen für einen angemessenen Schutz der
          Daten auch in diesen Ländern ergriffen.
        </p>
        <p>
          Soweit personenbezogene Daten durch das TikTok Pixel erhoben und an TikTok
          übermittelt werden, sind wir und TikTok hinsichtlich dieser Erhebung und
          Übermittlung gemeinsam Verantwortliche im Sinne des Art. 26 DSGVO. Die weitere
          Verarbeitung der Daten nach deren Übermittlung erfolgt ausschließlich in der
          Verantwortlichkeit von TikTok. Weitere Informationen dazu finden Sie in der
          Vereinbarung zur gemeinsamen Verantwortlichkeit unter:
          <a
            href="https://www.tiktok.com/legal/page/global/tiktok-analytics-joint-controller-addendum/en"
            >https://www.tiktok.com/legal/page/global/tiktok-analytics-joint-controller-addendum/en</a
          >
        </p>
        <p>
          Sie können Ihre Einwilligung in die oben beschriebene Verarbeitung Ihrer Daten
          durch den TikTok-Pixel jederzeit mit Wirkung für die Zukunft widerrufen. Dazu
          können Sie Ihre Einstellungen oben im Abschnitt Cookies entsprechend anpassen.
        </p>
        <p>
          Außerdem können Sie auf folgender Seite der Netzwerkwerbeinitiative die
          Verwendung von Cookies durch Drittanbieter deaktivieren:
          <a href="http://optout.networkadvertising.org/?c=1"
            >http://optout.networkadvertising.org/?c=1</a
          >
        </p>
        <p>&nbsp;&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>12. Webanalyse mit Google Analytics<br /></strong
          ></span>
        </p>
        <p>
          Diese Webseite benutzt Google Analytics, einen Webanalysedienst der Google
          Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland ("Google").
          Google Analytics verwendet Cookies, die eine Analyse des Aufrufs der Webseite
          und der anschließenden Benutzung der Webseite durch Sie ermöglichen. Die Cookies
          bleiben höchstens 2 Jahre auf Ihrem Computer gespeichert. Die durch die Cookies
          erzeugten Informationen über Ihre Benutzung dieser Webseite werden in der Regel
          an einen Server von Google in den USA übertragen und dort gespeichert. Wir
          verwenden Google Analytics zusammen mit der Erweiterung "_anonymizehelp()", um
          eine anonymisierte Erfassung von IP-Adressen (sog. IP-Masking) zu gewährleisten.
          Durch Aktivierung dieser Erweiterung für unsere Webseite wird Ihre IP-Adresse
          von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen
          Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der
          Übermittlung an einen Server von Google in den USA gekürzt. In unserem Auftrag
          benutzt Google diese Informationen, um Ihre Nutzung der Webseite auszuwerten, um
          Reports über die Webseitenaktivitäten zusammenzustellen und um weitere mit der
          Webseitennutzung und der Internetnutzung verbundene Dienstleistungen uns
          gegenüber zu erbringen, wie die Auswertung der Wege, über die Besucher auf
          unsere Webseite gelangen. Die im Rahmen von Google Analytics von Ihrem Browser
          übermittelte IP-Adresse wird nicht mit anderen auf Sie bezogenen Daten von
          Google zusammengeführt.
        </p>
        <p>
          Sie können die Speicherung der Cookies durch eine entsprechende Einstellung
          Ihrer Browser-Software verhindern; wir weisen Sie jedoch nochmals darauf hin,
          dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser
          Webseite vollumfänglich werden nutzen können. Sie können darüber hinaus die
          Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Webseite
          bezogenen personenbezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
          Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem
          folgenden Link verfügbare Browser-Plugin herunterladen und installieren:
          <a
            href="https://tools.google.com/dlpage/gaoptout?hl=de"
            target="_blank"
            rel="noopener noreferrer"
            >http://tools.google.com/dlpage/gaoptout?hl=de</a
          >
        </p>
        <p>
          Wir nutzen auf dieser Webseite die Funktion „Google-Signale“. Hierbei handelt es
          sich um eine Erweiterung von Google Analytics, die ein geräteübergreifendes
          Tracking ermöglicht.
        </p>
        <ul>
          <li>
            Verknüpfung von Web- und App-Aktivitäten: Sofern Sie in Ihrem Google-Konto die
            Option „Personalisierte Werbung“ aktiviert haben, erfasst Google Informationen
            über Ihre Nutzung unserer Webseite auf verschiedenen Endgeräten. Diese Web-
            und App-Aktivitäten werden von Google mit den Informationen aus Ihrem
            Google-Konto verknüpft, um uns anonymisierte Statistiken und Berichte (z.B. zu
            geräteübergreifenden Conversions oder Zielgruppen) bereitzustellen.<br />&nbsp;
          </li>
        </ul>
        <ul>
          <li>
            Einwilligung und Widerruf: Diese Datenverknüpfung erfolgt ausschließlich auf
            Grundlage Ihrer ausdrücklichen Einwilligung im Sinne des Art. 6 Abs. 1 S. 1
            lit. a) DSGVO, die Sie über unseren Consent-Banner erteilt haben.<br />&nbsp;
          </li>
        </ul>
        <ul>
          <li>
            Kontrolle durch den Nutzer („Meine Aktivitäten“): Sie haben jederzeit die
            volle Kontrolle über diese Daten. Wenn Sie nicht möchten, dass Google Ihre
            Aktivitäten mit Ihrem Konto verknüpft, können Sie dies in den Einstellungen
            Ihres Google-Kontos deaktivieren. Zudem können Sie Ihre gespeicherten Daten
            jederzeit unter dem Link
            <a href="https://myactivity.google.com">https://myactivity.google.com</a>
            einsehen, manuell verwalten oder dauerhaft löschen.<br />&nbsp;
          </li>
        </ul>
        <p>
          Google verarbeitet die durch Google Analytics erfassten Daten auch im Umfang
          gemäß der eigenen Datenschutzerklärung, die Sie unter folgendem Link finden:
          <a
            href="https://policies.google.com/privacy?hl=de"
            target="_blank"
            rel="noopener noreferrer"
            >https://policies.google.com/privacy?hl=de</a
          >. In der Google-Datenschutzerklärung finden Sie auch weitere Informationen zum
          Umgang mit Nutzerdaten bei Google Analytics. Details, insbesondere auch zu Ihren
          Betroffenenrechten, finden Sie zudem unter:
          <a
            href="https://privacy.google.com/businesses/processorterms/"
            target="_blank"
            rel="noopener noreferrer"
            >https://privacy.google.com/businesses/processorterms/</a
          >.
        </p>
        <p>
          Im Zusammenhang mit den oben genannten Funktionen kann Google die dabei
          verarbeiteten Daten auch an Server außerhalb der EU, insbesondere der Google LLC
          in den USA, übermitteln, soweit dies zur Erbringung dieser Dienste notwendig
          ist. Die Google LLC ist unter dem EU-US Data Privacy Framework (DPF)
          zertifiziert und in die vom U.S. Department of Commerce geführte Liste (Data
          Privacy Framework List) eingetragen. Bei der Übermittlung von Daten an Server
          von Google in den USA ist daher ein durchgängig hohes Datenschutzniveau
          gewährleistet. Soweit eine Übermittlung der Daten in die USA erfolgt, basiert
          ein solcher Drittlandtransfer auf Art. 45 Abs. 1 S. 1 DSGVO.
        </p>
        <p>
          Wir aktivieren Google Analytics nur, wenn Sie in die Verarbeitung Ihrer Daten
          durch den Google Analytics-Dienst einwilligen. Rechtsgrundlage für unsere
          Nutzung von Google Analytics ist daher Art. 6 Abs. 1 S. 1 lit. a) DSGVO.
          Rechtsgrundlage für den Einsatz von Cookies oder ähnlichen Technologien auf
          Ihrem Endgerät ist § 25 Abs. 1 TDDDG. Sie können eine bereits erteilte
          Einwilligung für Ihren jeweiligen Computer jederzeit mit Wirkung für die Zukunft
          widerrufen, indem Sie Ihre Einstellungen oben im Abschnitt Cookies anpassen.
        </p>
        <p>&nbsp;&nbsp;</p>
        <p>
          <span class="text-base"><strong>13. Geolokation</strong></span>
        </p>
        <p>
          Diese Webseite benutzt zur Kartenanzeige die Google Maps API, einen Kartendienst
          zur Darstellung einer interaktiven Karte ("Google Maps"), den Google anbietet.
          Durch die Nutzung von Google Maps können Informationen über Ihre Benutzung
          dieser Webseite (einschließlich Ihrer IP-Adresse) an Google, möglicherweise auch
          an einen Server außerhalb der Europäischen Union wie die USA übertragen und dort
          gespeichert werden. Google wird die hierdurch gewonnenen Informationen
          gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben ist
          oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Google wird in
          keinem Fall Ihre IP-Adresse mit anderen Daten von Google in Verbindung bringen.
          Trotzdem wäre es technisch möglich, dass Google aufgrund der erhaltenen Daten
          eine Identifizierung zumindest einzelner Nutzenden vornehmen könnte.
          Einzelheiten zum Datenschutz bei Google, insbesondere zu Art, Umfang und Zweck
          der Datenverarbeitung, finden Sie unter:
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            >https://policies.google.com/privacy</a
          >.
        </p>
        <p>
          Sie haben die Möglichkeit, den Service von Google Maps auf einfache Art und
          Weise zu deaktivieren und somit den Datentransfer an Google zu verhindern:
          Deaktivieren Sie dazu JavaScript in Ihrem Browser. Wir weisen Sie jedoch darauf
          hin, dass Sie in diesem Fall die Kartenanzeige nicht nutzen können.
        </p>
        <p>
          Die Übermittlung an Google im Zusammenhang mit Google Maps basiert auf Art. 45
          Abs. 1 S. 1 DSGVO; die Einzelheiten können Sie in unseren Erläuterungen zur
          Datenverarbeitung im Zusammenhang mit Google Analytics erfahren.
        </p>
        <p>
          Wir verwenden Google Maps, um die Nutzerfreundlichkeit unserer Webseite zu
          verbessern. Grundlage für die Nutzung von Google Maps ist Art. 6 Abs. 1 S. 1
          lit. f) DSGVO. Unser berechtigtes Interesse ist die Optimierung unserer Webseite
          und die Gewährleistung bestmöglicher Nutzerfreundlichkeit.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>14. Geo-Lokalisierung für den Fachmarkt-Finder</strong></span
          >
        </p>
        <p>
          Zur Bereitstellung standortbezogener Inhalte und Services nutzen wir auf unserer
          Webseite einen Fachmarkt-Finder, mit dessen Hilfe Ihnen der für Ihren Standort
          nächstgelegene Fachmarkt zugeordnet werden kann.
        </p>
        <p>
          Beim Besuch unserer Webseite wird Ihnen zunächst automatisch ein Fachmarkt auf
          Grundla-ge Ihres ungefähren Standorts zugeordnet. Hierfür nutzen wir eine
          IP-basierte Standortermittlung über unseren Dienstleister Cloudflare (siehe dazu
          den Abschnitt "Cloudflare" in dieser Datenschutzerklärung). Dabei wird anhand
          Ihrer IP-Adresse lediglich ein ungefährer geografischer Standort ermittelt, der
          zur Bestimmung des nächstgelegenen Fachmarkts verwendet wird. Eine Ermittlung
          Ihres exakten Standorts erfolgt hierbei nicht.
        </p>
        <p>
          Alternativ können Sie sich selbst einem Fachmarkt zuordnen lassen. Hierzu können
          Sie im Fachmarkt-Finder Ihre Postleitzahl oder Ihren Ort eingeben. Auf Basis
          dieser Angaben wird der geografisch nächstgelegene Fachmarkt ermittelt und Ihnen
          zugeordnet.
        </p>
        <p>
          Darüber hinaus haben Sie die Möglichkeit, Ihren aktuellen Standort über die
          Standortfunktion Ihres Browsers ermitteln zu lassen. Hierfür wird Ihre
          ausdrückliche Zustimmung über den von Ihrem Browser bereitgestellten Dialog zur
          Standortfreigabe eingeholt. Nur wenn Sie dieser Standortermittlung zustimmen,
          werden die vom Browser bereitgestellten Standortdaten (Breiten- und Längengrad)
          verwendet, um den nächstgelegenen Fachmarkt präziser zu bestimmen. Wird dabei
          ein anderer Fachmarkt ermittelt als durch die zuvor erfolgte IP-basierte
          Zuordnung, wird die Fachmarktzuordnung entsprechend aktualisiert.
        </p>
        <p>
          Erfolgt weder eine Standortfreigabe noch eine manuelle Eingabe, bleibt die
          Fachmarktzuordnung auf Basis der IP-basierten Standortermittlung bestehen.
        </p>
        <p>
          Im Zusammenhang mit dem Fachmarkt-Finder wird ein Cookie gesetzt, in dem die
          ermittelte bzw. von Ihnen ausgewählte Fachmarktzuordnung gespeichert wird. Dies
          dient dazu, dass Sie bei einem späteren Besuch unserer Webseite nicht erneut
          Ihren Fachmarkt auswählen müssen. Das Cookie wird 30 Tage gespeichert und dient
          ausschließlich der Speicherung Ihrer Auswahl und der Verbesserung der
          Nutzerfreundlichkeit.
        </p>
        <p>
          Wir nutzen die Fachmarktzuordnung, um Ihnen die Verfügbarkeit von Produkten,
          fachmarktspezifische Preise sowie weitere standortbezogene Services anzeigen zu
          können. Darüber hinaus ermöglicht die Zuordnung die Online-Reservierung von
          Produkten zur Abholung in Ihrem zugeordneten Fachmarkt.
        </p>
        <p>
          Soweit die Fachmarktzuordnung auf der IP-basierten Standortermittlung oder einer
          manuellen Eingabe beruht, erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs.
          1 Satz 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der Bereitstellung
          standortbezogener Inhalte und Services sowie einer nutzerfreundlichen
          Darstellung unseres Angebots. Rechtsgrundlage für den Einsatz von Cookies oder
          ähnlichen Technologien auf Ihrem Endgerät ist § 25 Abs. 2 Nr. 2 TDDDG.
        </p>
        <p>
          Soweit Sie die Ermittlung Ihres Standorts über die Standortfunktion Ihres
          Browsers freigeben, basiert die Verarbeitung der vom Browser bereitgestellten
          Standortdaten auf Ihrer Einwilligung gemäß Art. 6 Abs. 1 Satz 1 lit. a) DSGVO.
          Rechtsgrundlage für den Einsatz von Cookies oder ähnlichen Technologien auf
          Ihrem Endgerät ist ebenfalls Ihre Einwilligung gemäß § 25 Abs. 1 TDDDG. Sie
          können eine erteilte Einwilligung jederzeit über die Einstellungen Ihres
          Browsers oder Ihres Endgeräts für die Zukunft widerrufen.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>15. Erkennungsdienst reCAPTCHA</strong></span
          >
        </p>
        <p>
          Um für ausreichend Datensicherheit bei der Übermittlung von Formularen Sorge zu
          tragen, verwenden wir in bestimmten Fällen den Service reCAPTCHA von Google.
          Dies dient vor allem zur Unterscheidung, ob die Eingabe durch eine natürliche
          Person erfolgt oder missbräuchlich durch maschinelle und automatisierte
          Verarbeitung. Dazu nutzt reCAPTCHA auch Cookies. Der Service inkludiert den
          Versand der IP-Adresse, der Cookies und ggf. weiterer von Google für den Dienst
          reCAPTCHA benötigter Daten und Ihrer Eingaben, zu denen reCAPTCHA Sie
          auffordert, an Google. Hierfür gelten die abweichenden Datenschutzbestimmungen
          von Google. Weitere Informationen zu den Datenschutzrichtlinien von Google
          finden Sie unter
          <a
            href="https://policies.google.com/privacy?hl=de"
            target="_blank"
            rel="noopener noreferrer"
            >https://policies.google.com/privacy?hl=de</a
          >.
        </p>
        <p>
          Wir verwenden Google reCAPTCHA ausschließlich zur Aufdeckung und Verhinderung
          einer rechtswidrigen Nutzung unserer Webseite auf der Grundlage von Art. 6 Abs.
          1 S. 1 lit. f) DSGVO. Unser berechtigtes Interesse ist die Gewährleistung der
          Sicherheit unseres Angebots und die Verhinderung einer missbräuchlichen Nutzung.
          Rechtsgrundlage für den Einsatz von Cookies oder ähnlichen Technologien auf
          Ihrem Endgerät ist § 25 Abs. 2 Nr. 2 TDDDG.
        </p>
        <p>
          Im Zusammenhang mit den oben genannten Funktionen kann Google die dabei
          verarbeiteten Daten auch an Server außerhalb der EU, insbesondere der Google LLC
          in den USA, übermitteln, soweit dies zur Erbringung dieser Dienste notwendig
          ist. Die Übermittlung basiert auf Art. 45 Abs. 1 S. 1 DSGVO. Es wird insoweit
          auf die Ausführungen zu Drittlandtransfers im Abschnitt zu Google Analytics
          verwiesen.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >16. Facebook Custom Audiences, Facebook Pixel, Campaign Parameter</strong
            ></span
          >
        </p>
        <p>
          Wir setzen auf unserer Webseite auch den Dienst Meta Custom Audiences ein.
          Dieser Dienst wird von der Meta Platforms Ireland Limited, 4 Grand Canal Square,
          Grand Canal Harbour, Dublin 2, Irland („Meta") angeboten. Über diesen Dienst
          wird Ihnen, wenn Sie unsere Webseite besucht und damit Interesse an unseren
          Angeboten signalisiert haben, auf den Webseiten von Meta oder dessen Partnern
          gezielt Werbung zu unseren Angeboten angezeigt. Hierfür wird beim Besuch unserer
          Webseite ein sog. „Meta Pixel" auf Ihrem Endgerät gesetzt. Pixel sind
          Cookie-Elemente, welche die Kommunikation zwischen Browser und Server
          ermöglichen. Mit diesem Meta Pixel kann zugeordnet werden, dass Sie unsere
          Webseite bereits besucht haben. Darüber hinaus können wir das Verhalten der
          Besucher:innen auswerten, welche von einer Meta-Werbung auf diese Webseite
          gelangt sind. Dies kann zur Verbesserung von Meta-Werbeanzeigen genutzt werden
          und insbesondere um zu verhindern, dass Sie mit unpassender Werbung belästigt
          werden, die für Sie nicht relevant ist.
        </p>
        <p>
          Wenn Sie auf unsere Webseite zugreifen, während Sie bei einem Meta-Dienst (z.B.
          Facebook oder Instagram) angemeldet sind, verknüpft Meta die über das Meta Pixel
          gesammelten Informationen auch mit Ihrem Meta-Konto. Meta kann die gesammelten
          Informationen für geräteübergreifendes Marketing verwenden. Insbesondere können
          auf Grundlage Ihrer Nutzung unserer Webseite auf einem Endgerät unsere
          Werbeanzeigen auch dann an Sie ausgespielt werden, wenn Sie auf einem anderen
          Endgerät im Internet browsen. Für uns sind Ihre Daten jedoch anonym, so dass wir
          Sie nicht persönlich identifizieren können.
        </p>
        <p>
          Weiterhin setzen wir die KI-gestützte Datenanreicherungsfunktion des Meta Pixels
          ein. Mit dieser Funktion analysiert das Meta Pixel beim Besuch unserer Webseite
          automatisch die jeweiligen Seiteninhalte und erfasst dabei zusätzliche Produkt-
          und Seiteninformationen, insbesondere Produktnamen, Produktpreise,
          Währungsangaben, Produktverfügbarkeit sowie Unternehmensname und Standort. Dies
          kann zur Verbesserung unserer Werbeanzeigen genutzt werden und insbesondere
          dazu, Ihnen passendere und relevantere Werbung zu unseren Angeboten anzuzeigen.
          Die dabei erfassten Informationen werden gemeinsam mit den übrigen vom Meta
          Pixel erzeugten Daten an Server von Meta übermittelt und dort gespeichert.
        </p>
        <p>
          Darüber hinaus setzen wir bei unseren Werbeanzeigen, die wir über Meta schalten,
          den sog. Campaign Parameter (auch „URL-Parameter" genannt) ein. Hierbei wird bei
          Erstellung der Werbeanzeige deren URL um ein Text-Kürzel erweitert, in dem von
          uns definierte Parameter enthalten sind, die uns Rückschlüsse über die
          Effektivität unserer Werbeanzeigen erlauben. So können wir nicht nur sehen, dass
          Besucher:innen unserer Webseite durch den Klick auf eine Meta-Werbeanzeige zu
          uns gelangt sind, sondern wir können auch nachvollziehen, durch welche Kampagne
          bzw. welchen Meta-Beitrag Nutzer:innen den Weg zu uns gefunden haben.
        </p>
        <p>
          Im Rahmen des Einsatzes des Meta Pixels werden auch Cookies gesetzt, die eine
          Speicherdauer von höchstens 3 Monaten haben. Dadurch können wir feststellen,
          welche unserer Anzeigen oder Werbekampagnen erfolgreich sind, und diese besser
          an den Interessen unserer Nutzer:innen und potentiellen Kund:innen ausrichten.
          Wir können allerdings nicht erkennen, welche Person im Einzelnen auf eine
          Anzeige geklickt hat, sondern erhalten diese Daten nur in aggregierter Form. Sie
          bleiben als Nutzer:in oder Besucher:in unserer Webseite für uns also anonym,
          selbst wenn Sie auf eine unserer Werbeanzeigen klicken, bei der wir den
          Campaign-Parameter eingesetzt haben.
        </p>
        <p>
          Soweit personenbezogene Daten durch das Meta Pixel erhoben und an Meta
          übermittelt werden, sind wir und Meta hinsichtlich dieser Erhebung und
          Übermittlung gemeinsam Verantwortliche im Sinne des Art. 26 DSGVO. Die weitere
          Verarbeitung der Daten nach deren Übermittlung erfolgt ausschließlich in der
          Verantwortlichkeit von Meta. Weitere Informationen dazu finden Sie in der
          Vereinbarung zur gemeinsamen Verantwortlichkeit unter:
          <a href="https://de-de.facebook.com/legal/controller_addendum"
            >https://de-de.facebook.com/legal/controller_addendum</a
          >.
        </p>
        <p>
          Weitere Informationen zur Verarbeitung Ihrer personenbezogenen Daten und zum
          Datenschutz durch Meta finden Sie in der Datenschutzerklärung von Meta unter:<br /><a
            href="https://www.facebook.com/privacy/policy"
            >https://www.facebook.com/privacy/policy</a
          >.
        </p>
        <p>
          Rechtsgrundlage der vorstehend beschriebenen Datenverarbeitung ist Art. 6 Abs. 1
          S. 1 lit. a) DSGVO, d.h. Ihre erteilte Einwilligung. Rechtsgrundlage für den
          Einsatz von Cookies oder ähnlichen Technologien auf Ihrem Endgerät ist ebenfalls
          Ihre Einwilligung gemäß § 25 Abs. 1 TDDDG. Sie können Ihre Einwilligungen in die
          Verwendung Ihrer Daten für die vorgenannten Meta-Dienste jederzeit mit Wirkung
          für die Zukunft widerrufen. Dazu können Sie Ihre Einstellungen oben im Abschnitt
          Cookies entsprechend anpassen.
        </p>
        <p>
          Im Zusammenhang mit den oben genannten Funktionen kann Meta die dabei
          verarbeiteten Daten auch an Server außerhalb der EU, insbesondere der Meta
          Platforms, Inc. in den USA, übermitteln, soweit dies zur Erbringung dieser
          Dienste notwendig ist. Die Meta Platforms, Inc. ist unter dem EU-US Data Privacy
          Framework (DPF) zertifiziert und in die vom U.S. Department of Commerce geführte
          Liste (DPF List) eingetragen. Bei der Übermittlung von Daten an Server von Meta
          in den USA ist daher ein durchgängig hohes Datenschutzniveau gewährleistet.
          Soweit eine Übermittlung der Daten in die USA erfolgt, basiert ein solcher
          Drittlandtransfer auf Art. 45 Abs. 1 S. 1 DSGVO.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>17. Keine automatisierte Entscheidung</strong></span
          >
        </p>
        <p>
          Eine automatisierte Entscheidungsfindung einschließlich Profiling gemäß Art. 22
          Abs. 1 und 4 DSGVO findet seitens expert nicht statt.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>18. Gewinnspiele<br /></strong
          ></span>
        </p>
        <p>
          Um an einem Gewinnspiel teilnehmen zu können, ist es unerlässlich, persönliche
          Informationen zu übermitteln, wie z.B. Vor- und Nachname, E-Mail-Adresse
          und/oder Anschrift. Die erhobenen personenbezogenen Daten werden ausschließlich
          zum Zweck der Durchführung und Abwicklung des Gewinnspiels bspw. für die
          Gewinnermittlung, Gewinnbenachrichtigung und Zusendung verwendet. Eine
          Veröffentlichung der Namen oder des Wohnorts des Gewinners findet nicht statt.
        </p>
        <p>
          Ihre Teilnahme an einem Gewinnspiel ist selbstverständlich freiwillig. In den
          Teilnahmebedingungen für das jeweilige Gewinnspiel werden Sie sowohl über die
          zur Teilnahme am Gewinnspiel erforderlichen Daten als auch darüber informiert,
          ob das Gewinnspiel von expert oder einem bestimmten expert-Händler durchgeführt
          wird. Sofern Sie sich dann zu einer Teilnahme entschließen, erteilen Sie uns
          eine Einwilligung in die Verarbeitung Ihrer dafür erforderlichen
          personenbezogenen Daten. Dabei erklären Sie sich ausdrücklich damit
          einverstanden, dass expert die zur Gewinnspielteilnahme erforderlichen Daten für
          die Dauer des Gewinnspiels speichert und zum Zwecke der Gewinnabwicklung – falls
          notwendig – an den jeweiligen Kooperationspartner übermittelt, welcher die
          Personenangaben ebenfalls für die Dauer des Gewinnspiels speichern darf. Auf die
          Erteilung der Einwilligung werden Sie bei der Teilnahme gesondert hingewiesen.
          Die Datenverarbeitung erfolgt sodann aufgrund Ihrer Einwilligung gemäß Art. 6
          Abs. 1 S. 1 lit. a) DSGVO. Es steht Ihnen jederzeit frei, per Widerruf unter
          <a href="mailto:datenschutz@expert.de">datenschutz@expert.de</a> die
          Einwilligung in die Datenverarbeitung aufzuheben und somit von der Teilnahme
          zurückzutreten.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>19. Newsletterdaten<br /></strong
          ></span>
        </p>
        <p>
          Wenn Sie den auf der Webseite angebotenen Newsletter beziehen möchten, benötigen
          wir von Ihnen eine gültige E-Mail-Adresse sowie Ihre Anrede und den Vor- und
          Nachnamen. Um überprüfen zu können, dass Sie der Inhaber der angegebenen
          E-Mail-Adresse und mit dem Empfang des Newsletters einverstanden sind, versenden
          wir nach der Anmeldung zum Newsletter zunächst eine E-Mail an die angegebene
          E-Mail-Adresse, die einen Bestätigungslink für die Anmeldung zum Newsletter
          erhält. Erst nachdem Sie Ihre Anmeldung hierzu durch einen Klick auf den
          zugesandten Link bestätigt haben, ist Ihre Anmeldung wirksam (sog.
          Double-Opt-In-Verfahren). Weitere Daten werden für den Newsletterversand nicht
          erhoben. Diese Daten verwenden wir ausschließlich für den Versand der
          angeforderten Newsletter mit Informationen über das Angebot und die Aktionen von
          expert und geben sie nicht an Dritte weiter.<br />
          &nbsp;<br />Rechtsgrundlage der Datenverarbeitung im Zusammenhang mit dem
          Newsletter inklusive der Messung der Öffnungsraten, der Klickraten sowie die
          Speicherung der Messdaten ist Ihre Einwilligung (Art. 6 Abs. 1 S. 1 lit. a)
          DSGVO). Die erteilte Einwilligung zur Speicherung der Daten sowie deren Nutzung
          zum Versand des Newsletters können Sie jederzeit mit Wirkung für die Zukunft
          widerrufen, beispielsweise über den „Opt-Out“-Link im Newsletter oder Sie wenden
          sich direkt per Mail an
          <a href="mailto:datenschutz@expert.de">datenschutz@expert.de</a>.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>20. Kontaktaufnahme über die Webseite und per WhatsApp</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Wenn Sie uns per Kontaktformular über unsere Webseite Anfragen zukommen lassen,
          werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort
          angegebenen Kontaktdaten zur Erfüllung des mit der Übermittlung verbundenen
          Zwecks, z.B. zur Bearbeitung Ihrer Anfrage und für den Fall von Anschlussfragen,
          bei uns gespeichert und genutzt. Diese Daten geben wir nicht ohne Ihre
          Einwilligung oder eine gesetzliche Pflicht oder Befugnis an Dritte weiter.
        </p>
        <p>
          Grundlage dieser Speicherung und Verwendung Ihrer personenbezogenen Daten ist
          Art. 6 Abs. 1 S. 1 b) DSGVO, soweit Sie diese personenbezogenen Daten zwecks
          Anbahnung eines Vertragsverhältnisses mit uns eingeben. Nur in diesem Fall ist
          die Eingabe von personenbezogenen Daten erforderlich im Sinne von Art. 13 Abs. 2
          e) DSGVO.
        </p>
        <p>
          Andernfalls erfolgt diese Speicherung und Verwendung aufgrund von Art. 6 Abs. 1
          S. 1 lit. f) DSGVO, wobei unser berechtigtes Interesse die sorgfältige
          Bearbeitung Ihres Anliegens ist.
        </p>
        <p>
          Sofern wir Ihre Daten an Dritte weitergeben, geschieht dies ausschließlich auf
          Basis Ihrer Einwilligung gemäß Art. 6 Abs. 1 S. 1 a) DSGVO oder zur Erfüllung
          einer rechtlichen Verpflichtung, der wir unterliegen, gemäß Art. 6 Abs. 1 S. 1
          c) DSGVO. Sie haben das Recht, eine erteilte Einwilligung in die Datenweitergabe
          mit Wirkung für die Zukunft jederzeit zu widerrufen. In diesem Fall werden wir
          von einer Datenweitergabe absehen bzw. im Falle einer bereits erfolgten
          Weitergabe die Empfänger:innen über Ihren Widerruf informieren und verlangen,
          dass Ihre personenbezogenen Daten dort umgehend gelöscht werden.
        </p>
        <p>
          Ihre personenbezogenen Daten werden auch ohne Ihren Widerruf jedenfalls
          gelöscht, wenn wir Ihre Anfrage bearbeitet haben oder die Speicherung aus
          sonstigen gesetzlichen Gründen unzulässig ist.
        </p>
        <p>
          Wir bieten Ihnen auch die Möglichkeit, Ihre Anfragen über den Chat-Dienst
          WhatsApp zu stellen und über WhatsApp entsprechende Rückmeldung zu Ihrem
          Anliegen zu erhalten. Betreiber dieses Dienstes ist die WhatsApp Ireland
          Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland
          („WhatsApp"), eine Tochtergesellschaft von Meta. Durch Ihre Kommunikation mit
          uns über WhatsApp erhalten sowohl wir, als auch WhatsApp Ihre Telefonnummer und
          die Information, dass Sie unsere Kunden-Hotline kontaktiert haben.
        </p>
        <p>
          Die vorgenannten Daten werden von WhatsApp auch an Server von WhatsApp und Meta
          in den USA weitergeleitet und von WhatsApp und Meta entsprechend der
          WhatsApp-Datenschutzrichtlinie verarbeitet, was auch die Verarbeitung zu deren
          eigenen Zwecken, wie der Verbesserung des WhatsApp-Dienstes, beinhaltet. Wir
          weisen darauf hin, dass WhatsApp auch auf das Adressbuch des genutzten Geräts
          und die darin gespeicherten Kontaktdaten zugreift. Näheres zum Zweck und Umfang
          der Datenerhebung und der weiteren Verarbeitung dieser Daten durch WhatsApp und
          Meta sowie diesbezügliche Rechte und Einstellungsmög-lichkeiten zum Schutz Ihrer
          Privatsphäre können Sie der Datenschutzrichtlinie von WhatsApp entnehmen unter:
          <a
            href="https://www.whatsapp.com/legal/#privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            >https://www.whatsapp.com/legal/#privacy-policy</a
          >.
        </p>
        <p>
          Wir verarbeiten Ihre Telefonnummer, Ihren Namen sowie weitere von Ihnen
          mitgeteilte Daten und den Inhalt Ihrer Anfrage bzw. Nachricht, um Ihr Anliegen
          zu bearbeiten und etwaige Rückfragen von Ihnen beantworten zu können.
        </p>
        <p>
          Grundlage dieser Verarbeitungen und der Übermittlung an WhatsApp in diesem
          Rahmen ist Art. 6 Abs. 1 S. 1 b) DSGVO, soweit Ihr Anliegen eine bestehende
          Vertragsbeziehung mit uns betrifft oder der Anbahnung einer solchen
          Vertragsbeziehung dient. Andernfalls erfolgt diese Datenverarbeitung aufgrund
          von Art. 6 Abs. 1 S. 1 f) DSGVO, wobei unser berechtigtes Interesse die
          sorgfältige Bearbeitung Ihres jeweiligen Anliegens und die Lösung etwaiger
          technischer Probleme ist. Ihren Interessen tragen wir dadurch Rechnung, dass die
          Kommunikation per WhatsApp nur als zusätzliche Option besteht.
          Selbstverständlich können Sie uns auch auf anderem Wege kontaktieren,
          beispielsweise per Telefonanruf, E-Mail oder über unser Kontaktformular auf der
          Webseite, wie weiter oben in diesem Abschnitt beschrieben. Außerdem verwenden
          wir für die Kontaktmöglichkeit über WhatsApp nach Möglichkeit ein separates
          Gerät, in dem allein die Kontaktdaten der Anfragenden, die mit uns über WhatsApp
          kommunizieren, gespeichert werden, wodurch WhatsApp nur Daten von Anfragenden
          erhält, die den Dienst willentlich nutzen.
        </p>
        <p>
          Im Zusammenhang mit den oben genannten Funktionen kann WhatsApp die dabei
          verarbeiteten Daten auch an Server außerhalb der EU, insbesondere der WhatsApp
          LLC und Meta Platforms, Inc. in den USA übermitteln, soweit dies zur Erbringung
          dieser Dienste notwendig ist. Die WhatsApp LLC und Meta Platforms, Inc sind
          unter dem EU-US Data Privacy Framework (DPF) zertifiziert und in die vom U.S.
          Department of Commerce geführte Liste (DPF List) eingetragen. Bei der
          Übermittlung von Daten an Server von WhatsApp in den USA ist daher ein
          durchgängig hohes Datenschutzniveau gewähreistet. Soweit eine Übermittlung der
          Daten in die USA erfolgt, basiert ein solcher Drittlandtransfer auf Art. 45 Abs.
          1 S. 1 DSGVO.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>21. Ihre Rechte als Betroffene:r<br /></strong
          ></span>
        </p>
        <p>
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über die zu Ihrer
          Person gespeicherten Daten. Zudem haben Sie das Recht auf Berichtigung
          unrichtiger Daten, ggf. auf Löschung Ihrer personenbezogenen Daten und auf
          Einschränkung der Datenverarbeitung.
        </p>
        <p>
          Sofern die Grundlage für die Datenverarbeitung Art. 6 Abs. 1 S. 1 f) DSGVO
          (Wahrnehmung berechtigter Interessen) ist, haben Sie das Recht, gem. Art. 21
          DSGVO jederzeit Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten
          einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer besonderen
          Situation ergeben, oder wenn sich der Widerspruch gegen eine Datenverarbeitung
          zu Zwecken der Direktwerbung richtet. Im letztgenannten Fall steht Ihnen ein
          generelles Widerspruchsrecht zu, welches ohne Angabe von Gründen, die sich aus
          Ihrer besonderen Situation ergeben, von uns umgesetzt wird (Art. 21 Abs. 2
          DSGVO). Legen Sie aus Gründen, die sich aus Ihrer besonderen Situation ergeben,
          Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht mehr verarbeiten,
          es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung
          nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die
          Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
          Rechtsansprüchen (Art. 21 Abs. 1 DSGVO).
        </p>
        <p>
          Soweit Sie uns personenbezogene Daten bereitstellen und wir diese Daten aufgrund
          Ihrer Einwilligung verarbeiten, können Sie die entsprechende Einwilligung
          jederzeit mit Wirkung für die Zukunft frei widerrufen.
        </p>
        <p>
          Sofern Sie uns Daten bereitstellen, die Sie betreffen, und wir diese Daten
          aufgrund Ihrer Einwilligung oder zur Vertragserfüllung verarbeiten, können Sie
          zudem verlangen, dass Sie diese Daten in einem strukturierten, gängigen und
          maschinenlesbaren Format von uns erhalten oder wir diese Daten an einen anderen
          Verantwortlichen übermitteln, soweit dies technisch möglich ist (sog. Recht auf
          Datenübertragbarkeit).
        </p>
        <p>
          Außerdem haben Sie das Recht auf Beschwerde bei einer Aufsichtsbehörde, wenn Sie
          der Auffassung sind, dass die Datenverarbeitung durch uns gegen die gesetzlichen
          Vorschriften verstößt.
        </p>
        <p>
          Um Ihre hier aufgeführten Rechte geltend zu machen sowie bei weiteren Fragen zum
          Thema Verarbeitung Ihrer personenbezogenen Daten können Sie sich jederzeit unter
          den oben angegebenen Kontaktdaten an uns wenden.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >22. Reichweite dieser Datenschutzerklärung, soziale Netzwerke<br /></strong
          ></span>
        </p>
        <p>
          Diese Datenschutzerklärung gilt nur für die Inhalte auf den expert-Webseiten und
          die Datenverarbeitung auf den von uns verwendeten Servern. Sie umfasst nicht
          solche Inhalte und Webseiten Dritter, auf die unser Angebot lediglich verlinkt.
          Dies gilt beispielsweise für soziale Netzwerke wie Facebook, Instagram und
          YouTube. Die Verarbeitung Ihrer personenbezogenen Daten über diese sozialen
          Netzwerke erfolgt durch den jeweiligen Betreiber des Netzwerks, ohne dass wir
          auf diese Verarbeitung Einfluss haben. Informationen zum Umgang mit Ihren
          personenbezogenen Daten und deren Schutz auf diesen Plattformen finden Sie in
          der Datenschutzerklärung der jeweiligen Plattform.
        </p>
        <p>
          Sofern wir jedoch Ihre personenbezogenen Daten, die Sie uns über ein soziales
          Netzwerk mitgeteilt haben oder die wir von einem sozialen Netzwerk erhalten, auf
          unseren eigenen Servern speichern und zwecks Bearbeitung Ihrer Anfrage oder
          Ihres Anliegens oder zu sonstigen Zwecken verwenden, gelten insoweit
          selbstverständlich unsere Erläuterungen in dieser Datenschutzerklärung.
        </p>
        <p>
          Wir haben Auftritte (sog. „Fanpages“) bei den nachfolgenden sozialen Netzwerken
          und Anbietern:
        </p>
        <p>
          Facebook, das angeboten wird von der Meta Platforms Ireland Ltd., 4 Grand Canal
          Square, Grand Canal Harbour, Dublin 2, Irland („Meta“). Zu den
          Datenschutzhinweisen von Meta:
          <a href="https://de-de.facebook.com/policy.php"
            >https://de-de.facebook.com/policy.php</a
          >
        </p>
        <p>
          Instagram, das angeboten wird von Meta Platforms Ireland Limited, 4 Grand Canal
          Square, Dublin 2, Ireland („Meta“). Zu den Datenschutzhinweisen von Meta für
          Instagram:
          <a
            href="https://privacycenter.instagram.com/policy/?entry_point=ig_help_center_data_policy_redirect"
            >https://privacycenter.instagram.com/policy/?entry_point=ig_help_center_data_policy_redirect</a
          >
        </p>
        <p>
          LinkedIn, das angeboten wird von der LinkedIn Ireland Unlimited Company, Wilton
          Place, Dublin 2, Irland („LinkedIn“). Zu den Datenschutzhinweisen von LinkedIn:
          <a href="https://www.linkedin.com/legal/privacy-policy"
            >https://www.linkedin.com/legal/privacy-policy</a
          >
        </p>
        <p>
          xing, das angeboten wird von der New Work SE, Baumwall 7, 20459 Hamburg,
          Deutschland („Xing"). Zu der Datenschutzerklärung von Xing:
          <a href="https://privacy.xing.com/de/datenschutzerklaerung?nwt_nav=footer"
            >https://privacy.xing.com/de/datenschutzerklaerung?nwt_nav=footer</a
          >
        </p>
        <p>
          YouTube, das angeboten wird von Google Ireland Limited, Gordon House, Barrow
          Street, Dublin 4, Irland („Google“). Zu den Datenschutzhinweisen von Google:
          <a href="https://policies.google.com/privacy?hl=de"
            >https://policies.google.com/privacy?hl=de</a
          >
        </p>
        <p>
          Für den Betrieb der jeweiligen Fanpage greifen wir auf die technische Plattform
          und die Dienste der Anbieter zurück. Wir weisen Sie darauf hin, dass Sie unsere
          Fanpages bei sozialen Netzwerken und ihre Funktionen in eigener Verantwortung
          nutzen. Dies gilt insbesondere für die Nutzung der interaktiven Funktionen (z.B.
          Kommentieren, Teilen, Bewerten). Beim Besuch unserer Fanpages erfassen die
          Anbieter der sozialen Netzwerke bestimmte technische Daten (u.a. die IP-Adresse
          Ihres Endgeräts) sowie weitere Informationen, die in Form von Cookies auf Ihrem
          Endgerät vorhanden sind. Diese Informationen werden verwendet, um uns als
          Betreiber der Fanpages statistische Informationen über die Interaktion mit
          unseren Fanpages zur Verfügung zu stellen.
        </p>
        <p>
          Wir haben keinen Einfluss darauf und keine genaue Kenntnis davon, wie die
          Anbieter die Daten aus dem Besuch unserer Fanpage und aus den Interaktionen mit
          unseren Beiträgen zu eigenen Zwecken verarbeiten, wie lange diese gespeichert
          werden und ob die Daten an Dritte weitergegeben werden. Die Datenverarbeitung
          kann sich danach unterscheiden, ob Sie bei dem sozialen Netzwerk registriert und
          angemeldet sind oder als nicht-registrierter und/oder nicht-angemeldeter Nutzer
          die Seite besuchen. Beim Zugriff auf die Fanpage oder einen Beitrag wird die
          Ihrem Endgerät zugeteilte IP-Adresse an den Anbieter des jeweiligen sozialen
          Netzwerks übermittelt. Sind Sie in dem sozialen Netzwerk aktuell angemeldet,
          kann über ein Cookie auf Ihrem Endgerät nachvollzogen werden, wie Sie sich im
          Netz bewegt haben. Über in Webseiten eingebundene Buttons ist es den Plattformen
          möglich, Ihre Besuche auf diesen Webseiten zu erfassen und Ihrem jeweiligen
          Profil zuzuordnen. Anhand dieser Daten können Inhalte oder Werbung auf Sie
          zugeschnitten angeboten werden. Wenn Sie dies vermeiden möchten, sollten Sie
          sich abmelden bzw. die Funktion „angemeldet bleiben“ deaktivieren, die auf Ihrem
          Gerät vorhandenen Cookies löschen und Ihren Browser neu starten.
        </p>
        <p>
          Bitte beachten Sie auch, dass die in diesem Zusammenhang über Sie erhobenen
          Daten vom jeweiligen Anbieter des sozialen Netzwerks ggf. in Länder außerhalb
          des Europäischen Wirtschaftsraums (EWR), insbesondere die USA, übertragen und
          dort verarbeitet werden. Meta Platforms Inc. (Facebook und Instagram), LinkedIn
          Corp. (LinkedIn) und Google LLC (YouTube) sind unter dem EU-U.S. Data Privacy
          Framework zertifiziert und auch in die vom U.S. Department of Commerce geführte
          Liste (Data Privacy Framework List) eingetragen. Bei der Übermittlung von Daten
          an Server in den USA ist daher ein durchgängig hohes Datenschutzniveau
          gewährleistet. Soweit eine Übermittlung der Daten in die USA erfolgt, basiert
          ein solcher Drittlandtransfer auf Art. 45 Abs. 1 S. 1 DSGVO.
        </p>
        <p>
          Weitere Informationen zu den Datenverarbeitungen durch die Anbieter der sozialen
          Netzwerke, einschließlich einer etwaigen Datenübermittlung in Drittländer,
          erhalten Sie in den vorstehend verlinkten Datenschutzhinweisen des jeweiligen
          Anbieters. Dort finden Sie auch Informationen über Kontaktmöglichkeiten sowie zu
          den Einstellmöglichkeiten für Werbeanzeigen.
        </p>
        <p>
          Wir betreiben unsere Fanpage in dem jeweiligen sozialen Netzwerk, um mit den
          dort aktiven Nutzern zu kommunizieren und aktuelle Meldungen bereitstellen zu
          können. Wir verarbeiten die Daten aus Ihrer Nutzung der Fanpage, die Sie uns
          bereitstellen und eine Interaktion erfordern. Wenn Sie uns beispielsweise über
          eine Fanpage eine Frage stellen, verarbeiten wir Ihre Informationen zur
          sachgerechten Beantwortung der Anfrage. Beim Besuch unserer Fanpages auf
          Facebook, Instagram, und LinkedIn verarbeiten die jeweiligen Anbieter des
          sozialen Netzwerks zudem personenbezogene Daten, um uns Statistiken und
          Einblicke (sog. „Insights“) in die Nutzung unserer Fanpages bereitzustellen. Die
          Statistiken dienen uns dazu, unsere Fanpages entsprechend der Nutzerbedürfnisse
          anzupassen und damit fortlaufend zu optimieren, was auch zu Marktforschungs- und
          Werbezwecken erfolgen kann. Wir erhalten hierbei nur statistische Berichte, über
          die wir die einzelnen Nutzer des sozialen Netzwerks nicht identifizieren oder
          Rückschlüsse auf diese ziehen können. Die Verarbeitung der Daten zu
          statistischen Zwecken erfolgt durch uns und die Anbieter des sozialen Netzwerks
          in gemeinsamer Verantwortung nach Art. 26 DSGVO. Wir haben die Bedingungen und
          Pflichten als gemeinsame Verantwortliche mit den Anbietern jeweils in einer
          Vereinbarung geregelt, die wie folgt abrufbar ist:
        </p>
        <p>
          Facebook und Instagram:
          <a href="https://de-de.facebook.com/legal/terms/page_controller_addendum"
            >https://de-de.facebook.com/legal/terms/page_controller_addendum</a
          >
        </p>
        <p>
          LinkedIn:
          <a href="https://legal.linkedin.com/pages-joint-controller-addendum"
            >https://legal.linkedin.com/pages-joint-controller-addendum</a
          >
        </p>
        <p>
          Die vorstehenden Datenverarbeitungen durch uns dienen der Wahrung unserer
          berechtigten Interessen an dem Betrieb einer Fanpage auf dem jeweiligen sozialen
          Netzwerk, der Kommunikation und Interaktion mit den Nutzern dieses sozialen
          Netzwerks sowie an der Auswertung der Nutzerinteraktionen zur Verbesserung der
          Fanpage. Die Datenverarbeitungen beruhen damit jeweils auf Art. 6 Abs. 1 S. 1
          lit. f) DSGVO. Soweit auf den sozialen Netzwerken von den Anbietern Cookies oder
          ähnliche Technologien auf Ihrem Endgerät gespeichert werden, ist Rechtsgrundlage
          bei technisch erforderlichen Cookies oder ähnlichen Technologien § 25 Abs. 2 Nr.
          2 TTDSG und ansonsten Ihre Einwilligung gemäß § 25 Abs. 1 TTDSG.
        </p>
        <p>
          Zur Ausübung Ihrer Betroffenenrechte können Sie sich entweder an uns oder an den
          Anbieter des jeweiligen sozialen Netzwerks wenden. Soweit eine Partei nicht für
          die Beantwortung zuständig ist oder die Informationen von der anderen Partei
          erhalten muss, werden dann wir oder der Anbieter Ihre Anfrage an den jeweiligen
          Partner weiterleiten. Bitte wenden Sie sich für Fragen über die Profilbildung
          und Verarbeitung Ihrer Daten bei Nutzung der Fanpage direkt an den jeweiligen
          Anbieter des sozialen Netzwerks. Bei Fragen zu der Verarbeitung Ihrer
          Interaktion mit uns auf unserer Fanpage schreiben Sie bitte an die oben von uns
          angegebenen Kontaktdaten.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>23. Remarketing mit Criteo<br /></strong
          ></span>
        </p>
        <p>
          Wir verwenden im Rahmen unserer Webseite zudem den Remarketing-Dienst der Criteo
          SA, 32 Rue Blanche, 75009 Paris, Frankreich („Criteo"), sofern Sie Ihre
          Einwilligung hierzu erteilen. Mit Hilfe dieses Dienstes werden Nutzern, die
          unsere Webseite bereits einmal besucht und sich daher grundsätzlich für unsere
          Angebote interessiert haben, auf Partner-Webseiten von Criteo zielgerichtete
          Werbeanzeigen zu unseren Angeboten ausgespielt. Dazu wird beim Besuch unserer
          Webseite ein Cookie in Ihrem Browser gesetzt, der Ihrem Browser eine
          individuelle Cookie-ID zuordnet. Hierbei erhalten Criteo und die Partner, mit
          denen Criteo für den Remarketing-Dienst zusammenarbeitet, die Cookie-ID, einige
          technische Daten zu Ihrem genutzten Endgerät (z.B. Gerätetyp, Betriebssystem,
          Version, Sprache) sowie Ihre gekürzte IP-Adresse, sodass Criteo und deren
          Partner erkennen können, dass Sie unsere Webseite besucht haben. Im Rahmen eines
          anschließenden Besuchs einer Partner-Webseite von Criteo wird die Cookie-ID an
          Criteo und ggf. die Partner von Criteo zusammen mit der Information gesendet,
          dass Sie unsere Webseite besucht haben. Diese Daten werden genutzt, um Ihnen auf
          den Partner-Webseiten von Criteo unsere Werbung anzuzeigen. In keinem Fall
          werden diese Informationen aber dazu verwendet, Sie als Besucher unserer
          Webseiten persönlich zu identifizieren. Die Ausspielung der Werbung und damit
          zusammenhängende Datenverarbeitungen erfolgen selbständig durch Criteo und ggf.
          auch die Partner von Criteo. Insoweit haben wir keinen Einfluss auf die Auswahl
          und die zugehörigen Datenverarbeitungen. Insbesondere können wir nicht über die
          genaue Webseite bzw. den Partner von Criteo, über den die Werbung ausgespielt
          wird, entscheiden und legen auch nicht fest, wo und welchem individuellen
          Nutzer:in die Werbung angezeigt wird.
        </p>
        <p>
          Sofern Ihnen eine Werbeanzeige von uns bei einem Partner von Criteo angezeigt
          wird oder Sie auf eine solche Werbeanzeige klicken, erfasst Criteo diesen Klick
          und erhält Informationen zu Ihren weiteren Aktionen auf unserer Webseite, um die
          Erfolge der Werbeanzeigen zu ermitteln und auf dieser Grundlage die
          Werbeanzeigen mit uns und dem Criteo-Partner abzurechnen.
        </p>
        <p class="tinyMCECSS">
          Sie können die Speicherung und Verwendung von Informationen durch den Dienst von
          Criteo allgemein verhindern, indem Sie dem Link unter
          <a
            href="https://www.criteo.com/de/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            >https://www.criteo.com/de/privacy/</a
          >
          folgen und dort auf "Criteo-Services deaktivieren" klicken. Hierdurch wird ein
          neues Cookie in Ihrem Browser gesetzt, das Criteo als allgemeine Verweigerung
          Ihrer Einwilligung auffasst, sodass Criteo keinerlei Daten über Ihr
          Nutzungsverhalten mehr erhebt und verarbeitet. Sofern Sie Cookies in Ihrem
          Browser löschen, müssen Sie die vorgenannten Schritte wiederholen, wenn Sie
          Criteo weiterhin signalisieren wollen, dass Sie von vornherein ein Remarketing
          durch Criteo auf jeder Webseite ablehnen.
        </p>
        <p>
          Weitere Information zum Schutz Ihrer personenbezogenen Daten durch Criteo finden
          Sie unter
          <a
            href="https://www.criteo.com/de/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            >https://www.criteo.com/de/privacy/.</a
          >
        </p>
        <p>
          Rechtsgrundlage der Datenverarbeitung im Zusammenhang mit dieser
          Remarketing-Funktion ist Ihre Einwilligung gemäß Art. 6 Abs. 1 S. 1 lit. a)
          DSGVO. Rechtsgrundlage für den Einsatz von Cookies oder ähnlichen Technologien
          auf Ihrem Endgerät ist § 25 Abs. 1 TDDDG. Sie können Ihre Einwilligung jederzeit
          mit Wirkung für die Zukunft widerrufen. Dazu können Sie Ihre Einstellungen oben
          im Abschnitt Cookies entsprechend anpassen. Außerdem können Sie die Verarbeitung
          Ihrer Daten zur Webseitennutzung durch Criteo für unsere, wie auch die
          Werbekampagnen Dritter verhindern oder einschränken, indem Sie personalisierte
          Werbung für Criteo
          <a
            title="Werbekampagnen verhindern"
            href="https://www.youronlinechoices.com/de/praferenzmanagement/"
            target="_blank"
            rel="noopener noreferrer"
            >hier</a
          >
          deaktivieren.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong
              >24. Web-Push-Benachrichtigungen unter Auswertung des Standortes und
              Nutzungsverhaltens durch usemax<br /></strong
          ></span>
        </p>
        <p>
          Wir nutzen das Tool usemax Advertisment der Emego GmbH, Rheinpromenade 13, 40789
          Monheim am Rhein (nachfolgend „usemax“), um den für Sie am günstigsten gelegenen
          expert-Fachmarkt zu ermitteln und Ihnen sogenannte Web-Push-Benachrichtigungen
          mit aktuellen Informationen zukommen zu lassen. Die Nutzung von usemax findet
          nur mit Ihrer Zustimmung statt.
        </p>
        <p>
          Wie unter dem Punkt "Geo-Lokalisierung für den Fachmarkt-Finder" dieser
          Datenschutzerklärung bereits beschrieben, werden Sie beim Besuch unserer
          Webseite dem nächstgelegenen Fachmarkt zugeordnet. Sollten Sie sich bei dem
          Besuch unserer Webseite in einer Region aufhalten, in der (bisher) kein
          Fachmarkt vorhanden ist, werden Sie unserem Zentralshop zugeordnet.
        </p>
        <p>
          Wenn Sie sich beim Besuch unseres Zentralshops für den Web-Push-Service
          anmelden, senden wir Ihnen regelmäßig Web-Push-Benachrichtigungen mit
          interessanten Produktangeboten zu, die wiederum nur auf den Zentralshop
          verweisen und verlinken.
        </p>
        <p>
          Wenn Sie unseren Zentralshop aufrufen und das entsprechende Cookie zulassen,
          wird bei Ihnen ein Cookie des usemax Adservers gesetzt, über welcher Ihr
          Surfverhalten erfasst wird. Die darüber erhobenen Informationen dienen zur
          individuellen und personalisierten Ansprache über unsere Webseite oder über
          Werbeplatzierungen auf Drittwebseiten, welche in Verbindung mit usemax stehen.
        </p>
        <p>
          Außerdem wird bei Aufruf der Webseite anhand Ihrer IP-Adresse und dem
          anschließenden Abgleich mit einer Geo-Datenbank Ihr ungefährer Standort
          ermittelt. Anhand einer von expert bereitgestellten und regelmäßig
          aktualisierten Liste stellt usemax fest, ob es mittlerweile einen Fachmarkt in
          Ihrer Umgebung gibt. Wenn das der Fall sein sollte, so werden Sie aus dem
          Zentralshop-Web-Push-Verteiler herausgenommen und erhalten keine
          Web-Push-Benachrichtigungen mehr.
        </p>
        <p>
          Wir haben einen Vertrag über Auftragsverarbeitung mit usemax geschlossen. Die
          vorstehenden Daten werden von usemax somit lediglich im erforderlichen Umfang
          weisungsgebunden in unserem Auftrag gemäß Art. 28 DSGVO verarbeitet. Die Daten
          werden ausschließlich auf Servern innerhalb der Europäischen Union gespeichert.
        </p>
        <p>
          Die vorstehend beschriebene Datenverarbeitung beruht auf Ihrer Einwilligung in
          die Speicherung von Cookies auf Ihrem Endgerät und dem Zugriff auf die Cookies,
          die bereits auf Ihrem Endgerät gespeichert sind, sowie die weitere oben
          beschriebene Datenverarbeitung. Rechtsgrundlage für unsere Nutzung von usemax
          ist daher bezüglich der Speicherung von und dem Zugriff auf diese Cookies § 25
          Abs. 1 TDDDG sowie bezüglich der weiteren Verarbeitung der Daten Art. 6 Abs. 1
          S. 1 lit. a) DSGVO. Sie können jede erteilte Einwilligung jederzeit und mit
          Wirkung für die Zukunft widerrufen, indem Sie Ihre Einstellungen oben im
          Abschnitt Cookies anpassen. Auch wenn Sie eine Einwilligung nicht erteilt oder
          widerrufen haben, können Sie unsere Webseite nutzen. Im Fall des Widerrufs
          löschen wir die entsprechenden Daten unverzüglich. Im Übrigen löschen wir diese
          Daten 90 Tage nach dem letzten Zugriff. Bei usemax können Sie Ihre Daten über
          folgenden Link löschen lassen:
          <a
            href="https://www.usemax.de/index.php?l=rm&amp;kunde=&amp;id=1"
            target="_blank"
            rel="noopener noreferrer"
            >https://www.usemax.de/index.php?l=rm&amp;kunde=&amp;id=1</a
          >
        </p>
        <p>&nbsp;&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>25. Affiliate Marketing über Awin<br /></strong
          ></span>
        </p>
        <p>
          Auf unserer Webseite wird der Dienst Awin eingesetzt, der von der AWIN AG,
          Otto-Ostrowski-Straße 1A, 10249 Berlin angeboten wird. Mit Unterstützung von
          Awin verarbeiten wir Ihre personenbezogenen Daten zur Durchführung von sog.
          Afiiliate-Marketing-Kampagnen, das heißt Online-Werbekampagnen, die
          leistungsabhängig vergütet werden. Auf diese Weise sind wir in der Lage
          nachzuverfolgen, welcher Drittanbieter von Webseiten, Apps oder anderen
          Technologien potenzielle Kunden auf unsere Webseiten und Apps verwiesen hat
          („Referrer“) und ihm als Gegenleistung für diese Verweisungen eine Provision zu
          zahlen. Zu diesem Zweck nutzt Awin Cookies und ähnliche Technologien (wie z.B.
          das Tracking Pixel von Roeye), um nachzuverfolgen, ob Sie den Internetauftritt
          eines Referrers besucht, dort ein Produkt gefunden und auf den entsprechenden
          Link geklickt haben und sodann zu unserer Webseite weitergeleitet wurden, wo Sie
          das Produkt angesehen oder gekauft haben.
        </p>
        <p>
          Wenn Sie auf eine(n) unserer Links oder Werbeanzeigen klicken, erfasst Awin Ihre
          Interaktionen mit dem Link bzw. der Werbeanzeige sowie weitere Daten. Konkret
          speichert Awin eine individuelle Zahlenfolge für jede Transaktion, die nicht
          Ihren konkreten Namen preisgibt, aber Informationen über unsere Kampagne, den
          Referrer, Ihre Aktion als Nutzer (z.B. Klick oder „View“ und in welchem Land sie
          erfolgt ist) sowie das verwendete Endgerät enthält. Bei einer Bestellung auf
          unserer Webseite erhält Awin auch einige Transaktionsdaten, zu denen u.a. der
          Bestellwert, die Frage, ob ein Gutschein eingelöst wurde, die Produktart und der
          Vertriebsweg gehören. Die Auswertung dieser Informationen ist für die Zahlung
          der Vergütung (d.h. der Ermittlung und Abwicklung der Provisionszahlung)
          gegenüber dem Referrer, der unsere Links oder Werbeanzeigen ausgespielt hat,
          erforderlich. Zudem erstellt Awin auf Grundlage der ausgewerteten Informationen
          Berichte über die Aktivitäten auf unserer Webseite und unseren Werbeanzeigen.
          Dies hilft uns dabei, den Erfolg unserer Marketingmaßnahmen zu bestimmen.
        </p>
        <p>
          In einigen Fällen kann Awin ein eingeschränktes Profil unterhalten, das sich auf
          Sie bezieht. Dieses wird aber weder Ihre Identität noch Ihr Online-Verhalten
          oder andere persönliche Merkmale offenbaren. Dieses Profil dient allein dem
          Zweck nachzuvollziehen, ob eine Weiterleitung auf einem Endgerät begonnen und
          auf einem anderen Endgerät abgeschlossen wurde.
        </p>
        <p>
          Weitere Informationen zum Umgang von Awin mit Ihren personenbezogenen Daten
          sowie Ihre Rechte in Bezug auf die Datenverarbeitung durch Awin finden Sie
          unter:
          <a
            href="https://www.awin.com/de/datenschutzerklarung"
            target="_blank"
            rel="noopener noreferrer"
            >Datenschutzerklärung | Awin</a
          >.
        </p>
        <p>
          Die Verarbeitung Ihrer personenbezogenen Daten im Zusammenhang mit Awin erfolgt
          auf Basis Ihrer Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a) DSGVO.
          Rechtsgrundlage für den Einsatz von Cookies oder ähnlichen Technologien auf
          Ihrem Endgerät ist § 25 Abs. 1 TDDDG. Sie können Ihre Einwilligung jederzeit mit
          Wirkung für die Zukunft widerrufen. Dazu können Sie Ihre Einstellungen oben im
          Abschnitt Cookies entsprechend anpassen.
        </p>
        <p>
          Das Setzen von Cookies können Sie zudem in den Einstellungen Ihres Browsers
          verhindern. Bereits gesetzte Cookies können hier gelöscht werden.
        </p>
        <p>
          Wir weisen darauf hin, dass Awin sich vorbehält, die bei Nutzung des Dienstes
          anfallenden personenbezogenen Daten an andere Unternehmen der Awin-Gruppe sowie
          an Dienstleister, jeweils auch außerhalb der EU bzw. des EWR, weiterzugeben.
          Hierdurch können unter Umständen gesonderte Risiken für die Daten entstehen,
          z.B. Erschwernisse bei der Durchsetzung Ihrer Rechte zu diesen Daten. Nach
          eigenen Angaben hat Awin für diese Datenübermittlungen in Drittländer mit den
          jeweiligen Empfängern jedenfalls die Standarddatenschutzklauseln der
          EU-Kommission vereinbart. Derartige Übermittlungen durch Awin basieren daher auf
          Art. 46 Abs. 2 lit. c) DSGVO.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>26. Google Tag Manager<br /></strong
          ></span>
        </p>
        <p>
          Wir verwenden auf unserer Webseite den "Google Tag Manager", einen Dienst von
          Google. Der Google Tag Manager ermöglicht uns, Webseiten-Tags über eine
          Oberfläche verwalten zu können. Der Google Tag Manager, welcher die Tags
          implementiert, ist eine Cookie-lose Domain und nimmt keine eigenständigen
          Analysen vor. Der Google Tag Manager erfasst jedoch Ihre IP-Adresse, die auch an
          das Mutterunternehmen von Google in die USA übertra-gen werden kann. Der Google
          Tag Manager sorgt für die Auslösung anderer Tags, die ihrerseits unter Umständen
          Daten erfassen. Google Tag Manager greift nicht auf diese Daten zu. Wenn auf
          Domain- oder Cookie-Ebene eine Deaktivierung vorgenommen wurde, bleibt diese für
          alle Tracking-Tags bestehen, die mit Google Tag Manager implementiert werden.
        </p>
        <p>
          Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Basis Ihrer
          Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Rechtsgrundlage für den
          Einsatz von Cookies oder ähnlichen Technologien auf Ihrem Endgerät ist § 25 Abs.
          1 TDDDG. Sie können Ihre Einwilligungen jederzeit mit Wirkung für die Zukunft
          widerrufen. Dazu können Sie Ihre Einstellungen oben im Abschnitt Cookies
          entsprechend anpassen.
        </p>
        <p>
          Im Zusammenhang mit den oben genannten Funktionen kann Google die dabei
          verarbeiteten Daten auch an Server außerhalb der EU, insbesondere der Google LLC
          in den USA, übermitteln, soweit dies zur Erbringung dieser Dienste notwendig
          ist. Die Übermittlung basiert auf Art. 45 Abs. 1 S. 1 DSGVO. Es wird insoweit
          auf die Ausführungen zu Drittlandtransfers im Abschnitt zu Google Analytics
          verwiesen.
        </p>
        <p>
          Weitere Informationen zum Datenschutz können Sie den nachfolgenden Webseiten von
          Google entnehmen:
        </p>
        <ul>
          <li>
            Datenschutzerklärung:
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              >policies.google.com/privacy</a
            >
          </li>
          <li>
            FAQ Google Tag Manager:&nbsp;<a
              href="https://www.google.com/intl/de/tagmanager/faq.html"
              target="_blank"
              rel="noopener noreferrer"
              >www.google.com/intl/de/tagmanager/faq.html</a
            >
          </li>
          <li>
            Nutzungsbedingungen Google Tag Manager:&nbsp;<a
              href="https://www.google.com/intl/de/tagmanager/use-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              >www.google.com/intl/de/tagmanager/use-policy.html</a
            >
          </li>
        </ul>
        <p>&nbsp;&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>27. Cookiebot<br /></strong
          ></span>
        </p>
        <p>
          Wir verwenden das Consent-Management-Tool Cookiebot der Usercentrics GmbH,
          Sendlinger Str. 7, 80331 München („Usercentrics“) zur Bereitstellung eines
          Cookie-Banners auf unserer Webseite und zur Verwaltung der von unseren Besuchern
          getroffenen Cookie-Einstellungen.
        </p>
        <p>
          Beim Aufruf unserer Webseite wird das Tool zur Einblendung der Informationen und
          Einstellungsmöglichkeiten zu den auf unserer Webseite eingesetzten optionalen
          Cookies verwendet. Hierzu wird eine Serververbindung zu dem Anbieter des Tools
          hergestellt, bei der technische Daten zu Ihrem genutzten Endgerät (z.B.
          Betriebssystem, Browserversion, Sprache sowie die IP-Adresse), die besuchte
          Webseiten-URL, der ungefähre Standort sowie Informationen zu den vom Besucher
          getroffenen Cookie-Einstellungen (Einstellungen zu den jeweiligen
          Cookie-Kategorien, Zeit und Uhrzeit) an Usercentrics übermittelt werden. Nur
          soweit dies für die Dokumentation Ihrer etwaig erteilten Einwilligung
          erforderlich ist, werden diese Informationen gespeichert.
        </p>
        <p>
          Die vom Besucher vorgenommenen Einstellungen werden zudem in einem Cookie mit
          einer individuellen Consent-ID im Browser des verwendeten Endgeräts gespeichert,
          sodass die getroffenen Einstellungen sitzungsübergreifend verfügbar sind und der
          Besucher nicht bei jedem weiteren Aufruf unserer Webseite erneut zu den
          Cookie-Einstellungen befragt wird. Die Speicherdauer der gesetzten Cookies
          beträgt maximal ein Jahr.
        </p>
        <p>
          Wir haben mit Usercentrics einen Vertrag über Auftragsverarbeitung im
          Zusammenhang mit der Verwendung von Cookiebot geschlossen. Die von Usercentrics
          erhobenen Informationen werden auf der Grundlage dieses Auftrags gemäß unseren
          Weisungen verarbeitet. Die Weiterleitung der erhobenen Informationen an
          Usercentrics und die dortige Datenverarbeitung erfolgt somit in unserem Auftrag
          gemäß Art. 28 DSGVO.
        </p>
        <p>
          Wir weisen darauf hin, dass Usercentrics für die Bereitstellung von Cookiebot
          Dienstleister außerhalb der EU bzw. des EWR verwenden kann (u.a. in den USA).
          Hierdurch können unter Umständen gesonderte Risiken für die Daten entstehen,
          z.B. Erschwernisse bei der Durchsetzung Ihrer Rechte zu diesen Daten. Um ein
          angemessenes Datenschutzniveau in diesen Drittländern zu gewährleisten, hat
          Usercentrics mit den jeweiligen Empfängern der Daten u.a. die
          Standarddatenschutzklauseln der EU-Kommission vereinbart. Derartige
          Übermittlungen durch Usercentrics basieren daher auf Art. 46 Abs. 2 lit. c)
          DSGVO.
        </p>
        <p>
          Rechtsgrundlage für das Setzen des Cookies ist § 25 Abs. 2 Nr. 2 TDDDG, für die
          damit zusammenhängende anschließende Datenverarbeitung Art. 6 Abs. 1 S. 1 lit.
          f) DSGVO. Unser berechtigtes Interesse ist es, Ihnen eine rechtskonforme
          Webseite bereitzustellen, auf der Sie auf effiziente und sichere Weise Ihre
          Einwilligung in die Verwendung von Cookies bzw. den hiermit verbundenen
          Datenverarbeitungen erteilen und verwalten können. Hierfür ist auch das Setzen
          des Cookies von Cookiebot unbedingt erforderlich.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"><strong>28.&nbsp;</strong></span
          ><span class="text-base"
            ><strong>Cloudflare<br /></strong
          ></span>
        </p>
        <p>
          Wir verwenden die Netzwerkdienste der Cloudflare, Inc., 101 Townsend St., San
          Francisco, California 94107, USA („Cloudflare“), um unsere Webseite technisch
          möglichst einwandfrei und zuverlässig bereitstellen zu können und die Sicherheit
          auf unserer Webseite zu erhöhen.
        </p>
        <p>
          Cloudflare bietet eine Reihe von technischen Diensten an, die uns bei dem
          Betrieb unserer Webseite helfen. Hierzu gehört u.a. ein weltweit verteiltes
          Servernetzwerk (sog. Content Delivery Network), das uns die schnelle und
          zuverlässige Auslieferung unserer Webseite ermöglicht. Beim Aufruf unserer
          Webseite können daher die aufgerufene Webseite und technische Daten zu Ihrem
          Endgerät (z.B. Betriebssystem, Browserversion, Referrer-URL sowie die
          IP-Adresse) an Cloudflare übermittelt werden. Cloudflare kann zu
          Sicherheitszwecken (z.B. zur Abwehr bösartiger Bots) zudem ein Cookie in dem
          Browser Ihres Endgeräts setzen, das nach höchstens einem Tag wieder gelöscht
          wird.
        </p>
        <p>
          Wir haben mit Cloudflare einen Vertrag über Auftragsverarbeitung im Zusammenhang
          mit der Verwendung der Netzwerkdienste geschlossen. Die von Cloudflare erhobenen
          Informationen werden auf der Grundlage dieses Auftrags gemäß unseren Weisungen
          verarbeitet. Die Weiterleitung der erhobenen Informationen an Cloudflare und die
          dortige Datenverarbeitung erfolgt somit in unserem Auftrag gemäß Art. 28 DSGVO.
        </p>
        <p>
          Wir weisen darauf hin, dass Cloudflare Server außerhalb der EU bzw. des EWR
          verwenden kann (u.a. in den USA), in denen ein abweichendes Datenschutzniveau
          vorherrscht. Um bei etwaigen Datenübermittlungen in diese Drittländer ein
          angemessenes Datenschutzniveau zu gewährleisten, haben wir mit Cloudflare u.a.
          die Standarddatenschutzklauseln der EU-Kommission vereinbart, die
          <a
            href="https://www.cloudflare.com/cloudflare-customer-scc/"
            target="_blank"
            rel="noopener noreferrer"
            >hier</a
          >
          abrufbar sind. Die Übermittlung von Daten in diese Drittländer beruht damit auf
          Art. 46 Abs. 2 lit. c) DSGVO.
        </p>
        <p>
          Die Verwendung von Cookies durch Cloudflare ist für den Betrieb unserer Webseite
          unbedingt erforderlich und beruht daher auf § 25 Abs. 2 Nr. 2 TDDDG. Die
          Datenverarbeitung durch Cloudflare ist zur Wahrung unserer berechtigten
          Interessen erforderlich und basiert damit auf Art. 6 Abs. 1 S. 1 lit. f) DSGVO.
          Unser berechtigtes Interesse liegt in dem sicheren, zuverlässigen und technisch
          einwandfreien Betrieb unserer Webseite.
        </p>
        <p>&nbsp;&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>29. Durchführung von Umfragen mit SurveyMonkey</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Mit Ihrer Zustimmung wird auf unserer Webseite ein Tool der SurveyMonkey Europe
          UC, 70 Sir John Rogerson's Quay, Dublin 2, D02 R296, Irland („SurveyMonkey“) zur
          Durchführung von Umfragen eingesetzt. Wir verwenden das Tool zur Einholung von
          Kundenfeedback, das uns bei der Optimierung unserer Webseite und unserer
          Angebote helfen soll. Die über das Tool erhobenen Daten können zudem zur
          Verbesserung des Tools verarbeitet werden.
        </p>
        <p>
          Bei der Anzeige des Tools auf unserer Webseite kommt es zu einem Kontakt mit den
          Servern von SurveyMonkey, wobei SurveyMonkey automatisch Informationen über das
          verwendete Endgerät erfasst. Hierzu können insbesondere die IP-Adresse, die
          Version Ihres Betriebssystems, der Gerätetyp, die Geräte-ID/MAC-Adresse,
          Informationen zu System und Leistung sowie der Browsertyp gehören. Wenn Sie ein
          Mobilgerät einsetzen, kann Survey-Monkey auch die UUID dieses Geräts erfassen.
          Das Tool setzt zudem Cookies auf dem Endgerät (im Browser) der Nutzer:innen, die
          ggf. auch einen individuellen Identifizierungswert („Cookie-ID“) enthalten. Die
          Cookies dienen u.a. dazu, ein erneutes Anzeigen des Umfrage-Popups zu
          verhindern, indem festgehalten wird, wer bereits an einer Umfrage teilgenommen
          hat. Die Cookies werden spätestens nach einem Jahr automatisch gelöscht.
        </p>
        <p>
          Die Teilnahme an den Umfragen auf unserer Webseite ist selbstverständlich
          freiwillig. Bei der Teilnahme an einer Umfrage werden Ihre Antworten und
          Eingaben erhoben und verarbeitet. Wir führen auf unserer Webseite in erster
          Linie Umfragen zur Kundenzufriedenheit durch und sind etwa an Ihrer Meinung oder
          Bewertung zu unseren Angeboten und Produkten, unserer Webseite (z.B. der
          Nutzerführung auf der Webseite) und Ihrer Kauferfahrung (z.B. Zufriedenheit mit
          dem Kaufprozess) interessiert. Je nach Umfrage können Sie als Teilnehmer:in eine
          Bewertung abgeben, aus vorgegebenen Antwortmöglichkeiten auswählen oder eigene
          Antworten formulieren. Wir erheben hierbei grundsätzlich keine besonderen
          Kategorien von personenbezogenen Daten und bitten Sie, bei Teilnahme an einer
          Umfrage keine sensiblen Daten an uns zu übermitteln. Die erhobenen
          Umfrageergebnisse werden nicht mit weiteren Daten verknüpft und im Regelfall
          unmittelbar anonymisiert, sodass Sie Ihrer Person nicht mehr zugeordnet werden
          können.
        </p>
        <p>
          Nur in Einzelfällen, etwa wenn eine Umfrage mit einem Gewinnspiel kombiniert
          wird, können die Teilnehmer:innen auf freiwilliger Basis Kontaktdaten (z.B.
          E-Mail Adresse) angeben. Diese Kontaktdaten werden ausschließlich zum Zweck der
          Durchführung und Abwicklung des Gewinnspiels bspw. für die Gewinnermittlung,
          Gewinnbenachrichtigung und Zusendung verwendet. Insoweit wird auf den Abschnitt
          „Gewinnspiele“ in dieser Datenschutzerklärung verwiesen.
        </p>
        <p>
          Die vorstehenden Daten werden an Server von SurveyMonkey übermittelt. Wir weisen
          darauf hin, dass die Daten hierbei auch an weitere von SurveyMonkey eingesetzte
          Dienstleister, auch außerhalb der EU bzw. des EWR, insbesondere in die USA,
          übermittelt werden können. Soweit Daten an Server der Muttergesellschaft von
          SurveyMonkey mit Sitz in den USA (SurveyMonkey Inc., One Curiosity Way, San
          Mateo, California 94403, USA) übermittelt werden, erfolgt dies auf Grundlage des
          Angemessenheitsbeschlusses der EU-Kommission gemäß Art. 45 DSGVO, da
          SurveyMonkey Inc. nach dem EU-U.S. Data Privacy Framework zertifiziert ist.
          Etwaige weitere Datenübermittlungen in Drittländer erfolgen ebenfalls auf
          Grundlage von Angemessenheitsbeschlüssen der EU-Kommission, soweit dies
          rechtlich möglich ist. Im Übrigen hat SurveyMonkey die Datenübermittlungen
          insbesondere durch den Abschluss von Standarddatenschutzklauseln abgesichert,
          sodass diese auf Grundlage von Art. 46 Abs. 2 lit. c) DSGVO erfolgen.
        </p>
        <p>
          Wir haben mit SurveyMonkey einen Vertrag über Auftragsverarbeitung geschlossen.
          Die über das Umfrage-Tool erhobenen Informationen werden von SurveyMonkey daher
          nur gemäß unseren Weisungen verarbeitet. Die Weiterleitung der erhobenen
          Informationen an Survey-Monkey und die dortige Datenverarbeitung erfolgt somit
          in unserem Auftrag gemäß Art. 28 DSGVO.
        </p>
        <p>
          Wir verwenden das Tool von SurveyMonkey auf unserer Webseite nur mit Ihrer
          Einwilligung. Die Rechtsgrundlage für die Verwendung des Tools auf unserer
          Webseite sowie die Anzeige von Umfrage-Popups und die hiermit verbundene
          Datenverarbeitung ist daher Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Die Verwendung von
          Cookies durch das Tool erfolgt ebenfalls auf Grundlage Ihrer Einwilligung gemäß
          § 25 Abs. 1 TDDDG. Sie können jede erteilte Einwilligung jederzeit und mit
          Wirkung für die Zukunft widerrufen, indem Sie Ihre Einstellungen oben im
          Abschnitt Cookies anpassen. Die anschließende Verarbeitung und Auswertung der
          Umfrageergebnisse erfolgt zudem auf Grundlage von Art. 6 Abs. 1 S. 1 lit. f)
          DSGVO. Hierbei liegt unser berechtigtes Interesse in der sachgerechten
          Auswertung des Kundenfeedbacks, welches uns die Teilnehmer:innen der Umfragen
          auf freiwilliger Basis mitteilen.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"><strong>30. Einsatz von Adobe Fonts</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Auf unserer Webseite kommt Adobe Fonts, ein Webschriftarten-Hosting-Dienst, zum
          Einsatz. Dienstanbieter ist das Unternehmen Adobe Systems Software Ireland
          Limited, 4-6 River-walk, Citywest Business Campus, Dublin 24, Irland („Adobe“).
        </p>
        <p>
          Beim Aufruf einer Seite lädt Ihr Browser die benötigten Webfonts in Ihren
          Browsercache, um Texte und Schriftarten korrekt anzuzeigen. Zu diesem Zweck muss
          der von Ihnen verwendete Browser Verbindung zu den Servern von Adobe aufnehmen.
          Dabei erhebt Adobe folgende Daten:
        </p>
        <ul>
          <li>Ihre IP-Adresse,</li>
          <li>die Zeit, die der Webbrowser zum Herunterladen der Schriften benötigt,</li>
          <li>
            die Zeit vom Herunterladen der Schriften mit dem Webbrowser bis zur Anwendung
            der Schriften,
          </li>
          <li>
            ob ein Werbeblocker installiert ist, um festzustellen, ob der Werbeblocker die
            korrekte Verfolgung der Seitenaufrufe beeinträchtigt,
          </li>
          <li>sowie die Betriebssystem- und Browser-Version.<br />&nbsp;</li>
        </ul>
        <p>
          Die Einbindung von Adobe Fonts erfolgt auf Grundlage unseres berechtigten
          Interesses gemäß Art. 6 Abs. 1 S. 1 lit. f) DSGVO. Unser berechtigtes Interesse
          besteht in einer einheitlichen, technisch zuverlässigen und ansprechenden
          Darstellung unserer Webseite.
        </p>
        <p>
          Die Daten werden auf Adobe Servern innerhalb der Europäischen Union, in anderen
          Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum oder in den
          USA bis zu einem Jahr gespeichert. Im Zusammenhang mit den oben genannten
          Funktionen kann Adobe die dabei verarbeiteten Daten auch an Server außerhalb der
          EU, insbesondere der Adobe Inc. in den USA übermitteln, soweit dies zur
          Erbringung dieser Dienste notwendig ist. Die Adobe Inc. ist unter dem EU-US Data
          Privacy Framework (DPF) zertifiziert und in die vom U.S. Department of Commerce
          geführte Liste (DPF List) eingetragen. Bei der Übermittlung von Daten an Server
          von Adobe in den USA ist daher ein durchgängig hohes Datenschutzniveau
          gewähreistet. Soweit eine Übermittlung der Daten in die USA erfolgt, basiert ein
          solcher Drittlandtransfer auf Art. 45 Abs. 1 S. 1 DSGVO.
        </p>
        <p>
          Weitere Informationen zu Adobe Fonts finden Sie in der Datenschutzerklärung
          unter
          <a href="https://www.adobe.com/de/privacy/policy.html"
            >https://www.adobe.com/de/privacy/policy.html</a
          >
          und unter
          <a href="https://www.adobe.com/de/privacy/policies/adobe-fonts.html"
            >https://www.adobe.com/de/privacy/policies/adobe-fonts.html</a
          >.
        </p>
        <p>
          Wenn Ihr Browser Fonts nicht unterstützt, wird eine Standardschrift von Ihrem
          Computer genutzt.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"><strong>31. Einsatz von Google Ads</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Wir haben auf dieser Webseite den Werbedienst Google Ads integriert, der von
          Google Ireland Limited, Google Building Gordon House, Barrow St, Dublin 4,
          Irland (nachfolgend bezeichnet als „Google“) angeboten wird. Google Ads dient
          dem Ausspielen von Werbung in der Suchmaschine und auf Seiten von Google und von
          Partnern von Google („Google-Werbenetzwerk“). Im Rahmen dieses Dienstes nutzen
          wir die sog. Conversion-Tracking-Funktion zur Analyse der Werbekampagnen, sofern
          Sie dem zustimmen. Die Werbung spielen wir auch durch geräteübergreifende Werbe-
          und Remarketing-Funktionen aus, über die unsere Werbeangebote zielgerichtet an
          Nutzer ausgespielt werden, die z.B. durch einen vorherigen Besuch unserer
          Webseite ein generelles Interesse an unseren Angeboten signalisiert haben.
        </p>
        <p>
          Im Rahmen dieses Werbedienstes wählt Google eigenverantwortlich aus, welche
          Werbung welchem jeweiligen Nutzer im Google-Werbenetzwerk angezeigt wird.
          Weisungsmöglichkeiten oder genaueren Einfluss auf diese Auswahl haben wir nicht.
          Wir können lediglich bei der Bestellung der Werbeanzeigen durch wenige von
          Google vorgegebene Voreinstellungsoptionen vorab grobe Einschränkungen dazu
          treffen, wo potenziell Werbung ausgespielt werden darf. Wir übermitteln in
          diesem Zusammenhang keine personenbezogenen Daten an Google und erhalten weder
          die von Google verarbeiteten Daten der Nutzer, denen Werbeanzeigen gezeigt
          werden, noch haben wir näheren Einfluss auf die damit zusammenhängende
          Datenverarbeitung.
        </p>
        <p>
          Die Werbemittel werden durch Google über sog. „Ad Server“ ausgeliefert. Dazu
          nutzen wir und andere Webseiten sog. Ad Server-Cookies, durch die bestimmte
          Parameter zur Erfolgsmessung, wie Einblendung der Anzeigen oder Klicks durch die
          Nutzer, gemessen werden können. Über die auf unserer Webseite gespeicherten
          Google Ads-Cookies können wir Informationen über den Erfolg unserer
          Werbekampagnen erhalten. Diese Cookies sollen nicht dazu dienen, Sie persönlich
          zu identifizieren. Zu diesem Cookie werden in der Regel als Analyse-Werte die
          Unique Cookie-ID, Anzahl Ad-Impressions pro Platzierung (Fre-quency), letzte
          Impression (relevant für Post-View-Conversions) sowie Opt-out-Informationen
          (Markierung, dass ein Nutzer nicht mehr angesprochen werden möchte) gespeichert.
          Die von Google gesetzten Cookies ermöglichen es Google, Ihren Internetbrowser
          wiederzuerkennen. Sofern ein Nutzer bestimmte Seiten der Webseite eines
          Ads-Kunden besucht und das auf seinem Computer gespeicherte Cookie noch nicht
          abgelaufen ist, können Google und der Kunde erkennen, dass der Nutzer auf die
          Anzeige geklickt hat und zu dieser Seite weitergeleitet wurde. Jedem Ads-Kunden
          wird ein anderes Cookie zugeordnet, sodass die Cookies nicht über die Webseite
          von anderen Ads-Kunden nachverfolgt werden können.
        </p>
        <p>
          Durch die Einbindung von Google Ads erhält Google die Information, dass Sie den
          entsprechenden Teil unseres Internetauftritts aufgerufen oder eine Anzeige von
          uns angeklickt haben. Sofern Sie bei einem Dienst von Google registriert sind,
          kann Google den Besuch Ihrem Account zuordnen. Selbst wenn Sie nicht bei Google
          registriert sind bzw. sich nicht eingeloggt haben, besteht die Möglichkeit, dass
          der Anbieter Ihre IP-Adresse in Erfahrung bringt und speichert. Aufgrund der
          eingesetzten Marketing-Tools baut Ihr Browser automatisch eine direkte
          Verbindung mit dem Server von Google auf. Wir selbst erheben in den genannten
          Werbemaßnahmen nicht eigenständig personenbezogene Daten, sondern stellen allein
          für Google die Möglichkeit zur Erhebung der Daten bereit. Wir erhalten von
          Google lediglich statistische Auswertungen, die Auskunft erteilen, welche
          Anzeigen wie oft zu welchen Preisen angeklickt wurden. Weitergehende Daten aus
          dem Einsatz der Werbemittel erhalten wir nicht, insbesondere können wir die
          Nutzer nicht anhand dieser Informationen identifizieren.
        </p>
        <p>
          Wir nutzen Google Ads mit der zusätzlichen Anwendung „Google Conversion
          Tracking“. Hierbei handelt es sich um ein Verfahren, mit dem wir den Erfolg
          unserer Werbekampagnen prüfen können. Dazu werden die Werbeanzeigen mit einer
          technischen Vorkehrung, z.B. einer ID versehen, mit der wir feststellen können,
          wie ein Nutzer nach dem Klick auf die Werbeanzeigen interagiert und ob eine
          unserer Leistungen tatsächlich in Anspruch genommen wird. Dadurch erhalten wir
          in statistischer Form Informationen über die Gesamtzahl der Leser unserer
          Anzeigen, welche Anzeigen besonders beliebt sind und ggf. weitere Informationen
          über die Folgen aus der Anzeige. Für das Conversion-Tracking wird ein Cookie
          („Conversion-Cookie“) von Google auf Ihrem Endgerät gespeichert, wenn Sie auf
          eine Werbeanzeige von uns im Google-Werbenetzwerk klicken.
        </p>
        <p>
          Dieses Cookie wird spätestens nach 90 Tagen gelöscht. Beim Besuch unserer
          Webseite erfahren wir und Google, dass Sie auf eine unserer Anzeigen geklickt
          haben und darüber zu unserer Webseite weitergeleitet wurden. Diese Information
          wird dabei möglicherweise an Server von Google in den USA gesendet. Dadurch
          werden Kontakte, die Sie mit Werbeeinblendungen auf Webseiten des
          Google-Werbenetzwerks haben (Sichtkontakte und Klicks auf Werbebanner), von
          Google mit Ihren nachfolgenden Interaktionen auf unserer Webseite verknüpft.
          Google erfasst hierbei auch Ihre IP-Adresse, die individuelle Werbe-ID Ihres
          Endgeräts und technische Informationen zu Ihrem Endgerät. Die dabei erhobenen
          Daten werden von Google ausgewertet und zur Erstellung von statistischen
          Berichten verwendet. In diesem Zusammenhang verwendet Google auch weitere, Sie
          betreffende Daten, die Google bei Ihrer Nutzung von Google-Diensten erhoben hat,
          wie Alter, Geschlecht und allgemeine Kategorien von Themen, an denen Sie
          Interesse gezeigt haben. Wir erhalten im Rahmen des Conversion-Trackings nur
          aggregierte Informationen, die wir keinem einzelnen Nutzer zuordnen können, und
          keinesfalls Informationen, mit denen wir Nutzer persönlich identifizieren
          können.
        </p>
        <p>
          Außerdem verwenden wir mit Ihrer Einwilligung die Remarketing-Funktion von
          Google zur gezielteren Werbeausspielung. Wenn Sie unsere Webseite besuchen und
          Sie dadurch Ihr generelles Interesse an den Inhalten auf unserer Webseite zum
          Ausdruck bringen, wird über den Conversion-Cookie gezielt Werbung zu unseren
          Angeboten im Google-Werbenetzwerk angezeigt. Dazu wird mit dem Conversion-Cookie
          zugeordnet, ob Sie unsere Webseite bereits besucht haben, und diese Information
          wird zusammen mit dem Cookie an Server von Google, die sich möglicherweise auch
          in den USA befinden, weitergeleitet. Wir erhalten dabei jedoch keine
          Informationen, mit denen wir Sie persönlich identifizieren könnten.
        </p>
        <p>
          Auch bei dieser Remarketing-Funktion entscheidet letztlich Google selbständig
          über die konkret ausgespielte Werbung, insbesondere den genauen Zeitpunkt der
          Ausspielung und die Platzierung der Werbung, sowie die Auswahl, ob unsere
          Werbung unter den verschiedenen Personen, die unsere Webseite besucht haben,
          auch konkret Ihnen angezeigt wird.
        </p>
        <p>
          Die Nutzung aller oben genannten Funktionen der Google-Werbedienste erfolgt nur
          mit Ihrer Einwilligung und damit auf der Grundlage von Art. 6 Abs. 1 S. 1 lit.
          a) DSGVO und § 25 Abs. 1 TDDDG. Sie können Ihre Einwilligungen jederzeit mit
          Wirkung für die Zukunft widerrufen. Dazu können Sie Ihre Einstellungen oben im
          Abschnitt Cookies entsprechend anpassen.
        </p>
        <p>
          Alle vorgenannten Funktionen von Google Ads werden von Google geräteübergreifend
          ausgeführt. Google kann also Ihre Nutzung in bestimmten Fällen über
          verschiedene, von Ihnen genutzte Endgeräte hinweg erkennen und verknüpfen. Dazu
          erfasst Google, wenn Sie sich im Browser auf einem Gerät in Ihrem Konto für die
          Google-Dienste (wie Gmail, YouTube oder den Chrome-Browser) angemeldet haben,
          und ordnet Ihre Nutzung auf den betreffenden Geräten Ihrem Google-Konto zu. Über
          diese geräteübergreifende Verknüpfung kann Google Ihnen beispielsweise unsere
          potenziell für Sie interessante Werbung, z.B. nach Ihrem Besuch unserer
          Webseite, anzeigen, auch wenn Sie ein anderes Gerät nutzen. Außerdem kann Google
          ggf. Ihren (erneuten) Besuch unserer Webseite in Beziehung zu etwaigen
          vorherigen Interaktionen mit unserer Werbung setzen und dadurch die Erfolge
          unserer Werbekampagnen näher ermitteln, unabhängig davon, über welches konkrete
          Gerät Sie unsere Webseite besuchen.
        </p>
        <p>
          Die geräteübergreifende Verknüpfung wird von Google auch automatisch
          verarbeitet, um die Wege, über die Sie auf unsere Webseite gelangt sind, näher
          auszuwerten. Wir können diese automatische Funktion von Google nicht separat
          deaktivieren. Wir nehmen aber keinen näheren Einblick in diese besonderen
          Auswertungen von Google und verwenden diese auch nicht zu unseren Zwecken. Wenn
          Sie diese Verknüpfung mit Ihrem Google-Konto nicht wünschen, können Sie sich in
          Ihrem Google-Konto abmelden, bevor Sie unsere Webseite aufrufen, und so eine
          Verknüpfung verhindern.
        </p>
        <p>
          Die geräteübergreifende Verknüpfung können Sie auch von vornherein unterbinden,
          indem Sie sicherstellen, dass personalisierte Werbung in den Einstellungen Ihres
          Google-Kontos deaktiviert ist. Die Deaktivierung wird von Google auf der
          Supportseite näher beschrieben.
        </p>
        <p>
          Im Zusammenhang mit den oben genannten Funktionen kann Google die dabei
          verarbeiteten Daten auch an Server außerhalb der EU, insbesondere der Google LLC
          in den USA, übermitteln, soweit dies zur Erbringung dieser Dienste notwendig
          ist. Die Übermittlung basiert auf Art. 45 Abs. 1 S. 1 DSGVO. Es wird insoweit
          auf die Ausführungen zu Drittlandtransfers im Abschnitt zu Google Analytics
          verwiesen.
        </p>
        <p>
          Weitere Informationen zur Verarbeitung Ihrer personenbezogenen Daten durch
          Google im Rahmen von Google Ads, zu Kontaktdaten, über die Sie Ihre damit
          zusammenhängenden Rechte als Betroffener gegenüber Google geltend machen können,
          und die geltenden Datenschutzbestimmungen von Google können Sie auf in der
          Datenschutzerklärung von Google auf
          <a href="https://ads.google.com/intl/de_de/home/faq/gdpr/"
            >https://ads.google.com/intl/de_de/home/faq/gdpr/</a
          >
          und dieser Hilfeseite von Google auf
          <a href="https://support.google.com/google-ads/?hl=de#topic=10286612"
            >https://support.google.com/google-ads/?hl=de#topic=10286612</a
          >
          abrufen.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>32. Online-Live-Beratung per Chat oder Video</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Zur Klärung produktspezifischer Fragen bieten wir Ihnen die Möglichkeit, mit
          unseren Beratern per Textchat oder Video in Echtzeit in Kontakt zu treten (sog.
          „Live-Beratung“). Für die technische Einbindung der Live-Beratung nutzen wir die
          Plattform PoSLive der FLZR GmbH, Streustraße 67-68, 13086 Berlin („PoSLive“).
          Sie haben die Wahl, ob Sie mit unseren Beratern mittels Textchat oder Video in
          Kontakt treten möchten.
        </p>
        <p>
          Die Live-Beratung ist nur für bestimmte Produkte und zu bestimmten
          Beratungszeiten verfügbar. Sie können die Live-Beratung durch Klick auf den Link
          „Zur Live-Beratung“ erreichen, der auf einigen Produktseiten am rechten unteren
          Ende des Browsers eingeblendet wird. Nach dem Klick auf den Link werden Sie auf
          unsere PoSLive-Beratungsseite weitergeleitet. Bei dem Aufruf der Beratungsseite
          speichert der Webserver automatisch ein sogenanntes Server-Logfile, das z.B.
          Ihre IP-Adresse, Datum und Uhrzeit des Abrufs, übertragene Datenmenge und den
          anfragenden Provider (Zugriffsdaten) enthält und den Abruf dokumentiert. Diese
          Zugriffsdaten werden nicht ausgewertet und spätestens sieben Tage nach Ende
          Ihres Seitenbesuchs automatisch gelöscht.
        </p>
        <p>
          Mit Ihrer Einwilligung wird auf der PoSLive-Beratungsseite zudem Google
          Analytics zur Erfassung und Analyse der Benutzung der Webseite und des
          Beratungsangebots verwendet. Weitere Informationen zum Einsatz von Cookies und
          der weiteren Datenverarbeitung durch Google Analytics finden Sie in dieser
          Datenschutzerklärung unter dem Abschnitt „Werbeana-lyse mit Google Analytics“.
          Wie dort beschrieben wird, erfolgen der Einsatz von Cookies und die
          anschließende Datenverarbeitung jeweils auf Grundlage Ihrer Einwilligung nach §
          25 Abs. 1 TDDDG bzw. Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Sie können bereits
          erteilte Einwilligungen für Ihr jeweiliges Endgerät jederzeit mit Wirkung für
          die Zukunft widerrufen, indem Sie Ihre Einstellungen in den Cookie-Einstellungen
          der PoSLive-Beratungsseite anpassen.
        </p>
        <p>
          <a href="https://pos-live.com/de/datenschutzerklaerung/"
            >https://pos-live.com/de/datenschutzerklaerung/</a
          >
        </p>
        <p>
          Wenn Sie die Live-Beratung per Text oder Video in Anspruch nehmen, werden Ihre
          Kommunikationsinhalte (d.h. Text- oder Spracheingaben), ein Hashwert Ihrer
          IP-Adresse sowie einzelne Metadaten (z.B. Zeitpunkt und Dauer der Live-Beratung,
          ggf. Warteposition) erhoben und zur sachgerechten Bearbeitung Ihrer Anfrage
          verarbeitet. Die Chatprotokolle werden nur für die Dauer der Session gespeichert
          und hiernach automatisch gelöscht.
        </p>
        <p>
          Bei Aktivierung des Videochats greift Ihr Browser auf das Mikrofon Ihres
          Endgeräts zu. Im Rahmen des Videochats werden von Ihnen keine Bild-, sondern
          Audioaufnahmen übertragen. Obwohl Sie also unseren Berater während der
          Live-Beratung sehen und hören können, kann dieser Sie nur hören. Die
          übermittelten Sprach- bzw. Stimmdaten werden nicht gespeichert, ausgewertet oder
          analysiert. Eine Aufzeichnung des Videochats erfolgt nicht.
        </p>
        <p>
          Sie können auf unserer PoSLive-Beratungsseite einen Beratungstermin buchen.
          Hierbei werden das ausgewählte Datum und die Uhrzeit des Termins, das
          Beratungsthema (z.B. Produkt) sowie Ihre E-Mail-Adresse erhoben und zur
          Durchführung des Termins verarbeitet. Eine Bestätigung des gebuchten Termins
          wird Ihnen per E-Mail übersendet. Die erhobenen Daten werden im Regelfall nach
          Durchführung bzw. Verstreichen des gebuchten Termins gelöscht.
        </p>
        <p>
          Wir haben einen Vertrag über Auftragsverarbeitung mit PoSLive geschlossen. Die
          vorstehenden Daten werden von PoSLive somit lediglich im erforderlichen Umfang
          weisungsgebunden in unserem Auftrag gemäß Art. 28 DSGVO verarbeitet. Die Daten
          werden ausschließlich auf Servern innerhalb des Europäischen Wirtschaftsraums
          gespeichert.
        </p>
        <p>
          Grundlage für die vorstehend beschriebene Verarbeitung Ihrer personenbezogenen
          Daten in Zusammenhang mit der Live-Beratung ist Art. 6 Abs. 1 S. 1 lit. b)
          DSGVO, soweit Sie diese personenbezogenen Daten zwecks Anbahnung eines Vertrages
          mit uns eingeben. Andernfalls erfolgt die Datenverarbeitung aufgrund von Art. 6
          Abs. 1 S. 1 lit. f) DSGVO, wobei unser berechtigtes Interesse die Bereitstellung
          eines kundenfreundlichen Beratungsangebots und die kompetente Bearbeitung Ihres
          Beratungsanliegens ist.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>33. Webanalyse durch Tracify</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Wir setzen auf unserer Webseite oder auf Teilen unserer Webseite den
          Webanalysedienst Tracify ein, um zu erfassen, wie unsere Webseite von deren
          Besuchern genutzt wird und um die Effektivität unserer Werbe-/Marketingmaßnahmen
          zu evaluieren und zu optimieren. Tracify ist Webanalysedienst der Tracify GmbH,
          Agnes-Pockels-Bogen 1, 80992 München, Deutschland. Die Tracify GmbH wird dabei
          als Auftragsverarbeiter auf Basis einer Vereinbarung Auftragsverarbeitung gemäß
          Art. 28 DSGVO für uns tätig.
        </p>
        <p>
          Tracify ermöglicht eine Analyse der Nutzung der Webseite und der Customer
          Journey, ohne Cookies oder sonstige Informationen auf dem Endgerät des Users zu
          speichern, sondern lediglich auf Basis von Browser- und Geräteinformationen, wie
          z.B. der IP-Adresse des Users, der Konfiguration des jeweiligen Nutzeragenten
          (User Agent String), Nutzungsdaten, Bestellinformation, Kontaktdaten, der
          Bildschirmauflösung, den installierten Schriftarten und Plugins und des
          Prozessors des jeweiligen Gerätes.
        </p>
        <p>
          Die an Tracify übermittelten Informationen werden sofort nach Übermittlung
          vollständig und unumkehrbar anonymisiert, sodass ein Personenbezug
          ausgeschlossen ist. Es werden lediglich die anonymisierten, aggregierten
          Informationen analysiert.
        </p>
        <p>
          Die Datenverarbeitung bei der Nutzung von Tracify erfolgt vollumfänglich in
          Deutschland, es findet keine Datenübermittlung in unsichere Drittländer ohne
          angemessenes Datenschutzniveau statt.
        </p>
        <p>
          Rechtsgrundlage für die Nutzung von Tracify ist unser berechtigtes Interesse
          gemäß Art. 6 Abs. 1 S. 1 lit. f) DSGVO an einer bedarfsgerechten Gestaltung der
          Webseite und an der Evaluierung und Optimierung unserer Marketingmaßnahmen.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>34. Contextual Advertising mit AdClash</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Wir nutzen den Service AdClash der Oliro GmbH, Gredinger Str. 24a, 90453
          Nürnberg zur Einbindung und Ausspielung kontextbezogener Online-Werbung
          (Contextual Advertising).
        </p>
        <p>
          Der Dienst dient dazu, Nutzern thematisch passende Werbeanzeigen bereitzustellen
          und die Auslieferung sowie Darstellung von Werbemitteln technisch zu
          ermöglichen. Dabei können folgende personenbezogene Daten verarbeitet werden:
          IP-Adresse, Informationen zum verwendeten Browser und Endgerät,
          Betriebssysteminformationen, Datum und Uhrzeit des Zugriffs, Informationen zur
          besuchten Webseite und deren Kontext, technische Informationen zur Auslieferung
          und Darstellung von Werbemitteln.
        </p>
        <p>
          Dabei werden Cookies und ähnliche Technologien eingesetzt, um auf anderen
          Webseiten Werbung auszuliefern.
        </p>
        <p>
          Die Nutzung des oben genannten Dienstes erfolgt nur mit Ihrer Einwilligung auf
          Grundlage von Art. 6 Abs. 1 S. 1 lit. a) DSGVO. Rechtsgrundlage für den Einsatz
          von Cookies oder ähnlichen Technologien auf Ihrem Endgerät ist § 25 Abs. 1
          TDDDG. Ihre Einwilligungen können Sie bezüglich Ihres jeweils verwendeten
          Endgeräts jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie Ihre
          Einstellungen oben im Abschnitt Cookies anpassen.
        </p>
        <p>
          Die Einwilligung zur Verarbeitung der Daten für den Service AdClash kann hier
          widerrufen werden:
          <a href="https://www.gsi-one.org/de/opt-out.html"
            >https://www.gsi-one.org/de/opt-out.html</a
          >.
        </p>
        <p>
          Die Datenschutzerklärung sowie weitere Informationen finden Sie hier:
          <a href="https://adclash.de/datenschutz/">https://adclash.de/datenschutz/</a>
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"
            ><strong>35. Überarbeitung der Datenschutzerklärung</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          expert wird von Zeit zu Zeit diese Datenschutzerklärung prüfen und überarbeiten,
          soweit dies z.B. aufgrund neuer technischer Entwicklungen oder Änderungen in der
          Rechtsprechung oder in unserem Geschäftsbetrieb angezeigt ist. Daher empfiehlt
          es sich, die Regelungen dieser Datenschutzerklärung von Zeit zu Zeit zu lesen,
          um sicherzustellen, dass Sie wissen, wie expert Daten erhebt, verarbeitet und
          nutzt.
        </p>
        <p>&nbsp;</p>
        <p>
          <span class="text-base"><strong>36. Weitere Informationen</strong></span
          ><span class="text-base"
            ><strong><br /></strong
          ></span>
        </p>
        <p>
          Sollten Sie Fragen bezüglich unserer Datenschutzerklärung haben, wenden Sie sich
          bitte an <a href="mailto:datenschutz@expert.de">datenschutz@expert.de</a>. Für
          allgemeine Fragen nutzen Sie bitte das Kontaktformular auf unserer Webseite.
        </p>
        <p>&nbsp;</p>
      </div>
    </div>
    <div
      data-subwidget-id="d3469413-ce93-4a21-8658-d94db6377217"
      widget-child="content"
      style="
        background-repeat: no-repeat;
        background-position-x: center;
        background-position-y: center;
        background-size: auto;
      "
      data-widget-id="40c0ca5e-b53d-4a6b-a798-9111d0576ba2"
      class="widget widget-Container widget-Container---size-default widget-Container---40c0ca5e-b53d-4a6b-a798-9111d0576ba2 widget-Container---view-container widget-Container---preset-default"
    >
      <div
        data-subwidget-id="01bc113f-cffd-4a04-9afd-155127fab515"
        data-widget-id="371a9216-2229-4078-88c9-3851b664a60e"
        class="widget widget-Text widget-Text---371a9216-2229-4078-88c9-3851b664a60e widget-Text---view-text widget-Text---preset-default"
      >
        <p>
          <span class="text-base"
            ><strong>37. PAYBACK und expert Services</strong></span
          >
        </p>
        <p>
          Bei verschiedenen unserer Partner haben Sie die Möglichkeit, ausgewählte PAYBACK
          Services direkt in elektronischen Medien (z.B. Website und/oder Apps) sowie im
          Service Center von PAYBACK. Dies gilt auch für die expert Warenvertrieb GmbH
          („expert“). Die PAYBACK GmbH („PAYBACK”) bindet umgekehrt einige Services von
          expert direkt in elektronischen Medien (z.B. Website und/oder Apps) sowie im
          Service Center von PAYBACK ein.<br />Diese Hinweise zum Datenschutz informieren
          Sie über die Verarbeitung Ihrer Daten bei solchen Services. Bitte beachten Sie
          ergänzend auch die allgemeinen Hinweise zum Datenschutz beim PAYBACK Programm.
          Diese finden Sie
          <span style="text-decoration: underline"
            ><a href="https://www.payback.de/info/hinweise-datenschutz">hier</a></span
          >.<br />&nbsp;
        </p>
      </div>
      <div
        data-subwidget-id="de43b26e-c291-40ca-ade4-bf75af9e5fa1"
        data-widget-id="61e126b5-d807-4589-9702-f6fa7e305466"
        class="widget widget-Text widget-Text---61e126b5-d807-4589-9702-f6fa7e305466 widget-Text---view-text widget-Text---preset-default"
      >
        <p><strong>A. Inhalt der PAYBACK und expert Services</strong></p>
        <p>
          Derzeit gibt es die folgenden PAYBACK Services bei expert und anderen Partnern:
        </p>
        <ul>
          <li>Mit PAYBACK bei dem jeweiligen Partner anmelden</li>
          <li>Anzeigen und Aktivieren Ihrer aktuellen PAYBACK eCoupons</li>
          <li>Sammeln und Einlösen von PAYBACK Punkten bei dem jeweiligen Partner</li>
          <li>Anzeige Ihres PAYBACK Punktestandes</li>
          <li>
            Anzeige von Rabattdaten für Ihre bei dem jeweiligen Partner gesammelten Punkte
            (nicht jedoch für die bei anderen Partnern gesammelten Punkte)
          </li>
          <li>
            Ergänzung oder Berichtigung Ihrer bei PAYBACK oder dem jeweiligen Partner
            gespeicherten Adressdaten und sonstigen Kontaktdaten
          </li>
          <li>Bestellung von PAYBACK Vorteilservices (z.B. Coupon-Mail)</li>
          <li>Bestellung von eigenen PAYBACK Services des jeweiligen Partners</li>
        </ul>
        <p>
          &nbsp;<br />Anbieter dieser Services sind die jeweiligen Partner, so dass Sie
          dort die Nutzung des gewünschten Service auswählen müssen. Bitte beachten Sie,
          dass derzeit nicht alle Partner alle der oben genannten Services in allen ihren
          elektronischen Medien und in ihrem Service Center anbieten. Die von einem
          bestimmten Partner aktuell angebotenen PAYBACK Services können Sie bei dem
          jeweiligen Partner oder im PAYBACK Service Center erfragen.
        </p>
        <p>Derzeit gibt es die folgenden Services von expert bei PAYBACK:</p>
        <ul>
          <li>
            Anzeigen und Aktivieren aktueller eCoupons und Angebote von expert bei
            PAYBACK.
          </li>
        </ul>
        <p>&nbsp;<br />Anbieter dieses Service ist PAYBACK.<br />&nbsp;</p>
      </div>
      <div
        data-subwidget-id="621b2923-3873-4a89-a58f-53beb08cf3d7"
        data-widget-id="1b081dd5-d1a4-4b96-8bca-8eca39ad4755"
        class="widget widget-Text widget-Text---1b081dd5-d1a4-4b96-8bca-8eca39ad4755 widget-Text---view-text widget-Text---preset-default"
      >
        <p><strong>B. Datenschutzrechtlich Verantwortliche</strong></p>
        <p>
          Datenschutzrechtlich Verantwortliche für die PAYBACK und expert Services sind
          einerseits die PAYBACK GmbH als Programmbetreiber und andererseits expert als
          Partner.
        </p>
        <p>
          Die PAYBACK GmbH und expert sind dabei teilweise gemeinsam Verantwortliche. Sie
          haben insoweit in Vereinbarungen festgelegt, wer von ihnen welche
          datenschutzrechtlichen Verpflichtungen erfüllt. Das Wesentliche dieser
          Vereinbarungen finden Sie unter
          <span style="text-decoration: underline"
            ><a href="https://www.payback.de/gemeinsam-verantwortlich"
              >https://www.payback.de/gemeinsam-verantwortlich</a
            ></span
          >.<br />&nbsp;
        </p>
      </div>
      <div
        data-subwidget-id="a2b90213-5d72-4549-817b-7bce05c73b42"
        data-widget-id="62b9f04a-d2da-480a-9acb-521f57fb0fd2"
        class="widget widget-Text widget-Text---62b9f04a-d2da-480a-9acb-521f57fb0fd2 widget-Text---view-text widget-Text---preset-default"
      >
        <p><strong>C. Ihre Daten bei Nutzung der PAYBACK und expert Services</strong></p>
        <p>
          Bevor Sie die PAYBACK und expert Services bei expert nutzen können, leitet Sie
          expert zu einem elektronischen Medium der PAYBACK GmbH weiter. Dort müssen Sie
          PAYBACK und expert ausdrücklich beauftragen, bei expert die Möglichkeit zur
          Nutzung der PAYBACK und expert Services freizuschalten, um der PAYBACK GmbH die
          Übermittlung von Daten an expert zu erlauben. Erst danach werden die PAYBACK
          GmbH und expert die für die von Ihnen gewünschten PAYBACK und expert Services
          erforderlichen Daten untereinander austauschen und für die Erbringung dieser
          PAYBACK und expert Services verwenden.
        </p>
        <p>
          Abhängig von den genutzten PAYBACK und expert Services kann es sich hierbei um
          die folgenden Daten handeln:
        </p>
        <ul>
          <li>Ihre Anrede und Ihr vollständiger Name</li>
          <li>Ihr Geburtsdatum</li>
          <li>Ihre Wohnanschrift und ggf. abweichende Lieferanschrift(en)</li>
          <li>Ihre E-Mail-Adresse</li>
          <li>Ihre Telefonnummer(n)</li>
          <li>Ihre PAYBACK Kunden- und Kartennummer(n)</li>
          <li>Ihre expert Kundennummer(n)</li>
          <li>Ihr PAYBACK Punktestand</li>
          <li>
            Die Rabattdaten für Ihre bei expert gesammelten PAYBACK Punkte (nicht jedoch
            für die bei anderen Partnern gesammelten Punkte)
          </li>
          <li>Ihre aktuellen PAYBACK eCoupons zur Anzeige und Aktivierung bei expert</li>
          <li>
            Ihre aktuellen expert eCoupons und Angebote zur Anzeige und Aktivierung bei
            PAYBACK
          </li>
          <li>
            Ort und Zeitpunkt der Anzeige und ggf. Aktivierung der jeweiligen eCoupons und
            Angebote
          </li>
          <li>die von Ihnen ggf. bestellten PAYBACK Vorteilservices</li>
        </ul>
        <p>
          &nbsp;<br />Die im Rahmen der PAYBACK und expert Services übermittelten Daten
          verarbeiten PAYBACK und expert zur Erbringung der von Ihnen gewünschten PAYBACK
          und expert Services.Rechtsgrundlage für die hier in Abschnitt C beschriebene
          Verarbeitung Ihrer Daten ist Art. 6 Abs. 1 b) DSGVO (Vertragserfüllung und
          vorvertragliche Maßnahmen).<br />&nbsp;
        </p>
      </div>
      <div
        data-subwidget-id="d953feba-2f2a-42a1-ba48-10a90bb81a03"
        data-widget-id="04932f06-8ad7-4a88-b1be-bd7b1d58ac51"
        class="widget widget-Text widget-Text---04932f06-8ad7-4a88-b1be-bd7b1d58ac51 widget-Text---view-text widget-Text---preset-default"
      >
        <p id="Einwilligung"><strong>D. Werbung und Marktanalysen</strong></p>
        <p>
          Sie können einwilligen, dass Ihre Daten zusätzlich für Zwecke der
          personalisierten Werbung und für werbliche Marktanalysen verwendet werden:
        </p>
        <p>
          <em
            >D.1 Ihre Einwilligung in personalisierte Werbung durch expert und PAYBACK</em
          >
        </p>
        <p>
          Wenn Sie Ihre Einwilligung in personalisierte Werbung durch expert und PAYBACK
          erteilen, können expert und die PAYBACK GmbH Ihre Daten wie in der Einwilligung
          beschrieben für personalisierte Werbung und für werbliche Marktanalysen
          verarbeiten und austauschen.<br />Den genauen Wortlaut der Einwilligung finden
          Sie hier:<br />&nbsp;
        </p>
      </div>
      <div
        data-subwidget-id="46c6661a-4664-48f1-82d8-41d3f882c6d3"
        widget-child="content"
        style="
          background-color: rgba(235, 235, 235, 1);
          background-repeat: no-repeat;
          background-position-x: center;
          background-position-y: center;
          background-size: auto;
        "
        data-widget-id="ade25461-b393-42fb-b307-492ecb6b5433"
        class="widget widget-Container widget-Container---size-default widget-Container---ade25461-b393-42fb-b307-492ecb6b5433 widget-Container---view-container widget-Container---preset-default margin-xs-right-15 margin-xs-bottom-20 margin-xs-left-15 padding-xs-top-10 padding-xs-bottom-10"
      >
        <div
          data-subwidget-id="13835149-58ac-4a65-976e-0a58bb4b69da"
          data-widget-id="e4e66c82-87ab-4e47-8911-8efe0fd30884"
          class="widget widget-Text widget-Text---e4e66c82-87ab-4e47-8911-8efe0fd30884 widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <strong>Einwilligung in personalisierte Werbung durch</strong> expert
            <strong>und PAYBACK</strong>
          </p>
          <p>
            <span style="color: #004f9f"><strong>Das Wichtigste vorab:</strong></span> Ich
            willige ein, dass
          </p>
          <ul>
            <li>die expert Warenvertrieb GmbH und</li>
            <li>die PAYBACK GmbH</li>
          </ul>
          <p>
            &nbsp;<br />meine Daten für auf mich zugeschnittene Werbung und für werbliche
            Marktanalysen verarbeiten. Dafür dürfen sie meine Daten austauschen und
            Kundenprofile anlegen. Was ich genau erlaube, steht unten in den Details zum
            Umfang der Einwilligung.
          </p>
          <p>
            Ich kann diese Einwilligung jederzeit widerrufen. Andere ggf. von mir erteilte
            Einwilligungen gelten auch dann weiter, wenn ich diese Einwilligung nicht
            erteile oder widerrufe.
          </p>
          <p>Hier die Details zum Umfang der Einwilligung:<br />&nbsp;</p>
        </div>
        <div
          data-subwidget-id="846c3751-2176-469a-82d9-05bfac2737fb"
          data-widget-id="7d1d096c-0091-4ebc-a4e5-963efa9572ec"
          class="widget widget-Text widget-Text---7d1d096c-0091-4ebc-a4e5-963efa9572ec widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <span style="color: #004f9f"><strong>1. Worum geht es?</strong></span>
          </p>
          <p>
            expert (d.h. die expert Warenvertrieb GmbH) und PAYBACK (d.h. die PAYBACK
            GmbH) möchten auf Basis dieser Einwilligung Daten über mich verarbeiten und
            austauschen. Damit möchten sie Werbung personalisieren und werbliche
            Marktanalysen erstellen.
          </p>
          <p>
            <strong>Personalisierte Werbung</strong> bedeutet, dass anhand meiner Daten
            auf mich zugeschnittene Angebote und andere werbliche Inhalte ausgewählt
            werden.
          </p>
          <p>
            <strong>Marktanalysen</strong> meint die Erstellung von Statistiken, die
            expert und PAYBACK für die Verbesserung ihrer Angebote und Werbung sowie des
            PAYBACK Programms nutzen. Das hat für mich den Vorteil, dass ich Werbung
            erhalte, die besser zu mir, meinen Interessen und Bedürfnissen passt.<br />&nbsp;
          </p>
        </div>
        <div
          data-subwidget-id="d1c17bd9-faf3-4a13-b3a6-905a6f51e5c9"
          data-widget-id="3649c6e3-b986-4786-8949-8f8039bfe7e5"
          class="widget widget-Text widget-Text---3649c6e3-b986-4786-8949-8f8039bfe7e5 widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <span style="color: #004f9f"
              ><strong>2. Wer darf mir Werbung zukommen lassen?</strong></span
            >
          </p>
          <p>
            expert darf mir personalisierte Werbung im Zusammenhang mit dem PAYBACK
            Programm zukommen lassen.
          </p>
          <p>
            Wenn ich zusätzlich eine Einwilligung in personalisierte Werbung im PAYBACK
            Programm (im Folgenden kurz die
            <span style="text-decoration: underline"
              ><strong
                ><a href="https://www.payback.de/info/ewe23"
                  >Programm-Einwilligung</a
                ></strong
              ></span
            >
            genannt) erteilt habe, darf mir PAYBACK auf Grundlage der
            Programm-Einwilligung ebenfalls solche Werbung zukommen lassen.<br />&nbsp;
          </p>
        </div>
        <div
          data-subwidget-id="97552aab-ea55-48d6-8b40-7b9f46466f19"
          data-widget-id="20b05c6c-5096-4ae8-a876-90e450486f82"
          class="widget widget-Text widget-Text---20b05c6c-5096-4ae8-a876-90e450486f82 widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <span style="color: #004f9f"
              ><strong>3. Welchen Inhalt darf die Werbung haben?</strong></span
            >
          </p>
          <p>
            Die Werbung von expert darf PAYBACK Services sowie alle Waren und
            Dienstleistungen betreffen, die expert anbietet.<br />&nbsp;
          </p>
        </div>
        <div
          data-subwidget-id="0e66c8b2-1264-4a8a-9e3f-f1d730182255"
          data-widget-id="de594ce0-4759-4189-99b2-cc5168fafbcc"
          class="widget widget-Text widget-Text---de594ce0-4759-4189-99b2-cc5168fafbcc widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <span style="color: #004f9f"
              ><strong>4. Welche meiner Daten dürfen verarbeitet werden?</strong></span
            >
          </p>
          <p>
            Für die in dieser Einwilligung genannten Zwecke erlaube ich die Verarbeitung
            folgender Daten:
          </p>
          <p><strong>Anmeldedaten:</strong></p>
          <ul>
            <li>
              Die Daten, die ich bei meiner Anmeldung zum Programm oder in meinem PAYBACK
              Konto angegeben habe (z.B. Name, Geburtsdatum, Telefonnummer, Anschrift,
              E-Mail-Adresse)
            </li>
            <li>Wann und wie ich mich zum Programm angemeldet habe</li>
          </ul>
          <p>
            &nbsp;<br /><strong>Einwilligungsdaten:</strong> Die Information, welche
            Einwilligungen ich im Rahmen des Programms erteilt habe
          </p>
          <p><strong>Punktestand:</strong> Mein jeweils aktueller PAYBACK Punktestand</p>
          <p><strong>PAYBACK Profildaten:</strong></p>
          <ul>
            <li>
              Ob ich bestimmte PAYBACK Angebote nutze (Coupons, PAYBACK App, PAYBACK PAY,
              mobile PAYBACK Karte)
            </li>
            <li>Meine Postleitzahl</li>
            <li>Meine Altersgruppe</li>
          </ul>
          <p>
            &nbsp;<br /><strong>Karteneinsatzdaten:</strong> Daten, die beim Sammeln oder
            Einlösen von Punkten anfallen (auch, soweit sie bis zu 5 Jahre vor Abgabe
            dieser Einwilligung angefallen sind, d.h. historische Karteneinsatzdaten):
          </p>
          <ul>
            <li>
              Die verwendete PAYBACK Nummer und wie sie angegeben wurde (z.B. digital per
              App)
            </li>
            <li>Ort und Zeitpunkt des Vorgangs, Waren/Dienstleistungen und Preis</li>
            <li>Gesammelte bzw. eingelöste Punkte</li>
            <li>Genutzte PAYBACK Aktionen oder Coupons</li>
            <li>Wie wurde bezahlt</li>
          </ul>
          <p>
            &nbsp;<br />Soweit solche Daten bei einem abgebrochenen Kaufvorgang anfallen,
            sind sie ebenfalls Karteneinsatzdaten.
          </p>
          <p>
            <strong>Daten zur Servicenutzung:</strong> Die bei meiner Nutzung von PAYBACK
            Services bei expert oder von expert Services bei PAYBACK anfallenden Daten,
            d.h. welchen dieser Services habe ich wann und bei welcher Gelegenheit in
            Anspruch genommen.
          </p>
          <p>
            expert darf Werbung für mich außerdem auf Basis folgender Daten auswählen
            (auch, soweit diese Daten keinen Bezug zum PAYBACK Programm haben):
          </p>
          <p><strong>expert Profildaten:</strong></p>
          <ul>
            <li>
              Meine unabhängig von PAYBACK gegenüber expert erteilten Einwilligungen
            </li>
            <li>
              Ob ich bestimmte expert Angebote nutze (Coupons, Website, App und ggf.
              Nutzung meiner digitalen PAYBACK Karte darin)
            </li>
            <li>Wie ich bei expert bezahle</li>
          </ul>
          <p>
            &nbsp;<br /><strong>expert Werbedaten:</strong> Folgende Daten, wenn expert
            eine bestimmte Werbung ausspielt:
          </p>
          <ul>
            <li>Meine PAYBACK Nummer</li>
            <li>Inhalt der Werbung</li>
            <li>
              Ort und Zeitpunkt, an dem ich sie erhalten und ggf. darauf reagiert habe
            </li>
          </ul>
          <p>
            &nbsp;<br /><strong>Einkaufsdaten ohne PAYBACK:</strong> Folgende Daten, wenn
            ich ohne Einsatz meiner PAYBACK Nummer bei expert einkaufe (auch, soweit sie
            bis zu 5 Jahre vor Abgabe dieser Einwilligung angefallen sind, d.h.
            historische Einkaufsdaten):
          </p>
          <ul>
            <li>Ort und Zeitpunkt des Vorgangs, Waren/Dienstleistungen und Preis</li>
            <li>Genutzte expert Aktionen oder Coupons</li>
          </ul>
          <p>
            &nbsp;<br />Soweit solche Daten bei einem abgebrochenen Kaufvorgang anfallen,
            sind sie ebenfalls Einkaufsdaten.
          </p>
          <p>
            <strong>Kommunikationsdaten:</strong> Daten, die – auch unabhängig von PAYBACK
            Services bei expert – bei meinen Interaktionen mit expert
          </p>
          <ul>
            <li>über die expert Website</li>
            <li>über die expert App</li>
            <li>
              bei Nachrichten von expert an mich (z.B. per E-Mail oder auf das
              Mobiltelefon)
            </li>
          </ul>
          <p>
            &nbsp;<br />anfallen, d.h. wann und wie habe ich welchen dieser
            Kommunikationskanäle genutzt? Diese Daten umfassen Informationen über die von
            mir genutzten Geräte und die genutzten Webseiten oder Apps.
          </p>
          <p>
            <strong>Standortdaten:</strong> Standortdaten in den expert Ladengeschäften
            und anderswo, soweit ich deren Erfassung in den dafür vorgesehenen
            Geräteeinstellungen erlaubt habe und gesondert darüber informiert wurde
          </p>
          <p>
            <strong>Online-Daten:</strong> Von Anbietern digitaler (Werbe-)Dienste (z.B.
            Google Ads) oder sozialer Medien (z.B. Facebook) erhaltene Daten
          </p>
          <p>
            <strong>Daten aus Zufriedenheitsbefragungen:</strong> Die von mir gegebenen
            Antworten
          </p>
          <p>
            <strong>Service-Center Daten:</strong> Anfallende Daten, wenn ich mich mit
            einem Anliegen beim expert Service-Center melde, d.h. wann habe ich mich mit
            welchem Anliegen gemeldet und wie wurde dieses bearbeitet?
          </p>
          <p>
            Aus allen diesen Daten darf expert Wahrscheinlichkeitswerte (z.B. wie sehr ich
            mich vermutlich für ein bestimmtes Produkt interessiere) ableiten und auch
            diese Werte im Rahmen dieser Einwilligung verarbeiten.
          </p>
          <p>
            Wenn expert eine bestimmte Werbung ausspielt, darf expert die dabei
            anfallenden expert Werbedaten erheben und im Rahmen dieser Einwilligung
            verwenden. Im Übrigen darf expert Daten aus dieser Ziffer 4 im Rahmen dieser
            Einwilligung nur verwenden, soweit expert ohnehin über diese Daten verfügt
            oder sie nach der folgenden Ziffer 5 übermittelt wurden.
          </p>
          <p>
            Wenn ich zusätzlich die
            <span style="text-decoration: underline"
              ><a href="https://www.payback.de/info/ewe23">Programm-Einwilligung</a></span
            >
            erteilt habe, darf PAYBACK meine Daten zur Servicenutzung, expert Profildaten
            und expert Werbedaten zu meinen bereits vorhandenen Daten aus der
            Programm-Einwilligung hinzuspeichern. PAYBACK darf sie dann zusammen mit
            diesen Daten auf die in der Programm-Einwilligung beschriebenen Weise
            verarbeiten.<br />&nbsp;
          </p>
        </div>
        <div
          data-subwidget-id="c334252d-48ac-46d1-ad0a-ec88cb273e4b"
          data-widget-id="3b362bb8-3896-4afd-ac1e-cf03a8e99832"
          class="widget widget-Text widget-Text---3b362bb8-3896-4afd-ac1e-cf03a8e99832 widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <span style="color: #004f9f"
              ><strong>5. Welche Daten dürfen übermittelt werden?</strong></span
            >
          </p>
          <p>
            Für die in dieser Einwilligung genannten Zwecke erlaube ich folgende
            Übermittlungen:
          </p>
          <p><strong>Von PAYBACK an expert:</strong></p>
          <ul>
            <li>Meine Anmeldedaten</li>
            <li>Meine Einwilligungsdaten</li>
            <li>Mein Punktestand</li>
            <li>Meine PAYBACK Profildaten</li>
            <li>Meine Daten zur Servicenutzung bei PAYBACK</li>
          </ul>
          <p>&nbsp;<br /><strong>Von expert an PAYBACK:</strong></p>
          <ul>
            <li>Meine expert Profildaten</li>
            <li>Meine expert Werbedaten</li>
            <li>Meine Daten zur Servicenutzung bei expert</li>
            <li>
              Meine PAYBACK Nummer, damit mich PAYBACK anhand dieser Nummer identifizieren
              und mir im Auftrag von expert Werbung zukommen lassen kann
            </li>
          </ul>
          <p>&nbsp;</p>
        </div>
        <div
          data-subwidget-id="8f85c281-e010-40d3-8ed7-4f1da44c04c0"
          data-widget-id="db043bec-fe65-4702-aa39-9ffd519f0130"
          class="widget widget-Text widget-Text---db043bec-fe65-4702-aa39-9ffd519f0130 widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <span style="color: #004f9f"
              ><strong>6. Über welche Kanäle darf ich Werbung erhalten?</strong></span
            >
          </p>
          <p><strong>Von expert:</strong></p>
          <ul>
            <li>
              In den Verkaufsstellen von expert (insbesondere an den dortigen
              Kassensystemen und Kunden-Terminals)
            </li>
            <li>
              Während ich beim expert Service Center anrufe, die Internet-Seite von expert
              besuche oder die expert App benutze
            </li>
            <li>
              In weiteren expert Services (z.B. E-Mail), soweit ich diese gesondert
              bestellt habe
            </li>
          </ul>
          <p>
            &nbsp;<br />Wenn expert der Partner ist, über den ich mich beim PAYBACK
            Programm angemeldet habe, darf mir expert die Werbung auch per Post zusenden.
          </p>
          <p>
            Wenn ich zusätzlich die
            <span style="text-decoration: underline"
              ><a href="https://www.payback.de/info/ewe23">Programm-Einwilligung</a></span
            >
            erteilt habe, darf expert außerdem anhand meiner Daten personalisierte Werbung
            für mich auswählen und über PAYBACK zukommen lassen.<br />&nbsp;
          </p>
        </div>
        <div
          data-subwidget-id="2b268a04-279d-4406-9492-73f3a9534790"
          data-widget-id="fe55e31a-74b3-4d63-b69b-6d3fabbad18a"
          class="widget widget-Text widget-Text---fe55e31a-74b3-4d63-b69b-6d3fabbad18a widget-Text---view-text widget-Text---preset-default"
        >
          <p>
            <span style="color: #004f9f"
              ><strong>7. Zusätzliche Marktanalysen</strong></span
            >
          </p>
          <p>
            expert darf die in Ziffer 4 genannten Daten – soweit sie expert vorliegen –
            außerdem für werbliche Marktanalysen verarbeiten.
          </p>
        </div>
      </div>
      <div
        data-subwidget-id="b1b22851-6c37-4871-b2c2-d420eebf20e9"
        data-widget-id="5bbb0021-7c30-4965-9fb8-d35474f7c9d1"
        class="widget widget-Text widget-Text---5bbb0021-7c30-4965-9fb8-d35474f7c9d1 widget-Text---view-text widget-Text---preset-default"
      >
        <p>
          Diese Einwilligung können Sie jederzeit widerrufen, z. B. online über Ihr
          Kundenkonto auf
          <span style="text-decoration: underline"
            ><a href="https://www.payback.de/info/mein-payback/einwilligungen"
              >PAYBACK.de</a
            ></span
          >, telefonisch im PAYBACK Service Center oder schriftlich an PAYBACK GmbH,
          Postfach 23 21 03, 85330 München. expert wird von der PAYBACK GmbH über Ihren
          Widerruf informiert. Ein Widerruf berührt nicht die Rechtmäßigkeit der bis zum
          Widerruf aufgrund der Einwilligung erfolgten Datenverarbeitung.
        </p>
        <p>
          Sie können auch ohne die Einwilligung die PAYBACK und expert Services nutzen.
          Haben Sie Ihre Einwilligung nicht erklärt oder widerrufen, findet die in der
          Einwilligung beschriebene Datenverarbeitung nicht statt. Ihre Daten werden dabei
          wie oben in Abschnitt C beschrieben verarbeitet. Andere Einwilligungserklärungen
          (z.B. das
          <span style="text-decoration: underline"
            ><a href="https://www.payback.de/info/om-einverstaendnis"
              >Online Marketing-Einverständnis</a
            ></span
          >), die Sie ggf. gegenüber der PAYBACK GmbH oder Partnerunternehmen abgegeben
          habe, bleiben ebenfalls unberührt. Solche anderen Einwilligungserklärungen
          gelten also auch dann weiter, wenn Sie die hier behandelte Einwilligung nicht
          abgeben oder widerrufen. Dies gilt beispielsweise, wenn Sie eine
          <span style="text-decoration: underline"
            ><a href="https://www.payback.de/info/ewe23"
              >Einwilligung in personalisierte Werbung im PAYBACK Programm</a
            ></span
          >
          erteilt haben. Die von einer solchen anderen Einwilligung erlaubte
          Datenverarbeitung findet also auch dann weiterhin statt, wenn Sie die hier
          behandelte Einwilligung nicht abgeben oder widerrufen.
        </p>
        <p><em>D.2 Zusätzliche Hinweise zu der Einwilligung</em></p>
        <p>
          Mit Ausnahme der „expert Werbedaten“ rechtfertigt diese Einwilligung nicht das
          Sammeln zusätzlicher Daten über Sie, sondern lediglich die (Weiter-)Verarbeitung
          von Daten, die ohnehin auf der Basis einer anderen Rechtsgrundlage erhoben
          werden bzw. wurden (z.B. auf Basis einer anderen Einwilligung oder zum Zwecke
          der Vertragserfüllung). Dies gilt insbesondere für die Erhebung der in der
          Einwilligung definierten „Kommunikationsdaten“.
        </p>
        <p>
          „PAYBACK Services“ im Sinne dieser Einwilligung sind alle Funktionen und
          Angebote, die ausschließlich Teilnehmer des PAYBACK Programms in Anspruch nehmen
          können, z.B. der PAYBACK Prämienshop, die PAYBACK App oder der PAYBACK
          Newsletter per E-Mail oder SMS.
        </p>
        <p>
          Die bei den PAYBACK Profildaten genannte „Altersgruppe“ meint jeweils
          mehrjährige Zeitabschnitte (wie z.B. 20-29 Jahre, 30-39 Jahre, etc.), in die ich
          zum jeweiligen Zeitpunkt falle.
        </p>
        <p>
          Der bei den Karteneinsatzdaten und bei den Einkaufsdaten ohne PAYBACK genannte
          „Ort“ des Vorgangs meint bei Einkäufen im Ladengeschäft den Standort des
          Geschäfts und ggf. auch der Kasse innerhalb des Geschäfts. In elektronischen
          Medien meint der „Ort“ das jeweilige elektronische Medium (also z.B. auf welcher
          Internet-Seite oder in welcher App).
        </p>
        <p>
          Die bei den Karteneinsatzdaten genannten „PAYBACK Aktionen“ bezeichnet alle
          zeitlich befristeten Aktionen, bei denen bestimmten PAYBACK Kunden (oder auch
          allen) ein besonderer Vorteil versprochen wird, wenn sie eine bestimmte Handlung
          vornehmen (z.B. ein bestimmtes Produkt erwerben und dabei ihre PAYBACK Nummer
          einsetzen). Die Einzelheiten ergeben sich aus der Werbung für die jeweilige
          Aktion.
        </p>
        <p>
          Die bei den Karteneinsatzdaten genannte Information „wie wurde bezahlt“
          bedeutet, welche der folgenden Kategorien auf die jeweilige Zahlung zutrifft:
          Barzahlung, Kartenzahlung, Zahlung mit PAYBACK PAY und dabei verwendeter
          Zahlungsdienst, sonstige Zahlungsweise.
        </p>
        <p>
          "Daten aus Zufriedenheitsbefragungen“ meint die von Ihnen gegebenen Antworten,
          wenn expert Sie zu Ihrer Zufriedenheit mit bestimmten Waren oder
          Dienstleistungen befragt (z.B. nachdem Sie diese erworben haben).
        </p>
        <p>
          Bei der Auswahl von Werbung und den werblichen Marktanalysen durch expert kommen
          unter anderem Techniken zur mathematischen Modellierung von Kundengruppen zum
          Einsatz, außerdem „maschinelles Lernen“ und „Data Mining“. Das bedeutet, dass
          große Datenmengen aus unterschiedlichen Quellen verarbeitet werden, um
          Strukturen und Muster zu entdecken, Modelle zu entwickeln, Vorhersagen zu
          treffen, Erkenntnisse zu gewinnen und sie für die in der Einwilligung
          beschriebenen Zwecke anzuwenden.
        </p>
        <p>
          Die Einwilligung bleibt nur wirksam, solange expert und die PAYBACK GmbH die
          Einwilligung nutzen und solange Sie am PAYBACK Programm teilnehmen. Sollten Sie
          über 5 Jahre lang keine Punkte mehr sammeln oder einlösen, werden expert und die
          PAYBACK GmbH Ihre Einwilligung nicht mehr nutzen.
        </p>
        <p><em>D.3 Zusätzliche nicht-werbliche Marktanalysen</em></p>
        <p>
          Wenn Sie Ihre
          <span style="text-decoration: underline"
            ><a href="#Einwilligung">Einwilligung</a></span
          >
          in personalisierte Werbung erteilen und daher mit werblicher Nutzung Ihrer Daten
          einverstanden sind, verarbeitet expert die von dieser Einwilligung umfassten
          Daten auch für solche Marktanalysen, die keine werblichen Zwecke verfolgen.
          Damit ist die die Erstellung von anonymen Statistiken gemeint, die expert für
          nicht-werbliche Zwecke nutzen kann (z.B. um zu entscheiden, an welchen
          Standorten neue Läden eröffnet, welche Waren in einem Laden angeboten oder
          welche neuen Produkte entwickelt werden sollten).
        </p>
        <p><em>D.4 Rechtsgrundlagen</em></p>
        <p>
          Rechtsgrundlage für die in Abschnitt D.1 und D.2 beschriebene Datenverarbeitung
          ist Art. 6 Abs. 1 a) DSGVO in Verbindung mit Ihrer Einwilligung. Rechtsgrundlage
          für die in Abschnitt D.3 beschriebene Datenverarbeitung ist Art. 6 Abs. 1 f)
          DSGVO (Interessenabwägung, basierend auf dem Interesse von expert, seine Waren
          und Dienstleistungen möglichst gut an die Interessen und Bedürfnisse der PAYBACK
          Kunden anzupassen)<br />&nbsp;
        </p>
      </div>
      <div
        data-subwidget-id="70a7fc9a-1e3f-45af-8a14-69195425da42"
        data-widget-id="14d0ec82-501d-443e-b7de-8f5142154687"
        class="widget widget-Text widget-Text---14d0ec82-501d-443e-b7de-8f5142154687 widget-Text---view-text widget-Text---preset-default"
      >
        <p><strong>E. Speicherdauer</strong></p>
        <p>
          Die bei Ihrer Nutzung der PAYBACK Services bei expert anfallenden Daten
          speichert die PAYBACK GmbH entsprechend den allgemeinen Hinweisen zum
          Datenschutz beim PAYBACK Programm. Diese finden Sie
          <span style="text-decoration: underline"
            ><a href="https://www.payback.de/info/hinweise-datenschutz">hier</a></span
          >. Soweit PAYBACK expert eCoupons und Angebote bei sich anzeigt, speichert
          PAYBACK Informationen zu Ort und Zeitpunkt der Anzeige und ggf. Aktivierung der
          jeweiligen eCoupons und Angebote für höchstens 3 Jahre.
        </p>
        <p>
          Wenn Sie die Einwilligung in personalisierte Werbung durch PAYBACK und expert
          erteilt haben, speichern die PAYBACK GmbH und expert die auf Grundlage dieser
          Einwilligung übermittelten Daten bis zum Widerruf der Einwilligung. Die
          übermittelten Daten zur Servicenutzung und expert Werbedaten werden auch davor
          spätestens nach 3 Jahren gelöscht.<br />&nbsp;
        </p>
      </div>
      <div
        data-subwidget-id="05af2c41-7e50-4186-856a-8b457be82268"
        data-widget-id="53daa562-9545-44a1-af97-f7d3e23479dc"
        class="widget widget-Text widget-Text---53daa562-9545-44a1-af97-f7d3e23479dc widget-Text---view-text widget-Text---preset-default pt-5 border-xs-top-2 border-xs-right-0 border-xs-bottom-0 border-xs-left-0 border-xs-solid border-xs-black"
      >
        <p>
          <strong>IHR WIDERSPRUCHSRECHT:</strong><br />Soweit expert Ihre Daten auf Basis
          der Interessenabwägung verarbeitet, steht Ihnen bei Vorliegen der gesetzlichen
          Voraussetzungen ein Widerspruchsrecht zu.
        </p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
defineProps({
  isPage: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang="postcss" scoped>
.c-content-static-data-security {
  @apply flex flex-col gap-4 p-4;
  h1,
  h2.grandline {
    @apply text-lg font-normal;
  }
  h2 {
    @apply text-base font-bold;
  }
  h3 {
    @apply text-sm font-bold;
  }
  p {
    @apply text-sm;
  }
  ul {
    @apply text-sm;
  }
  section {
    @apply flex flex-col gap-4 pb-4;
  }
  a {
    @apply text-primary;
  }
}
</style>
